/***
*
* Code from js_eventos.js
*
***/


// TAG(Luis): 09022025
// oneditoraction: control de la pulsacion de la tecla enter, para oporar en ese momento
//  - objSelf: objeto en el que estamos..
//  - hideKeyboard: para ordenar ocultar teclado(true) o ignorar en caso contrario
//  - nextProp: si pasamos el foco a otra propiedad, la indicamos aqui
//  - executeNode: nodo que queremos ejecutar tras la pulsacion de enter (anulado no funciona bien. dos busquedas pero parece que el valor no esta asentado en el prop)
function oneditoractionnext(objSelf,hideKeyboard,nextProp) {
    try{
        if (hideKeyboard){
            ui.hideSoftwareKeyboard ();
        }
        if (nextProp.toString().length>0){
            var ventana=null;
            ventana=ui.getView(objSelf);
            if (ventana){
                ventana.setFocus(nextProp);
            }
        }
        /*if (executeNode.toString().length>0){
            objSelf.executeNode(executeNode);
        }*/
    }catch (e) {
        let sterror=e.message;
        writelogExceptionJSv2(" oneditoraction. ERROR: "+sterror,"eventos.js");
    }
}

function onBackOption(objSelf) {
    appData.failWithMessage(-11888,"##EXIT##");
}/***
*
* Code from js_const.js
*
***/


var jsconst_devenvsetts = {
    cceRegionid: 16
};

var jsconst_prodenvsetts = {
    cceRegionid: 44
};

var jsconst_oper = { 
    // para saber si estamos en debug y cambiar ciertos controles
    prod: true,
    // nivel de log
    logLevel:1,    
    isIBDServer: true,
    forceNotifyAvailable:true
};   

var jsconst_Broker = {
    urlPrincipal:"",
    urlInterna: ""
};

var jsconst_LDAP = {
    // fluo de control de validacion con LDAP que estamos empleando:  
    // 0- login local, 1- llamada a LDAP saliendo a internet (usar en movil),  2- llamada a API interna por la red de IBD (solo para servidor)
    
    modeLDAPControl: 2,
    
    // nombre del servicio al que llamamos en la api generica de validacion, por ahora la del broker de egired
    url: (jsconst_oper.prod)?"LDAP":"LDAP10",
    // nombe del fichero local para credenciales temporales
    // LAST_USER_FILE: appData.getAppPath() + "/last_user.json",
    // valor tamporal del token en el flujo de acceso
    tmpToken: null,
    // ACTIVACION DEL CONTROL DE ATAQUES DE FUERZA BRUTA
    Fail_Control: true,
    //Número de intentos fallidos permitidos antes de bloquear el acceso (valor: 2)
    Fail_Attempts: 4,
    //Tiempo, en minutos, que permanecerá bloqueado el acceso tras alcanzar el límite de intentos (valor: 0.5)
    Fail_Time: 0.5,
    //Factor incremental para el tiempo de bloqueo tras cada intento fallido adicional (valor: 2).
    Fail_Interval: 2
};

// var APP_NAME = (jsconst_oper)?"PLADEMER":"PLADEMER INT";
var APP_NAME;

// 20250115 LM: se incluye una funcion por bug de que no se incorporan los js si no incluten alguna funcion. 
function isProd() {
    return jsconst_oper.prod;
}

function isIBDServer() {
    return jsconst_oper.isIBDServer;
}

function getLDAPControl() {
    return jsconst_LDAP.modeLDAPControl;
}

function getDevEnvSetts() {
    return jsconst_devenvsetts;
}

function getProdEnvSetts() {
    return jsconst_prodenvsetts;
}/***
*
* Code from exportData.js
*
***/


/*
    Funciones para exportación de datos de la aplicación
*/

/*
    Esta función se encarga de exportar los datos del content en cuestión a un fichero con la extensión 
    especificada.
    @objSelf: objeto de la vista actual.
    @contentData: nombre del content donde están los datos a exportar.
    @extension: extensión del fichero en que se quiere exportar los datos.
    @fileName: nombre del fichero en que se exportarán los datos.
    @templateName: nombre del fichero en que se usará como plantilla. Esta plantilla debe estar en la raíz de
                   ficheros del servidor en la carpeta /templates.
*/
async function exportDataToFile(objSelf, contentData, extension, fileName, templateName) {
    let contentName = (contentData == "UsuariosListForExportData") ? "Usuarios" : 
        (contentData == "ContactosListForExportData") ? "Contactos" : contentData;
    try {
        let content = await objSelf.getContents(contentData);
        content.unlock();
        let filterCond = getFilterConditionsFor(objSelf, contentName);
        // Aplicar filtros
        content.setLinkFilter(filterCond);
        content.clear();
        await content.loadAll();
        content.lock();
        let contentView = ui.getView(objSelf);
       
        if (!isNothing(contentView)) {
            contentView.export(content, extension, fileName, templateName);
        } else {
            await userMsgBox("No ha sido posible exportar los datos, por favor, inténtelo de nuevo.", "AVISO", 0, "#E04C41"); 
        }
    } catch(e) {
        appData.writeConsoleString("Error in exportDataToFile");
        appData.writeConsoleString(e);   
        await userMsgBox("No ha sido posible exportar los datos, por favor, inténtelo de nuevo.", "AVISO", 0, "#E04C41");        
    }
    
}

function getFilterConditionsFor(objSelf, contentName) {
    let filterCond = "";
    
    switch (contentName) {
        case 'Usuarios':
            if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                filterCond += "UPPER(u.NOMBRE) like '%" + objSelf.MAP_DESCRIPFILTER.toUpperCase() + "%'"; 
            }
            if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                if (filterCond.length > 0) {
                    filterCond += " AND ";
                }
                filterCond += "UPPER(u.LOGIN) like '%" + objSelf.MAP_CODFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_EMAILFILTER) && objSelf.MAP_EMAILFILTER != '') {
                if (filterCond.length > 0) {
                    filterCond += " AND ";
                }
                filterCond += "UPPER(u.EMAIL) like '%" + objSelf.MAP_EMAILFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_PHONEFILTER) && objSelf.MAP_PHONEFILTER != '') {
                if (filterCond.length > 0) {
                    filterCond += " AND ";
                }
                filterCond += "UPPER(u.TELEFONO) like '%" + objSelf.MAP_PHONEFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                if (filterCond.length > 0) {
                    filterCond += " AND ";
                }
                filterCond += "u.BAJA=" + objSelf.MAP_BAJAFILTER;
            }
            break;
        case 'Contactos':
            if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                filterCond += "UPPER(c.NOMBRE) like '%" + objSelf.MAP_DESCRIPFILTER.toUpperCase() + "%'"; 
            }
            if (!isNothing(objSelf.MAP_INFOFILTER) && objSelf.MAP_INFOFILTER != '') {
                if (filterMacro.length > 0) {
                    filterCond += " AND ";
                }
                filterCond += "UPPER(c.DESCRIPCION) like '%" + objSelf.MAP_INFOFILTER.toUpperCase() + "%'"; 
            }
            if (!isNothing(objSelf.MAP_EMAILFILTER) && objSelf.MAP_EMAILFILTER != '') {
                if (filterCond.length > 0) {
                    filterCond += " AND ";
                }
                filterCond += "UPPER(c.EMAIL) like '%" + objSelf.MAP_EMAILFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_PHONEFILTER) && objSelf.MAP_PHONEFILTER != '') {
                if (filterCond.length > 0) {
                    filterCond += " AND ";
                }
                filterCond += "UPPER(c.TELEFONO) like '%" + objSelf.MAP_PHONEFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_REGFILTER) && objSelf.MAP_REGFILTER != '') {
                if (filterCond.length > 0) {
                    filterCond += " AND ";
                }
                filterCond += " (r.NOMBRE like '%" + objSelf.MAP_REGFILTER.toUpperCase() + "%' OR c.ESCONTACTOGLOBAL=1)";
            }  
            if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                if (filterCond.length > 0) {
                    filterCond += " AND ";
                }
                filterCond += "c.BAJA=" + objSelf.MAP_BAJAFILTER;
            }
            break;
        
        default:
            // No se hace nada
    }
    
    return filterCond;
}

/*
    Esta función se encarga de validar los datos del del registro teniendo en cuenta 
    el tipo de dato y los requerimientos de sus campos.
    @obj: referencia al registro.
    @collName: nombre de la colección a la que pertenece el registro.
*/
function validateDataIn (obj, collName) {
    switch(collName) {
        case 'Contacto':
            
            // TODO: Validar teléfono.
                
            // Comprueba si el correo es válido.
            obj.MAP_INVALIDEMAIL = ((obj.EMAIL.length > 0 && isValidEmail(obj.EMAIL)) ? "0" : "1") + obj.MAP_INVALIDEMAIL[1];
                
            // Comprueba validez de códigos de región, zona y unidad.
            obj.MAP_INVALIDREGION = (isNothing(obj.MAP_REGION) ? "1" : "0") + obj.MAP_INVALIDREGION[1];
            obj.MAP_INVALIDZONE = (isNothing(obj.MAP_ZONA) ? "1" : "0") + obj.MAP_INVALIDZONE [1];
            obj.MAP_INVALIDUNIT = (isNothing(obj.MAP_UNIDAD) ? "1" : "0") + obj.MAP_INVALIDUNIT[1];
                
            // TODO: Validar que se corresponden los datos de región, zona y unidad.
                
            if (isNothing(obj.ESCONTACTOGLOBAL) || obj.ESCONTACTOGLOBAL != 1) {
                obj.ESCONTACTOGLOBAL = 0;
            }
                
            if(isNothing(obj.BAJA || obj.BAJA != 1)) {
                obj.BAJA = 0;
            }
            break;
    }
}

/*
    Esta función se encarga de comparar los valores de los campos de dos registros y dejar indicado si difieren o no.
    @importedObj: referencia a objeto que se quiere importar.
    @saveObj: referencia a objeto guardado en el sistema.
    @collName: nombre de la colección a la que pertenecen los registros.
*/
function compareDataFrom(importedObj, saveObj, collName) {
    switch(collName) {
        case 'Contacto':
            importedObj.MAP_INVALIDEMAIL = importedObj.MAP_INVALIDEMAIL[0] + ((saveObj.EMAIL === importedObj.EMAIL) ? "0" : "1");
            importedObj.MAP_INVALIDREGION = importedObj.MAP_INVALIDREGION[0] + ((saveObj.REGIONCODIGO === importedObj.REGIONCODIGO) ? "0" : "1");
            importedObj.MAP_INVALIDZONE = importedObj.MAP_INVALIDZONE[0] + ((saveObj.ZONACODIGO === importedObj.ZONACODIGO) ? "0" : "1");
            importedObj.MAP_INVALIDUNIT = importedObj.MAP_INVALIDUNIT[0] + ((saveObj.UNIDADCODIGO === importedObj.UNIDADCODIGO) ? "0" : "1");
            importedObj.MAP_INVALIDECG = importedObj.MAP_INVALIDECG[0] + ((saveObj.ESCONTACTOGLOBAL === importedObj.ESCONTACTOGLOBAL) ? "0" : "1");
            importedObj.MAP_INVALIDBAJA = importedObj.MAP_INVALIDBAJA[0] + ((saveObj.BAJA === importedObj.BAJA) ? "0" : "1");
            break;
    }
}

function getSearchConditionFor(collName, collObj) {
    switch(collName) {
        case 'Contacto':
            return "c.ID = " + collObj.ID;
            break;
    }
}

/*
    Esta función se encarga de validar los datos en el content especificado.
    @objSelf: referencia a la vista donde se encuentra el content.
    @content: referencia al content.
    @contentName: nombre del content en la vista.
*/
async function validateImportedData(objSelf, content, contentName, collName) {
    var obj, collObj;
    for(var i = 0; i < content.count(); i++) {
        obj = await content.getItem(i);
        obj.MAP_INVALIDEMAIL = "00";
        obj.MAP_INVALIDREGION = "00";
        obj.MAP_INVALIDZONE = "00";
        obj.MAP_INVALIDUNIT = "00";
        obj.MAP_INVALIDECG = "10";
        obj.MAP_INVALIDBAJA = "10";
        
        if (!isNothing(obj.ID)) {
            // ID especificado
            collObj = await (await appData.getCollection(collName)).findObject(getSearchConditionFor(collName, obj));
            
            if (!isNothing(collObj)) {
                // Existe registro con mismo ID. Comparamos datos.
                compareDataFrom(obj, collObj, collName);
            } else {
                // TODO: Mostrar mensaje de que se ha especificado ID pero no existe elemento con ese ID. 
            }
        } else {
            // ID NO especificado. Posible nuevo registro.
            
            // TODO: Buscar si existe elemento con los mismos valores para campos claves (No ID).
            
        }
        
        // Validar datos 
        validateDataIn(obj, collName); 
        
        // Especificar mensajes de error.
        if (obj.MAP_INVALIDEMAIL[0] === '1') {
            // Correo inválido.
            obj.EMAIL_ERROR = "Correo inválido";
        }
    }
}

async function importDataFromFile(objSelf, contentName, collName) {
    var jsParams = {
        targetProperty : "MAP_FILENAME",
        fileTypes      : "csv,xlsx"
    };
    
    var result = await ui.pickFile(jsParams);
    
    /* 
        TODO: El content donde se deben poner los datos es: ContactosListForExportData y viene 
        especificada en contentName.
    */
     try {
        let content = await objSelf.getContents(contentName);
        content.unlock();
        // Limpiar filtros
        content.setLinkFilter("");
        content.clear();
        
        // Cargando datos desde fichero.
        content.loadFromXLSX(result);
        
        // Validación de datos.
        await validateImportedData(objSelf, content, contentName, collName);
        
        content.lock();
        objSelf.MAP_SHOWDATATOIMPORT = 1;
        ui.refresh('FRM_CURRENTDATA,FRM_CURRENTDATA1');
    } catch(e) {
        appData.writeConsoleString("Error in importDataFromCSVFile");
        appData.writeConsoleString(e);   
        await userMsgBox("No ha sido posible lanzar la importación de datos, por favor, inténtelo de nuevo.", "AVISO", 0, "#E04C41");        
    }
}

function saveImportedData(objSelf, contentName, collName) {
    
}
/***
*
* Code from maps.js
*
***/


/*  Funciones relativas a funcionalidades con Mapas  */

async function cargarDatosMapa_ANTERIOR(objSelf) {
  
    ui.refresh("MAP_MAPASITUACIONES");
    if (jsconst_oper.noMapa){
        ui.showToast("Configurado no cargar mapa");
        return;
    }
    
    var cadena,filtro,objcnt;
    var sec,color,i,j,gps,relleno;
    var stSectoresCargados="";
    var zonacar="";
    var regioncar="";
    var coll=await objSelf.getContents("MapaPintarScript");
    var cnt=await objSelf.getContents("SituacionesContent");
    filtro="";
    for (var j = 0; j <=cnt.getCount()-1; j++) {
        objcnt=await cnt.getItem(j);
        if (objcnt.MAP_SEL==1) {
            if (filtro.length==0) {
                filtro="'" + objcnt.MAP_CODIGO + "'";    
            } else {
                filtro=filtro + ",'" + objcnt.MAP_CODIGO + "'";    
            }
        }
    }
    coll.clear();
    coll.unlock();
    coll.setMacro("##MACRO##",filtro);
    await coll.loadAll();
    coll.lock();
    if (filtro.length>0) {
        for (var i = 0; i <=coll.getCount()-1; i++) {
            if ((await coll.getItem(i)).CODIGOTIPO.toUpperCase() == 'ALERTA' )  {
                color="#FF9500";
                relleno="#70FF9500";
            } else {
                color="#FF5A00";
                relleno="#70FF5A00";
            }
            if (stSectoresCargados.indexOf((await coll.getItem(i)).MAP_VALOR)<0){
        		if (sec != (await coll.getItem(i)).MAP_VALOR) {
        		    stSectoresCargados=addString(stSectoresCargados,(await coll.getItem(i)).MAP_VALOR,",");
        		    
        		    cadena=(await coll.getItem(i)).MAP_VALOR + ".geojson";
        		    addGeoJson(objSelf,'MAP_MAPASITUACIONES',i,cadena,color,relleno);
        		    sec=(await coll.getItem(i)).MAP_VALOR;
        		} 
            }
    	} 
    }
    //Ir al zoom indicado.
    let mapControl = getControl(objSelf,'MAP_MAPASITUACIONES');
    if (!mapControl) {
        return;
    }
	mapControl.zoomToBounds(["43.12892531691697, 2.78257539277755","37.057715484771734, -8.927675447364429"]);
	
}

async function cargarDatosMapa(objSelf) {
  
    try {
        ui.refresh("MAP_MAPASITUACIONES");
        if (jsconst_oper.noMapa){
            ui.showToast("Configurado no cargar mapa");
            return;
        }   
        
        var cadena,filtro,objcnt;
        var sec,color,i,j,gps,relleno, colorzona, colorregion, rellenoregion;
        var stSectoresCargados="";
        var zonacar="";
        var regioncar="";
        var coll=await objSelf.getContents("MapaPintarScript");
        var cnt=await objSelf.getContents("SituacionesContent");
        filtro="";
        for (var j = 0; j <=cnt.getCount()-1; j++) {
            objcnt=await cnt.getItem(j);
            if (objcnt.MAP_SEL==1) {
                if (filtro.length==0) {
                    filtro="'" + objcnt.MAP_CODIGO + "'";    
                } else {
                    filtro=filtro + ",'" + objcnt.MAP_CODIGO + "'";    
                }
            }
        }
        coll.clear();
        coll.unlock();
        coll.setMacro("##MACRO##",filtro);
        await coll.loadAll();
        coll.lock();
        if (filtro.length>0) {
            for (var i = 0; i <=coll.getCount()-1; i++) {
                if ((await coll.getItem(i)).CODIGOTIPO.toUpperCase() == 'ALERTA' )  {
                    color="#00000000";
                    relleno="#80FF9500";
                    colorregion="#ffdd00";
                    rellenoregion="#33ffdd00";
                } else {
                    color="#00000000"; 
                    relleno="#80FF5A00";
                    colorregion="#ffdd00";
                    rellenoregion="#33ffdd00";
                }
                
                if (regioncar.indexOf((await coll.getItem(i)).MAP_REGION)<0){
            // 		if (sec != coll.getItem(i).MAP_REGION) {
            		    regioncar=addString(regioncar,(await coll.getItem(i)).MAP_REGION,",");
            		    cadena=(await coll.getItem(i)).MAP_REGION + ".geojson";
            		    addGeoJson(objSelf,'MAP_MAPASITUACIONES',i,cadena,colorregion,rellenoregion);
            		  //  sec=coll.getItem(i).MAP_REGION;
            // 		} 
                }
                if (stSectoresCargados.indexOf((await coll.getItem(i)).MAP_VALOR)<0){
            // 		if (sec != coll.getItem(i).MAP_VALOR) {
            		    stSectoresCargados=addString(stSectoresCargados,(await coll.getItem(i)).MAP_VALOR,",");
            		    cadena=(await coll.getItem(i)).MAP_VALOR + ".geojson";
            		    addGeoJson(objSelf,'MAP_MAPASITUACIONES',i,cadena,color,relleno);
            		  //  sec=coll.getItem(i).MAP_VALOR;
            // 		} 
                }
        	} 
        }
    } catch(e) {
        
    }
    try {
        //Ir al zoom indicado.
        let mapControl = getControl(objSelf,'MAP_MAPASITUACIONES');
        if (!mapControl) {
            return;
        }
    	mapControl.zoomToBounds(["43.12892531691697, 2.78257539277755","37.057715484771734, -8.927675447364429"]);
    } catch (e) {
        
    }
}

function addGeoJson(objSelf,sMapControl,indice,areapintar,trazo,relleno) {
    try {
        let mapControl = getControl(objSelf,sMapControl);
        if (!mapControl) {
            return;
        }
        mapControl.addGeoJson({
            id      : indice.toString(),
            // Este acepta strings json y objetos javascript en formato GeoJson
            //data    : new FileManager().readFile("geojson_sample_6.json"),
            // Este acepta ficheros con texto JSON en formato GeoJson
            dataFile: areapintar,
            strokeColor: trazo,
            fillColor: relleno
        });
    } catch(e) {
        
    }
}


/*  Esta función se encarga de pintar el polígono descrito por los pares de coordenadas 
    geográficas recibidas en el mapa indicado.  */
function drawArea(objSelf, sMapControl, areaID, fillColor, color, areaPolygon) {
    let mapControl = getControl(objSelf, sMapControl);
    if (!mapControl) {
        return;
    }
    
    let params = {
        //id       : "DCF5D0",
        //fillcolor: "#FF9500",
        //color    : "#FF9500",
        id       : areaID,
        fillcolor: fillColor,
        color    : color,
        width    : 1,
        pattern  : "normal",
        onClick  : function() {
            ui.showToast("Click en el área");
        },
        data     : areaPolygon
        //data     : ["43.3712591, -8.4188010", "43.2603479, -2.9334110", "38.7166700, -9.1333300"]
    };
    mapControl.drawArea(params);
}

function setDefaultMapProps(objSelf, sMapControl) {
    
    return;
    
    // let mapControl = getControl(objSelf, sMapControl);
    // if (!mapControl) {
    //     return;
    // }
    // //mapControl.restrictMapToBounds(["27.7567, -17.93394", "43.68333, 4.2899"]);
    // //mapControl.zoomTo(38.88767, -7.00031);
    // mapControl.zoomToBounds(["35.946850084, -9.39288367353", "43.7483377142, 3.03948408368"]);
}/***
*
* Code from vbscriptsupport.js
*
***/


function VBScriptSupport() {
	this.cstr = function(value) {
		return safeToString(value);
	};
 
	this.now = function() {
		return new Date();
	};
 
	this.len = function(str) {
		return safeToString(str).length;
	};
 
	this.cint = function(value) {
		return parseInt(value);
	};
 
	this.left = function(str, n) {
		if (n <= 0) {
			return new String();
		} else if (n > String(str).length) {
			return safeToString(str);
		} else {
			return safeToString(str).substring(0, n);
		}
	};
 
	this.replace = function(source, search, replacement) {
		source = safeToString(source);
		search = safeToString(search);
		replacement = safeToString(replacement);
		search = escapeRegularExpression(search);
		source.replace(search, replacement);
		return source;
	};
 
	this.day = function(mDate) {
		mDate = safeToDate(mDate);
		return mDate.getDate();
	};
 
	this.month = function(mDate) {
		mDate = safeToDate(mDate);
		return mDate.getMonth();
	};
 
	this.year = function(mDate) {
		mDate = safeToDate(mDate);
		return mDate.getFullYear();
	};
 
	this.right = function(str, n) {
		str = new String(str);
		if (n <= 0 || n > str.length) {
			return str;
		} else {
			var iLen = str.length;
			return str.substring(iLen, iLen - n);
		}
	};
 
	this.mid = function(str, start, len) {
		if (start < 0 || len < 0) {
			return str;
		}
		var iEnd, iLen = new String(str).length;
		if (start + len > iLen) {
			iEnd = iLen;
		} else {
			iEnd = start + len;
		}
		return new String(str).substring(start, iEnd);
	};
 
	this.inStr = function(strSearch, charSearchFor) {
		for (i = 0; i < len(strSearch); i++) {
			if (charSearchFor == mid(strSearch, i, 1)) {
				return i;
			}
		}
		return -1;
	};
 
	this.lcase = function(str) {
		if (isString(str)) {
			return str.toLowerCase();
		}
		return new String(str).toLowerCase();
	};
 
	this.ucase = function(str) {
		if (isString(str)) {
			return str.toUpperCase();
		}
		return new String(str).toUpperCase();
	};
 
	this.abs = function(value) {
		return Math.abs(value);
	};
 
	this.trim = function(str) {
		str = safeToString(str);
		return str.trim();
	};
 
	this.split = function(str, delimiter) {
		return str.split(delimiter);
	};
 
	this.dateDiff = function(sPeriod, mDate1, mDate2) {
		mDate1 = safeToDate(mDate1);
		mDate2 = safeToDate(mDate2);
		nDiff = Math.abs(mDate1.getTime() - mDate2.getTime());
		switch(sPeriod) {
			case "h":
				return nDiff / 3600000;
			case "n":
				return nDiff / 60000;
			default:
				throw new Error("dateDiff(): Unknown date period " + sPeriod);
		}
	};
 
	this.dateAdd = function(sPeriod, nNumber, mDate) {
		mDate = safeToDate(mDate);
		switch(sPeriod) {
			case "yyyy":
				//Year
				mDate.setYear(mDate.getYear() + nNumber);
				return mDate;
			case "q":
				//Quarter
				return mDate;
			case "m":
				//Month
				mDate.setMonth(mDate.getMonth() + nNumber);
				return mDate;
			case "y":
				//Day of year
				return mDate;
			case "d":
				//Day
				mDate.setDate(mDate.getDate() + nNumber);
				return mDate;
			case "w":
				//Weekday
				return mDate;
			case "ww":
				//Week of year
				return mDate;
			case "h":
				//Hour
				mDate.setHours(mDate.getHours() + nNumber);
				return mDate;
			case "n":
				//Minute
				mDate.setMinutes(mDate.getMinutes() + nNumber);
				return mDate;
			case "s":
				//Second
				mDate.setSeconds(mDate.getSeconds() + nNumber);
				return mDate;
			default:
				throw new Error("dateAdd(): Unknown date period " + sPeriod);
		}
	};
	
	this.dateDiffSign = function(sPeriod, mDateTo, mDateFrom) {
		mDateTo = safeToDate(mDateTo);
		mDateFrom = safeToDate(mDateFrom);
		let nDiff = mDateTo.getTime() - mDateFrom.getTime();
		//F20210308 LM: para controlar si es NaN, usamos dateDiffSignV2
		switch(sPeriod) {
		    case "d":
				return nDiff / 86400000;
			case "h":
				return nDiff / 3600000;
			case "n":
				return nDiff / 60000;
			case "s":
				return nDiff / 1000;	
			default:
				throw new Error("dateDiffSign(): Unknown date period " + sPeriod);
		}
	};
}
 
var vbSupport = new VBScriptSupport();

 
function cambiarAtributoProp(obj,prop,att,value) {
    obj.setFieldPropertyValue(prop,att,value);
    var view=ui.getView(obj);
    if (view)
        view.refresh(prop);   
}    

function isNothing(obj) {
	if (obj === null) {
		return true;
	}
	if (obj == "undefined") {
		return true;
	}
	if (obj == undefined) {
	    return true;
	}
	return false;
}

function isNothingDate(obj) {
	if (obj === null) {
		return true;
	}
	if (obj == "undefined") {
		return true;
	}
	if (obj == undefined) {
		return true;
	}
	if (obj==='') {
		return true;
	}
	return false;
}
 
function isSomething(obj) {
	if (obj === null) {
		return false;
	}
	if (obj == "undefined") {
		return false;
	}
	return true;
}
 
function getClassName(obj) {
	if(isNothing(obj)) {
		return null;
	}
	return obj.constructor.name;
}
 
function isFloatNumber(n) {
	return n === +n && n !== (n | 0);
}
 
function isIntegerNumber(n) {
	return n === +n && n === (n | 0);
}
 
function isNumber(obj) {
	if (isNothing(obj)) {
		return false;
	}
	return !isNaN(parseFloat(obj)) && isFinite(obj);
}
 
function isString(obj) {
	return typeof obj === 'string' || obj instanceof String;
}
 
function isEmptyString(obj) {
	if(!isString(obj)) {
		return false;
	}
	return(!obj || 0 === obj.length);
}
 
function isDate(obj) {
	if (obj instanceof Date) {
		return true;
	}
	return false;
}
 
function safeToString(value) {
	if(isNothing(value)) {
		return new String();
	}
	return new String(value);
}
 
function safeToDate(mDate) {
	if(isDate(mDate)) {
		return mDate;
	}
	return new Date(replaceAll(safeToString(mDate), '-', '/'));
}
 
function escapeRegularExpression(str) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}
 
function replaceAll(sSource, sSearch, sReplacement) {
	sSearch = escapeRegularExpression(sSearch);
	return sSource.split(sSearch).join(sReplacement);
}

function safeToInt(value) {
	if(isNothing(value)) {
		return 0;
	}
	if (isIntegerNumber(value))
	    return value;
	try {
	    return parseInt(value);
	} catch(e) {
	    return 0;
	}
}

function safeCompareInt(value1,value2){
    return safeToInt(value1)===safeToInt(value2);
}/***
*
* Code from funciones.js
*
***/


var ObjMenuPadre = "";

// TAG(Luis): 09022025
//Lo puse aqui de momento para que haga bien el await-async
async function userMsgBox (msg, title, stType, stTitleColor){
    try{
    	//if instr(msg,"delete")>1 and instr(msg,"report")>1 and stType=1 then stType=3
    	var mColeccionMessageBox = await appData.getCollection("MsgBox");
        var mNuevoMessageBox = await mColeccionMessageBox.createObject(); 
        mColeccionMessageBox.addItem(mNuevoMessageBox);
    	mNuevoMessageBox.MAP_TITULO= title;
    	mNuevoMessageBox.MAP_TITLECOLOR= stTitleColor;
    	
    	//if (stType<100){
        mNuevoMessageBox.MAP_MENSAJE = msg;
    	mNuevoMessageBox.MAP_VISIBLE = parseInt(stType);
    	mNuevoMessageBox.MAP_VISIBLEMENSAJE2 = 0;
    	//} else{
    	//    loadMenssages(stType);
    	//    ui.refresh();
    	//}
    	//contentFiles.addItem(objFichero);
        
        
    
    	var nResult = await ui.msgBox(mNuevoMessageBox);
    	//mNuevoMessageBox = null;
    	return nResult;
    } catch (e) {
        let sterror=e.message;
    } 
}

async function onBackOptionDisponibilidadListado(objSelf, tipo) {
    
    try{
        if (jsconst_oper.forceNotifyAvailable){
            var dispoContent = await objSelf.getContents('ComiteRelacionadoEditDisponibilidad');
            var count=dispoContent.getCount();
            var idUser=user.ID;
            var i=0;
            var bExit=false;
            while (i<count  && !bExit){
            //for (var i=0; i<= niveles.getCount()-1; i++) {
                var dispoObj=await dispoContent.getItem(i);
                if ((dispoObj.IDTITULAR===idUser && dispoObj.DISP_TITULAR===0)||(dispoObj.IDSUPLENTE===idUser && dispoObj.DISP_SUPLENTE===0) ){
                    bExit=true;
                }
                i++;
            }
            if (bExit){
                let response=await userMsgBox("Debe informar la disposnibilidad en todos las posiciones.", "AVISO",0,"#e04c41");        
                return 0;            
            }
        }
        if (tipo==1) {
            user.MAP_OBJ_DISPONIBILIDAD=null;
            appData.failWithMessage(-11888,"##EXIT##");    
        } else if (tipo==2) {
            return 1;
        } else if (tipo==3) {
            return 1;
        }
    }catch (e) {
        let sterror=e.message;
        if (tipo==1) {
            user.MAP_OBJ_DISPONIBILIDAD=null;
            appData.failWithMessage(-11888,"##EXIT##");    
        } else if (tipo==2) {
            return 1;
        } else if (tipo==3) {
            return 1;
        }
    }  
}

async function setMenusData() {
    var emp = await appData.getCollection("Empresas");
    
    //20250123 LM: para cargar los menus segun sea el usuario administrador o no...
    var bAdmin = false;
    if (user.USERTYPE == 'ADMIN') {
        bAdmin = true;
    }   
    if (!bAdmin){
        emp.setVariables("menu-padre-data", [
    		{
    			"ID": 1,
    			"MAP_NOMBRE": "Inicio",
    			"MAP_COLL": "Inicio",
    			"MAP_USU": user.USERTYPE,
    			"MAP_ICONPATH": 'inicio.png'
    		},
    		{
    			"ID": 2,
    			"MAP_NOMBRE": "Organigrama",
    			"MAP_COLL": "ComitesDisponibilidad",
    			"MAP_USU": user.USERTYPE,
    			"MAP_ICONPATH": 'idelc_centralcommittee.png'
    		},
    		{
    			"ID": 3,
    			"MAP_NOMBRE": "Situaciones Planificadas",
    			"MAP_COLL": "SeguimientoPlanificada",
    			"MAP_USU": user.USERTYPE,
    			"MAP_ICONPATH": 'reloj_gris.png'
    		},
    		{
    			"ID": 7,
    			"MAP_NOMBRE": "Situaciones en Curso",
    			"MAP_COLL": "SeguimientoEnCurso",
    			"MAP_USU": user.USERTYPE,
    			"MAP_ICONPATH": 'rayo_gris.png'
    		},
    		{
    			"ID": 4,
    			"MAP_NOMBRE": "Situaciones Histórico",
    			"MAP_COLL": "HistoricoSituaciones",
    			"MAP_USU": user.USERTYPE,
    			"MAP_ICONPATH": 'idelc_recordUCI.png'
    		},
    		{
    			"ID": 5,
    			"MAP_NOMBRE": "Contactos Externos",
    			"MAP_COLL": "ContactosListado",
    			"MAP_USU": user.USERTYPE,
    			"MAP_ICONPATH": 'contactos.png'
    		},
    		{
    			"ID": 8,
    // 			"MAP_NOMBRE_X": "MO Planes Emergencias",
    			"MAP_NOMBRE": "Repositorio",
    			"MAP_COLL": "RepositorioListado",
    			"MAP_USU": user.USERTYPE,
    			"MAP_ICONPATH": 'repositorio.png'
    		}
    	]); 
    }
      
    else {
        // Para USERTYPE='ADMIN'
        emp.setVariables("menu-padre-data", [
    		{
    			"ID": 1,
    			"MAP_NOMBRE": "Inicio",
    			"MAP_COLL": "Inicio",
    			"MAP_USU": user.USERTYPE,
    			"MAP_ICONPATH": 'inicio.png'
    		},
    		{
    			"ID": 2,
    			"MAP_NOMBRE": "Organigrama",
    			"MAP_COLL": "ComitesDisponibilidad",
    			"MAP_USU": user.USERTYPE,
    			"MAP_ICONPATH": 'idelc_centralcommittee.png'
    		},
    		{
    			"ID": 3,
    			"MAP_NOMBRE": "Situaciones Planificadas",
    			"MAP_COLL": "SeguimientoPlanificada",
    			"MAP_USU": user.USERTYPE,
    			"MAP_ICONPATH": 'reloj_gris.png'
    		},
    		{
    			"ID": 7,
    			"MAP_NOMBRE": "Situaciones en Curso",
    			"MAP_COLL": "SeguimientoEnCurso",
    			"MAP_USU": user.USERTYPE,
    			"MAP_ICONPATH": 'rayo_gris.png'
    		},
    		{
    			"ID": 4,
    			"MAP_NOMBRE": "Situaciones Histórico",
    			"MAP_COLL": "HistoricoSituaciones",
    			"MAP_USU": user.USERTYPE,
    			"MAP_ICONPATH": 'idelc_recordUCI.png'
    		},
    		{
    			"ID": 5,
    			"MAP_NOMBRE": "Contactos Externos",
    			"MAP_COLL": "ContactosListado",
    			"MAP_USU": user.USERTYPE,
    			"MAP_ICONPATH": 'contactos.png'
    		},
    		{
    			"ID": 8,
    // 			"MAP_NOMBRE_X": "MO Planes Emergencias",
    			"MAP_NOMBRE": "Repositorio",
    			"MAP_COLL": "RepositorioListado",
    			"MAP_USU": user.USERTYPE,
    			"MAP_ICONPATH": 'repositorio.png'
    		},
    		{
    			"ID": 6,
    			"MAP_NOMBRE": "Maestros",
    			"MAP_COLL": "Maestros",
    			"MAP_USU": user.USERTYPE,
    			"MAP_ICONPATH": 'bt_Firma.png'
    		}
    	]);        
        emp.setVariables("menu-hijo-data", [
    		{
    			"ID": 1,
    			"MAP_IDPADRE": 6,
    			"MAP_NOMBRE": "Usuarios",
    			"MAP_COLL": "UsuariosListado"
    		},
    		{
    			"ID": 3,
    			"MAP_IDPADRE": 6,
    			"MAP_NOMBRE": "Organigrama Nivel 1",
    			"MAP_COLL": "ComitesListadoNivel1"
    		},
    		{
    			"ID": 4,
    			"MAP_IDPADRE": 6,
    			"MAP_NOMBRE": "Organigrama Nivel 2",
    			"MAP_COLL": "ComitesListadoNivel2"
    		},
    		{
    			"ID": 5,
    			"MAP_IDPADRE": 6,
    			"MAP_NOMBRE": "Organigrama Nivel 3",
    			"MAP_COLL": "ComitesListadoNivel3"
    		},
    		{
    			"ID": 6,
    			"MAP_IDPADRE": 6,
    			"MAP_NOMBRE": "Organigrama Nivel 4",
    			"MAP_COLL": "ComitesListadoNivel4"
    		},
    		{
    			"ID": 7,
    			"MAP_IDPADRE": 6,
    			"MAP_NOMBRE": "Regiones",
    			"MAP_COLL": "RegionesListado"
    		},
    		{
    			"ID": 8,
    			"MAP_IDPADRE": 6,
    			"MAP_NOMBRE": "Zonas Organizativas",
    			"MAP_COLL": "ZonasListado"
    		},
    		{
    			"ID": 9,
    			"MAP_IDPADRE": 6,
    			"MAP_NOMBRE": "Sectores Organizativos",
    			"MAP_COLL": "UnidadesListado"
    		},
    		{
    			"ID": 10,
    			"MAP_IDPADRE": 6,
    			"MAP_NOMBRE": "Causas",
    			"MAP_COLL": "CausasListado"
    		},
    		{
    			"ID": 11,
    			"MAP_IDPADRE": 6,
    			"MAP_NOMBRE": "Carpetas",
    			"MAP_COLL": "CarpetasListado"
    		},
    		{
    			"ID": 12,
    			"MAP_IDPADRE": 6,
    			"MAP_NOMBRE": "Lista Blanca",
    			"MAP_COLL": "ListaBlancaArchivosListado"
    		},
    		{
    			"ID": 13,
    			"MAP_IDPADRE": 6,
    			"MAP_NOMBRE": "Trazabilidad",
    			"MAP_COLL": "TrazabilidadListado"
    		}
    	]);
    }
}

async function loadData(objSelf, contentName, contentProp, load, showMessage, ini, fin){
    
    if (showMessage === 0) {
        // No se muestra mensaje.
    } else {
        ui.showToast("Cargando información...");
    }     
    try {
        let ct = await objSelf.getContents(contentName);
        ct.unlock();
        ct.clear();
        
        var page;
        if (!isNothing(ini)) {
            page = {
                "start": ini,
                "length": fin
            };
            await ct.loadAll(false, page);
        } else {
            //ui.showToast("START: " + ini + "  -  END: " + fin);
            await ct.loadAll();
            objSelf.MAP_ROWSCOUNT = ct.count();
        }
        ct.lock();
        // ui.msgBox("content: " + ct.getDevelopedAccessString(),"DEBUG",0);
        if (load === 1) 
            ui.getView(objSelf).refresh(contentName + ',' + contentProp);
        // HWD();
    } catch(e) {
        // HWD();
        // if (logJSON===1) {
            // ui.msgBox("PROBLEMA: " + e.toString(),"CARGAR CONTENT",0);
        // }
        // ui.showToast("Error de conexión...");
    }
}

async function paginado(objself, tipo, cnt, cntProp) {
    
    var valorde, valorhasta;
    valorde=0;
    if (tipo=='ANT') {
        if (objself.MAP_PAG_INI==0) {
            ui.showToast("No hay mas registros");
        } else {
            objself.MAP_PAG_INI=objself.MAP_PAG_INI - objself.MAP_PAG_LEN;
            if (objself.MAP_PAG_INI < 0) {
                objself.MAP_PAG_INI = 0;  
            } 
            await loadData(objself, cnt, cntProp, 1, 0, objself.MAP_PAG_INI, objself.MAP_PAG_LEN);
        }
    } else {
        // Si el total de registros obtenidos es menos que el numero maximo,
        //ya no hay mas registros. ver siempre el total registros que da la 
        //consulta
        //ui.showToast("CONTENT COUNT: " + objself.getContents(cnt).getCount() + "  -  PAG_LEN: " + objself.MAP_PAG_LEN);
        if ((await objself.getContents(cnt)).getCount() < objself.MAP_PAG_LEN) {
            ui.showToast("No hay mas registros");
        } else {
            objself.MAP_PAG_INI = objself.MAP_PAG_INI + objself.MAP_PAG_LEN;
            if (objself.MAP_PAG_INI > objself.MAP_TOTAL_REGISTROS) {
                objself.MAP_PAG_INI = objself.MAP_TOTAL_REGISTROS;  
            }
            await loadData(objself, cnt, cntProp, 1, 0, objself.MAP_PAG_INI, objself.MAP_PAG_LEN);
        }
    }
    
    valorhasta=objself.MAP_PAG_INI + objself.MAP_PAG_LEN;
    if (valorhasta>objself.MAP_TOTAL_REGISTROS) {
        valorde=valorhasta - objself.MAP_PAG_LEN;
        valorhasta=objself.MAP_TOTAL_REGISTROS;  
    } else {
        valorde=valorhasta - objself.MAP_PAG_LEN;    
    } 
    if (valorde<0) {
        valorde=0;  
    } 
    objself.MAP_ROWSCOUNT="Filas de " + valorde + " a " + valorhasta + "/" + objself.MAP_TOTAL_REGISTROS;
    
    if (objself.MAP_AREALLSELECTED == 1) {
        objself.MAP_SELECTEDROWSCOUNT = -1;
        objself.MAP_AREALLSELECTED = 0;
    } 
}

function comprobarMenu(){
    if(ObjMenuPadre == ""){
        ObjMenuPadre=self;
    }
    let padre = self.getParent();
    if(self.MAP_NOMBRE=="Leads"){
        padre.MAP_MENU=1;
        self.setFieldPropertyValue("MAP_NOMBRE","bgcolor","#FFFFFF");
        self.setFieldPropertyValue("MAP_NOMBRE","border-color","#00000000");
    }

}

async function loadMenuHijo() {
    var emp = await appData.getCollection("Empresas");
    var menuHijo = emp.getVariables("menu-hijo-data");
    if (!isNothing(menuHijo)) {
        var data = menuHijo.filter(function(e) { return e.MAP_IDPADRE == self.ID; });
        (await self.getContents("MenuHijo")).loadFromJson(data);
    }
}

async function selectedItemPadre(objSelf) {
    
    var ok;
    ok=0;
    if (!isNothing(user.MAP_OBJ_DISPONIBILIDAD)){
        ok=await onBackOptionDisponibilidadListado(user.MAP_OBJ_DISPONIBILIDAD, 3); 
    } else {
        ok=1;
    }
    
    if (ok==1) {
        if(ObjMenuPadre == "") {
            ObjMenuPadre = objSelf;
        }
        if (objSelf.COLL) {
            ObjMenuPadre.setNodePropertyValue("frame","FRM_MENUOPTION","bgcolor","#00000000");
            
            ui.refreshContentRow("MenuPadreDrawer",ObjMenuPadre.getObjectIndex());
            
            objSelf.setNodePropertyValue("frame","FRM_MENUOPTION","bgcolor","#FFFFFF");
            ObjMenuPadre = objSelf;
            
            ui.refreshContentRow("MenuPadreDrawer",ObjMenuPadre.getObjectIndex());
            
            if (objSelf.COLL == 'Maestros') {
                return;
            }
            if (objSelf.NOMBRE) {
                await goToColl(objSelf, objSelf.COLL, null, true);
            }
        }
    }
}
    
async function selectedItemHijo(objSelf) {
    if(objSelf.COLL) {
        let padre = objSelf.getParent();
        padre.MAP_MENU = 0;
        //ObjMenuPadre.setFieldPropertyValue("MAP_NOMBRE","bgcolor","#00000000");
        ObjMenuPadre.setFieldPropertyValue("FRM_MENUOPTION","bgcolor","#00000000");
        //ui.getView(padre).refresh("MAP_MENU,FRMMENU1,FRMMENU2");
        ui.refresh("FRM_MENUOPTION");
        await goToColl(objSelf, objSelf.COLL, null, true);
    }
}

async function goToColl(objSelf, collName, nivel, exit) {
    
    var originalCollName=collName;
    
    if (collName == 'Usuarios') {
        collName = 'UsuariosMaestro';
    } else if (collName == 'ZonaOrganizativa') {
        collName = 'ZonaOrganizativaMaestro';
    } else if (collName == 'NewSituacionExtraordinariaCCE') {
        collName = 'SituacionExtraordinaria';
    } else if (collName == 'ComitesListadoNivel2' || collName == 'ComitesListadoNivel3' || collName == 'ComitesListadoNivel4') {
        collName = 'ComitesListadoNivel1';
    }
        
    var coll=await appData.getCollection(collName);
    coll.clear();
    var obj = await coll.createObject();
    obj.MAP_PARENT = objSelf;
    
    if (collName == 'Comite' && !isNothing(nivel) && nivel != '') {
        obj.IDNIVEL = nivel;
        obj.MAP_IDNIVEL = nivel;
    }
    
    var guid;
    if (collName == 'SituacionExtraordinaria') {
        obj.MAP_OBJINI=objSelf;
        guid = CreateGuid();
        obj.CODIGO = guid;
        obj.MAP_CODIGO = guid;
        obj.MAP_RECORDSTATE = "CREATE";
        obj.MAP_BLOQUEADO=0;
    } 
    
    if (originalCollName == 'NewSituacionExtraordinariaCCE') { 
        obj.MAP_CCE=1;
        obj.MAP_TITLETEXT="Activar CCE";
        // asignarDatosCCE(obj);
    }  
    
    if (originalCollName == 'ComitesListadoNivel1') { 
        obj.MAP_TIPO_NIVEL=1;
    } 
    if (originalCollName == 'ComitesListadoNivel2') { 
        obj.MAP_TIPO_NIVEL=2;
    } 
    if (originalCollName == 'ComitesListadoNivel3') { 
        obj.MAP_TIPO_NIVEL=3;
    } 
    if (originalCollName == 'ComitesListadoNivel4') { 
        obj.MAP_TIPO_NIVEL=4;
    } 
    
    if (collName == 'UsuariosMaestro') {
        obj.MAP_RECORDSTATE = 'CREATE';
    }
    
    // appData.pushValue(obj);
    if(exit){
        appData.pushValueAndExit(obj);
    }else{
        appData.pushValue(obj);
    }
}

//En función del tipo de usuario, mostraremos unas opciones en el menú u otras. Indicamos el id del menú a mostrar
async function loadMenuPadre() {
    var emp =await appData.getCollection("Empresas");
    var data;
    
    let contentName = 'MenuPadre';
    
    (await self.getContents(contentName)).unlock();
    (await self.getContents(contentName)).clear();
    // usertype 0 Comercial
    if (user.USERTYPE==='1') {
        data = emp.getVariables("menu-padre-data").filter(function(e) { 
            return e.ID == 1 || e.ID == 2 ; 
        });
        
    // usertype 1 Pitcher
    } else if(user.USERTYPE==='2'){
        data = emp.getVariables("menu-padre-data").filter(function(e) { 
            return e.ID == 1 ; 
        });
    // usertype 2 Líder
    }else if(user.USERTYPE==='3'){
        data = emp.getVariables("menu-padre-data").filter(function(e) { 
            return e.ID == 1 || e.ID == 2 ; 
        });
    // usertype 3 Gerente
    }else if(user.USERTYPE==='4'){
        data = emp.getVariables("menu-padre-data").filter(function(e) { 
            return e.ID == 1 || e.ID == 2 || e.ID == 3 || e.ID == 4 || e.ID == 7|| e.ID == 5 || e.ID == 8; 
        });
    // usertype 4 Director
    }else{
        data = emp.getVariables("menu-padre-data").filter(function(e) { 
            return e.ID == 1 || e.ID == 2 || e.ID == 3 || e.ID == 4 || e.ID == 5 || e.ID == 6 || e.ID == 7  || e.ID == 8; 
        });
    }
    (await self.getContents(contentName)).loadFromJson(data);
    (await self.getContents(contentName)).lock();
}

function logout() {
    appData.logout();
}

// Esta función se usa para evitar efectos no deseados cuando se hace click 
// en algún control.
function noop() {
    // Dummy function for no click.
}

function expandOrCollapseMenu(objSelf) {
    if (objSelf.MAP_MENUISCOLLAPSE == 1) {
        objSelf.MAP_MENUISCOLLAPSE = 0;
        //objSelf.setFieldPropertyValue("FRM_LEFTMENU","width", "15%");
    } else {
        objSelf.MAP_MENUISCOLLAPSE = 1;
        //objSelf.setFieldPropertyValue("FRM_LEFTMENU","width", "5%");
    }
    ui.refresh("FRM_LEFTMENUEXPAND,FRM_LEFTMENUCOLLAP,FRM_MENUOPTION,frmCentral");
}

function getMonthsName(monthNumber) {
    switch (monthNumber) {
        case 0:
            return 'enero';
            break;
        case 1:
            return 'febrero';
            break;
        case 2:
            return 'marzo';
            break;
        case 3:
            return 'abril';
            break;
        case 4:
            return 'mayo';
            break;
        case 5:
            return 'junio';
            break;
        case 6:
            return 'julio';
            break;
        case 7:
            return 'agosto';
            break;
        case 8:
            return 'septiembre';
            break;
        case 9:
            return 'octubre';
            break;
        case 10:
            return 'noviembre';
            break;
        case 11:
            return 'diciembre';
            break;
        default:
            return null;
    }
}

function getTodayDateInText() {
    let dateNow = new Date();
    let dayOfTheMonth = dateNow.getDate();
    let month = dateNow.getMonth();
    return dayOfTheMonth.toString() + " de " + getMonthsName(month);
}

function changeOnField(objSelf, propName, propsToRefresh) {
    switch (propName) {
        case 'MAP_ZONAID':
            objSelf.MAP_SHOWNIVEL = (!isNothing(objSelf.MAP_ZONAID) && objSelf.MAP_ZONAID != '') ? 1 : 0;
            break;
        case 'MAP_REGIONID':
            objSelf.MAP_SHOWNIVEL = (!isNothing(objSelf.MAP_REGIONID) && objSelf.MAP_REGIONID != '') ? 1 : 0;
            break;
        case 'MAP_NIVELID':
            // TODO: Cargar Titular y Suplente
            objSelf.MAP_SHOWCARGOS = (!isNothing(objSelf.MAP_NIVELID) && objSelf.MAP_NIVELID != '') ? 1 : 0;
            break;
    }
    ui.refresh(propsToRefresh);
}

// Helper para instanciar un control
function getControl(objSelf, sPropName) {
    try {
        let window = ui.getView(objSelf);
        if (!window) {
            return null;
        }
        let control = window[sPropName];
        if (!control) {
            return null;
        }
        return control;
    } catch(e) {
        appData.writeConsoleString("Error in getControl");
        appData.writeConsoleString(e);
        return null;
    }
}

/*  Esta función añade un '0' delante de la cadena recibida si esta representa 
    un número menor que '10'.  */
function addZero(i) {
    if (i < 10) {
        i = "0" + i;
    }
    return i;
}

function addHours(date, hours) {
    var newDate = new Date(date);
    newDate.setTime(date.getTime() + hours*60*60*1000);
    return newDate;
}


/*  Esta función se encarga de generar un código GUID.
    Código extraído de: https://slavik.meltser.info/the-efficient-way-to-create-guid-uuid-in-javascript-with-explanation/
*/
function CreateGuid() {  
    function _p8(s) {  
        var p = (Math.random().toString(16)+"000000000").substr(2,8);  
        return s ? "-" + p.substr(0,4) + "-" + p.substr(4,4) : p;  
    }  
    return _p8() + _p8(true) + _p8(true) + _p8();  
}  

async function pickFileToUpload (objSelf, messageCode) {
    try {
        let dateNow = new Date(); 
        let year = dateNow.getFullYear();
        let month = addZero(dateNow.getMonth() + 1);
        let day = addZero(dateNow.getDate());
        let hours = addZero(dateNow.getHours());
        let minutes = addZero(dateNow.getMinutes());
        let seconds = addZero(dateNow.getSeconds());
        
        let fileName = objSelf.MAP_CODIGO + '-' + year.toString() + month.toString() + day.toString() + hours.toString() + minutes.toString() + seconds.toString();
        
        var nombrefile=await ui.pickFile('MAP_FILENAME', 'jpg,png,doc,pdf', '/' + fileName);
        //Me da el nombre del fichero en un parametro
        //y con ese nombre lo guardo en base de datos añadiendo la extension
        
        objSelf.MAP_FILENAME = fileName + nombrefile.name.slice(nombrefile.name.lastIndexOf('.'));
        objSelf.MAP_FILEDESCRIPTION=nombrefile.name;
        objSelf.MAP_HAYFILE=1;
        
        // let filesColl = appData.getCollection('FicheroDiarioDeABordo');
        // createNewFileForSituation(objSelf, filesColl, messageCode);
        // ui.executeActionAfterDelay('updateFilesInMessage', 2);
    } catch(ex) {
        
    }        
}

async function pickFileToUploadRepositorio (objSelf, messageCode) {
    try {
        let dateNow = new Date(); 
        let year = dateNow.getFullYear();
        let month = addZero(dateNow.getMonth() + 1);
        let day = addZero(dateNow.getDate());
        let hours = addZero(dateNow.getHours());
        let minutes = addZero(dateNow.getMinutes());
        let seconds = addZero(dateNow.getSeconds());
        
        let fileName = user.LOGIN + '-' + year.toString() + month.toString() + day.toString() + hours.toString() + minutes.toString() + seconds.toString();
        
        //Leer lista blanca
        //formar cadena a poner en el pickfile
        let extensiones, i;
        extensiones="";
        let coll=await appData.getCollection("ListaBlancaArchivos");
        await coll.loadAll();
        for (i = 0;i <=coll.getCount()-1 ;i++) {
            if (i==0) {
                extensiones=(await coll.getItem(i)).NOMBRE;
            } else {
                extensiones=extensiones + "," + (await coll.getItem(i)).NOMBRE;
            }
        }
        
        var nombrefile=await ui.pickFile('FILENAME', extensiones, '/' + fileName);
        if (nombrefile=='Extension not supported') {
            ui.showToast("Extensión no soportada");
        } else {
            //Me da el nombre del fichero en un parametro
            //y con ese nombre lo guardo en base de datos añadiendo la extension
            objSelf.NOMBRE =nombrefile.name;
            objSelf.FILENAME = fileName + nombrefile.name.slice(nombrefile.name.lastIndexOf('.'));
        }
    } catch(ex) {
        ui.showToast("Extensión no soportada");
    }        
}

async function pickFileToUploadFromMain (objSelf, messageCode) {
    try {    
        let dateNow = new Date(); 
        let year = dateNow.getFullYear();
        let month = addZero(dateNow.getMonth() + 1);
        let day = addZero(dateNow.getDate());
        let hours = addZero(dateNow.getHours());
        let minutes = addZero(dateNow.getMinutes());
        let seconds = addZero(dateNow.getSeconds());
        
        let fileName = user.LOGIN + year.toString() + month.toString() + day.toString() + hours.toString() + minutes.toString() + seconds.toString();
        
        var nombrefile=await ui.pickFile('MAP_FILENAME', 'jpg,png,doc,pdf', '/' + fileName);
        //Me da el nombre del fichero en un parametro
        //y con ese nombre lo guardo en base de datos añadiendo la extension
        
        objSelf.MAP_FILENAME = fileName + nombrefile.name.slice(nombrefile.name.lastIndexOf('.'));
        objSelf.MAP_FILEDESCRIPTION=nombrefile.name;
        objSelf.MAP_HAYFILE=1;
        
        // let filesColl = appData.getCollection('FicheroDiarioDeABordo');
        // createNewFileForSituation(objSelf, filesColl, messageCode);
        // ui.executeActionAfterDelay('updateFilesInMessage', 2);
   
    } catch(ex) {
        
    }
}

async function pickReasonIconToUpload (objSelf) {
    try {
        let dateNow = new Date(); 
        let year = dateNow.getFullYear();
        let month = addZero(dateNow.getMonth() + 1);
        let day = addZero(dateNow.getDate());
        let hours = addZero(dateNow.getHours());
        let minutes = addZero(dateNow.getMinutes());
        let seconds = addZero(dateNow.getSeconds());
        // let fileName = "file" + year.toString() + month.toString() + day.toString() + hours.toString() + minutes.toString() + seconds.toString();
        
        let fileName = objSelf.MAP_CODIGO + '-' + year.toString() + month.toString() + day.toString() + hours.toString() + minutes.toString() + seconds.toString();
        //var jsParams = {
            //	targetProperty : "MAP_FILE",
            //	fileTypes      : "jpg,png"
        //};
        //ui.pickFile(jsParams);
        
        var nombrefile=await ui.pickFile('MAP_FILE', 'jpg,png', '/Causas/' + fileName);
        //Me da el nombre del fichero en un parametro
        //y con ese nombre lo guardo en base de datos añadiendo la extension
        
        objSelf.MAP_ICON = fileName + nombrefile.name.slice(nombrefile.name.lastIndexOf('.'));
        
    } catch(ex) {
        
    }
}

async function afterEditInicio(objSelf){
    try {
       
        var sit;
        //20250122 LM: si el usuario no tiene telefono, se lo solicitamos
        let coll=await appData.getCollection("Usuarios");
        var objUsuario=await coll.findObject("ID=" + user.ID);
        if (objUsuario){
            //appData.executeSql("UPDATE gen_device SET USUARIO='" + objSelf.MAP_USUARIO + "' WHERE MID="+iMID);
            if (!objUsuario.TELEFONO.length>0){
                //ui.showToast("Usuario sin telefono "+user.LOGIN);
                //showTelefono(objSelf,true);
            }// AQUI VENTANA PARA PEDIRLO Y GUARDAR
        }
        objUsuario=null;
        coll.clear();
        //objSelf.MAP_SITUSSUBTL = 'Hoy, ' + getTodayDateInText();
        
        
        // loadData(objSelf, 'SituacionesContent', 'MAP_SITUSCONTENT', 1, 0, 0, 50);
        await loadSelectedSituaciones(objSelf, 'SituacionesContent', 'MAP_SITUSCONTENT', 1, 0);
        sit=await objSelf.getContents("SituacionesContent");
        
        await cargarDatosSituaciones(objSelf,sit);
        
        await checkIfUserHasToIndicateDisponibility(objSelf, false);
        
        // ui.refresh("MAP_SITUSXUNITCONTENT,MAP_SITUSCONTENT");
        // ui.executeActionAfterDelay("drawArea", 1);

    } catch (e) {
        let sterror=e.message;
    } 
}

async function saveTelefonoUser(objSelf){
    try {
        if (objSelf.MAP_TELEFONO.length!=9) {
            var response=await userMsgBox("Por favor, incluya numero de teléfono para asignarlo a su usuario.", "AVISO",0,"#e04c41");        
        }else{
            var stSQL="UPDATE gen_usuarios SET TELEFONO='"+objSelf.MAP_TELEFONO+"' WHERE LOGIN LIKE '" + user.LOGIN+"'";
            appData.executeSql(stSQL);
            // replica.start();
            showTelefono(objSelf,false);
        }
        
        return;
    }catch (e) {
        var sterror=e.message;
        writelogExceptionJSv2(" saveTelefonoUser. ERROR: "+sterror,"funciones.js",false);   
    } 
      
}

function showTelefono(objSelf,bShow){
    try {
        if (bShow) {
            objSelf.MAP_SOLICITARTELEFONO=1;
        }else{
            objSelf.MAP_SOLICITARTELEFONO=0;
        }
        ui.refresh("frmbTelefono,frmacciones,FRM_TELEFONO");
    }catch (e) {
        var sterror=e.message;
        writelogExceptionJSv2(" showTelefono. ERROR: "+sterror,"funciones.js",false);   

    } 
      
}
  
function beforeEditSectorSituacionExtra(objSelf){
    try {
        if (bShow) {
            objSelf.MAP_SOLICITARTELEFONO=1;
        }else{
            objSelf.MAP_SOLICITARTELEFONO=0;
        }
        ui.refresh("frmbTelefono,frmacciones,FRM_TELEFONO");
    }catch (e) {
        var sterror=e.message;
        writelogExceptionJSv2(" beforeEditSectorSituacionExtra. ERROR: "+sterror,"funciones.js",false);   

    } 
      
}  

function editNewSituacionExtraordinaria(objSelf){
    try {
        // esto solo lo cumple cuando entra a la situacion dsd el menu historico
        if (objSelf.ESTADO=='0020') 
            return;
        // el resto, en la situacion en pantalla, sale por este camino...
        if (objSelf.MAP_BLOQUEADO===1)
            objSelf.MAP_BLOQUEADO=0;
        else
            objSelf.MAP_BLOQUEADO=1;
        
        var view=ui.getView(objSelf);
        if (view)
            //view.refresh("MAP_EDITTITLE","MAP_SAVETITLE","MAP_NOMBRE","MAP_CODIGOTIPO","MAP_CAUSASELECTBT","MAP_CAUSASTEDIT","MAP_CAUSAST","MAP_CODIGOREGION","MAP_ESTADO","MAP_ZDATACONTENT","MAP_SDATACONTENT","MAP_FECHAINICIO","MAP_HORAFECHAINICIO","MAP_FECHAFINESTIMADA","MAP_HORAFECHAFINESTIMADA");
            view.refresh("MAP_NTEXT","MAP_EDITSITUIMG","MAP_EDITTITLE","MAP_SAVEIMG", "MAP_SAVETITLE","MAP_SAVESEPARATOR","MAP_SAVEANDCLOSEIMG","MAP_SAVEANDCLOSETITLE","MAP_SAVEANDCLOSESEPARATOR","MAP_NOMBRE","MAP_CODIGOTIPO","MAP_CAUSASELECTBT","MAP_CAUSASTEDIT","MAP_CAUSAST","MAP_CODIGOREGION","MAP_ESTADO","MAP_ZDATACONTENT","MAP_SDATACONTENT","MAP_FECHAINICIO","MAP_HORAFECHAINICIO","MAP_FECHAFINESTIMADA","MAP_HORAFECHAFINESTIMADA","MAP_NUM_FICHEROS","MAP_NSAVEANDCLOSE","MAP_NUPLOADFILE");
        controlBotonesNewSituacionExtraordinaria(objSelf);
    }catch (e) {
        var sterror=e.message;
        writelogExceptionJSv2(" editNewSituacionExtraordinaria. ERROR: "+sterror,"funciones.js",false);   
    } 
}

function controlBotonesNewSituacionExtraordinaria(objSelf){
    try {
        //  MAP_EDITTITLE
        // se oculta si se esta creando, no esta bloqueado, esta en historico
        if (objSelf.MAP_RECORDSTATE=='CREATE' || objSelf.MAP_BLOQUEADO==0  || objSelf.ESTADO=='0020')
            objSelf.MAP_HIDEBTEDITTITLE=1;
        else
            objSelf.MAP_HIDEBTEDITTITLE=0;
        
        //  MAP_SAVETITLE 
        // se oculta si esta en creacion en grupo 1 o bloquedao. 
        if (objSelf.MAP_RECORDSTATE=='CREATE'|| objSelf.MAP_BLOQUEADO==1  )   
            objSelf.MAP_HIDEBTSAVETITLE=1;
        else
            objSelf.MAP_HIDEBTSAVETITLE=0;        
        
        //  MAP_NEXT
        // se oculta si no esta en creacion, no esta en grupo 1 o esta en historico
        //if (objSelf.MAP_RECORDSTATE!=='CREATE' || objSelf.MAP_OPTION!='1' || objSelf.ESTADO=='0020'  )    
        //    objSelf.MAP_HIDEBTNEXT=1;
        //else
        //    objSelf.MAP_HIDEBTNEXT=0;        
        
        //  MAP_CLOSETITLE
        //if (objSelf.MAP_BLOQUEADO==0)  
        //    objSelf.MAP_HIDEBTCLOSETITLE=1;
        //else
        //    objSelf.MAP_HIDEBTCLOSETITLE=0;
        
        var view=ui.getView(objSelf);
        if (view)
            view.refresh("MAP_EDITTITLE","MAP_SAVETITLE");
    }catch (e) {
        var sterror=e.message;
        writelogExceptionJSv2(" controlBotonesNewSituacionExtraordinaria. ERROR: "+sterror,"funciones.js",false);   
    } 
}

// AIPL: Copiado y adaptado del código de la App Móvil 
// createComiteListado: para visualizar el comite en el menu.
async function createComiteListado(objSelf) {
    try {
        
        //var relComitteeContent = objSelf.getContents('ComiteRelacionadoList');
        var relComitteeContent = await objSelf.getContents('DataContent');
        
        var idComiteMatriz = 0;
        // si tenemos valor para nivel de la region, por venir de un filtro encima del listado, usamos ese nivel como onBackOptionPushAndExit
        // en caso contrario, vemos cual es el elemento con nivel=1 en el comite y es el que usamos. 
        if (objSelf.MAP_REGIONNIVEL) {
            idComiteMatriz = objSelf.MAP_REGIONNIVEL;
        }
        else {
            idComiteMatriz = await getValueFromObjColl('ComiteMaestro','ID','N','c.IDNIVEL=1 AND (c.BAJA=0 OR c.BAJA IS NULL)','c.ID');
        }
        
        relComitteeContent.unlock();
        if (objSelf.MAP_REGIONCODIGO == 'CCE') {
            relComitteeContent.setMacro("##MACRO##", "r.IDNIVEL IN (1,2)");
        } else {
            relComitteeContent.setMacro("##MACRO##", "1=1");
        }
        relComitteeContent.setMacro("##CCIDNIVELPADRE##", idComiteMatriz);
        relComitteeContent.clear();
        await relComitteeContent.loadAll();
        relComitteeContent.lock();
        ui.refresh("MAP_DATACONTENT"); 
        ui.hideWaitDialog();
    } catch (e) {
        var sterror=e.message;
        // writelogExceptionJSv2(" createComiteListado. ERROR: "+sterror,"funciones.js",false);   
        ui.hideWaitDialog();
    } 
      
}

async function seleccionarPrimerElemento(objself){
    let contentsOpcionesMenu = await objself.getContents("MenuPadre");
    if(contentsOpcionesMenu){
        if(contentsOpcionesMenu.getCount() > 0){
            let item = await contentsOpcionesMenu.getItem(0);
            item.setNodePropertyValue("frame","FRM_MENUOPTION","bgcolor","#FFFFFF");
            ObjMenuPadre = item;
            ui.refreshContentRow("MenuPadreDrawer",ObjMenuPadre.getObjectIndex());
        }
    }
}

// getValueFromObjColl: retorna varios valores de un prop de la coll indicada
//  - stCollName: coleccion donde buscamos
//  - stProp: valor del prop a devolver
//  - stType: tipo de rotnor del prop
//  - stFilter: filtro a aplicar a la coll 
//  - stOrder. ordenación a aplicar a la coll
async function getValueFromObjColl(stCollName, stProp, stType, stFilter, stOrder) {
	var vValue = "";
	try { 
		var collLoad = null;
		switch (stType) {
			case 'N':
				vValue = 0;
				break;
			case 'T':
				vValue = "";
				break;
			case 'D':
				vValue = null;
				break;
			default:
				vValue = "";
				break;
		}        
		collLoad = (await appData.getCollection(stCollName)).createClone();
		collLoad.filter = stFilter;
		collLoad.sort = stOrder;
		await collLoad.startBrowse();
		if (await collLoad.getCurrentItem()) {
			vValue = (await collLoad.getCurrentItem)()[stProp];
		}
		collLoad.endBrowse();
		collLoad.clear();
		return vValue;
	} catch (e) {
		let stError = e.message;
		writelogExceptionJSv2(" getValueFromObjColl. ERROR: " + stError, "js_util.js");
		return vValue;
	}    
}
  /***
*
* Code from messages.js
*
***/


function showMessage(objSelf, messageTag, context) {
    switch (messageTag) {
        case 'EXIST_RECORD':
            switch (context){
                case 'Nivel':
                    ui.showToast("Existe un Nivel con el mismo Código, por favor, rectifique los datos.");
                    break;
                case 'Usuarios':
                    ui.showToast("Existe un Usuario con el mismo número de expediente, por favor, rectifique los datos.");
                    break;
                case 'Comite':
                    ui.showToast("Existe un Comité con el mismo código, por favor, rectifique los datos.");
                    break;
                case 'Region':
                    ui.showToast("Existe una Región con el mismo Código, por favor, rectifique los datos.");
                    break;
            }
            break;
        
        default:
            // code
    }
}/***
*
* Code from login.js
*
***/


async function trazaSeguridadLogin(objSelf, tipo, resultado, usuario) {
    
    var coll = await appData.getCollection("TrazabilidadSeguridad");
    var obj = await coll.createObject();
    obj.TIPO = tipo;
    obj.RESULTADO = resultado;
    obj.FECHA = new Date();
    obj.IDENTIFICADORMID = "WEB";
    obj.DISPOSITIVO = appData.getGlobalMacro("##VERSION##") + ". " + appData.getGlobalMacro("##DEVICE_OS##") + ": " + appData.getGlobalMacro("##DEVICE_MODEL##") + ".  " + appData.getGlobalMacro("##DEVICEID##");
    obj.USUARIO = usuario;
    //obj.USUARIO = objSelf.USER;
    await obj.save();
}

function getTypeDevice(objSelf) {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isDevice= /android|iphone|ipad|ipod|blackberry|windows phone|opera mini|iemobile/i.test(userAgent);
	var isAndroid= /android/i.test(userAgent);
	var isIos= /iphone/i.test(userAgent);
	
	if(isDevice) {
	    objSelf.MAP_DEVICE_MOVIL = 1;
	    if(isAndroid) {
    	    objSelf.MAP_MESSAGE_DEVICE = "Para acceder a PLADEMER en un dispositivo Android debe hacerlo utilizando la app movil que puede encontrar en las aplicaciones de trabajo de Google Play";
    	    objSelf.MAP_IMG_PLATAFORMA = "google-play.png"; 
    	    // poner img del logo de Google Play con un href a la app en el market    
	    } else {
    	    if(isIos) {
        	    objSelf.MAP_MESSAGE_DEVICE = "Para acceder a PLADEMER en un dispositivo iOS debe hacerlo utilizando la app movil que puede encontrar en las aplicaciones del Portal de Empresa de Intune";
        	    objSelf.MAP_IMG_PLATAFORMA = "Intune.jpg";
        	    // poner img del logo de iOS   
    	    } else {
        	    objSelf.MAP_MESSAGE_DEVICE = "Para acceder a PLADEMER use la versión web de la aplicacion";
        	    objSelf.MAP_IMG_PLATAFORMA = "";
        	    // no hace falta nada
    	    }
	    }
	} else {
	    objSelf.MAP_DEVICE_MOVIL = 0;
	}
}

async function isUserWithAccess(userLogin) {
    try {
        
        //if (jsconst_oper.prod == false) {
        //    // Para evitar necesitar en entorno de pruebas que el usuario exista en BD y en el organigrama. 
        //    // Para facilitar pruebas de Login.
        //    return true;
        //}
        
        // Usuario existe en BD local
        let usersColl = await appData.getCollection("Usuarios");
        // 20250121 LM: no usamos NUMEXPEDIENTE, ya que el frame requiere del uso de LOGIN, por tanto, nos basamos en ese campo
        let userObj = await usersColl.findObject("LOGIN = '" + userLogin + "'");
        
        if (isNothing(userObj)) {
            // No existe usuario correspondiente en BD Local.
            return false;
        }
        // 20250121 LM: miramos si es admin, y entra...
        if (userObj.USERTYPE == 'ADMIN') {
            // esta marcado como admin, entra...
            return true;
        }       
        
        // Usuario pertenece al organigrama del CCE
        let committeeColl = await appData.getCollection("ComiteMaestro");
        let comitteeObj = await committeeColl.findObject("c.IDTITULAR=" + userObj.ID + " OR c.IDSUPLENTE=" + userObj.ID);
        
        if (isNothing(comitteeObj)) {
            // No pertenece al organigrama del CCE.
            return false;
        }
        return true;
    } catch(e) {
        let stError = e.message;
        return false;
        //writelogExceptionJSv2("isUserWithAccess. ERROR: " + stError, "js_login.js", false);
    }
}

async function doLogin(objSelf) {
    try {
        var stUsuario = objSelf.USER.trim().toUpperCase();
            
        if(isEmptyString(stUsuario)) {
            await onLoginWithLDAPFailed(objSelf, {
                hasError: true, 
                message: "No se ha incluido expediente de usuario", 
                errorCode: "PERSO1", 
                data: null
            });
            return;
        }
            
        if(isEmptyString(objSelf.PWD)) {
            await onLoginWithLDAPFailed(objSelf, {
                hasError: true, 
                message: "No se ha incluido clave de usuario", 
                errorCode: "PERSO2", 
                data: null});
            return;
        }
        
        var params = {
            userName: stUsuario,
            password: objSelf.PWD,
            entryPoint: "Inicio", 
        
            // Opcional
            onLoginSuccessful: function() {
                // TODO: Esto se hacía antes si el login con LDAP era successful, continuamos haciéndolo?
                // 20241122 LM: para control ataques fuerza bruta
                //crearRegistroAcceso(objSelf, false);
                // AIPL 2025-08-13: Añadido para manejar la caducación de la sesión y evitar que se dejen de obtener datos.
                ui.setSessionExpired(600000, afterSessionExpired);
            },
    
            // Opcional
            onLoginFailed: function() {
                // TODO: Deberían obtenerse los mismos errores que antes obteníamos si fallaba el LDAP y procesarlos como se hace en 
                // onLoginWithLDAPFailed?
                objSelf.MAP_MESSAGE_ERROR_LOGIN = "Usuario o contraseña incorrectos o sin perfil necesario para usar esta aplicación";
                ui.refreshValue("MAP_MESSAGE_ERROR_LOGIN"); 
            }
        };
        await appData.login(params);
    } catch(e) {
        
    }
}

async function afterSessionExpired() {
    let response = await userMsgBox("La sesión a caducado por favor, inicie sesión nuevamente", "AVISO", 0, "#E04C41"); 
    if (response === 1) {
        appData.logout();
    }
}

async function onLoginWithLDAPFailed(objSelf, jsResult) {
    try {
        //writeLogFunctionJSv2(" onLoginWithLDAPFailed: "+jsresult,"js_login.js",1);
        var errorCode = "NO_ERROR_CODE";
        var tmpLoginOK = 0;
        var tmpMsg = "";
        try {
            errorCode = jsResult.errorCode;
        } catch (e) {
            //objself.MAP_MESSAGE_ERROR_LOGIN = "No se ha podido validar el dispositivo para realizar esta acción";
            //writelogExceptionJSv2(" onLoginWithLDAPFailed. ERROR: NO_ERROR_CODE "+jsresult,"funciones.js",false);
        }        
        // if(typeof jsresult !== "undefined" 
        // && jsresult != null
        // && typeof jsresult.errorCode !== "undefined" 
        // && jsresult.errorCode == 1006){
        if (errorCode == "NO_ERROR_CODE") {
            objSelf.MAP_MESSAGE_ERROR_LOGIN = "No se ha podido validar el dispositivo para realizar esta acción";
        } else if(typeof jsResult !== "undefined"  && errorCode == 1006) {
            objSelf.MAP_MESSAGE_ERROR_LOGIN = "No se ha podido obtener conexión. Inténtelo mas tarde";
        }else if(errorCode == "PE") {
            objSelf.MAP_MESSAGE_ERROR_LOGIN = "Usuario con contraseña caducada o pendiente de cambio";
        }else if(errorCode == "BAE") {
            objSelf.MAP_MESSAGE_ERROR_LOGIN = "Usuario con contraseña caducada o pendiente de cambio. Binding erróneo";
        }else if(errorCode.indexOf('PERSO') != -1) {
            objSelf.MAP_MESSAGE_ERROR_LOGIN = jsResult.message;
        }else {
            objSelf.MAP_MESSAGE_ERROR_LOGIN = "Usuario o contraseña incorrectos o sin perfil necesario para usar esta aplicación";
        }
        // 20241122 LM: para control ataques fuerza bruta
        await crearRegistroAcceso(objSelf, true);
        
    } catch (e) {
        //objself.MAP_MESSAGE_ERROR_LOGIN = "Usuario o contraseña incorrectos o sin perfil de movilidad asignado";
        let stError = e.message;
        //writelogExceptionJSv2(" onLoginWithLDAPFailed. ERROR: "+stError,"js_login.js",false);
    } finally {
        //objSelf.setFieldPropertyValue("MAP_BTUSUARIO","img","login_error.png");
        //objSelf.setFieldPropertyValue("MAP_BTCONTRASENNA","img","pwd_error.png");
        //ui.refresh("MAP_BTUSUARIO","MAP_BTCONTRASENNA");
        ui.refreshValue("MAP_MESSAGE_ERROR_LOGIN");
        ui.hideWaitDialog();
    }
}

// funcion para actualizar el control de login de usuarios para control ataques fuerza bruta
async function crearRegistroAcceso(objSelf, bFailed){
    try {
        if(jsconst_LDAP.Fail_Control) {
            var coll = await appData.getCollection("UsuariosLogin");
            var obj = await coll.findObject("MID=" + replica.getMid() + " AND LOGIN='" + objSelf.USER.trim().toUpperCase() + "'");
            if(!obj) {
                obj = await coll.createObject();
            }
            // obj.MID = replica.getMid();
            obj.LOGIN = objSelf.USER.trim().toUpperCase(); 
            obj.TIMESTAMP = new Date();
            obj.NEXTACCESS = new Date();
            
            if (bFailed) {
                //Acceso fallido (dentro de los intentos permitidos). 
                //Si el login es incorrecto y el número de intentos fallidos es menor o igual a Fail_Attempts
                //Sumamos 1 a ATTEMPTS y comprobar
                var contador = obj.ATTEMPTS + 1;
                obj.ATTEMPTS = contador;
                if (contador > jsconst_LDAP.Fail_Attempts) {
                    //Acceso fallido (supera los intentos permitidos). 
                    //Si el número de intentos fallidos supera Fail_Attempts
                    var calculo = (obj.ATTEMPTS + 1 - jsconst_LDAP.Fail_Attempts) * jsconst_LDAP.Fail_Time * jsconst_LDAP.Fail_Interval;
                    var fecha = new Date();
                    
                    //ui.msgBox("fecha: "+fecha.toString() + " minutos: "+calculo,"a",0);
                    fecha.setMinutes(fecha.getMinutes() + calculo);
                    obj.NEXTACCESS = fecha;
                    //ui.msgBox("fecha 1: "+fecha.toString(),"a",0);
                }
    
                await obj.save();
            } else {
                //Acceso correcto, borramos intentos fallidos y limpiamos...
                obj.LASTOKACCESS = new Date();
                obj.ATTEMPTS = 0;
                await obj.save();
            }
            //replica.start();
        }
    } catch (e) {
        let stError = e.message;
        //writelogExceptionJSv2(" crearRegistroAcceso. ERROR: "+stError,"js_login.js",false);
        return false;
    } 
}/***
*
* Code from js_util.js
*
***/


// writelogExceptionJSv2: función que escribe en la tabla gen_devicelog la informacion. 
//  - st: texto de log
//  - filename: fichero en el que se genera la excepcion
//  - bsendLog: para indicar si con la excepción queremos o no que se envie los logs del terminal
function writelogExceptionJSv2(st,filename,bsendLog) {
	
	return;
}
   
// addString: incluir texto en una cadena
function addString(stSource, stNewString, stSeparator)
{
    try{
        // comprobamos si la cadena original tiene contenido
        if (safeCompareInt(stSource.length,0))
            return stNewString;

        stSource=stSource+stSeparator+stNewString;
        return stSource;

    }catch (e) {
        var sterror=e.message;
        writelogExceptionJS(" addString. ERROR: "+sterror,"funciones.js");
    }   
}

// copyObject: Copiamos las propiedades de un objeto a otro. en fields va el formato
// {
//    NOMBREOBJFROM:NOMBREOBJTO
// }
function copyObject(fromObject,toObject, fields) {
	try {
    	//var st="";gen_e
    	for (var fld in fields) {
    		//st=st+fld+"->"+fields[fld]+"."+fromObject[fields[fld]]+"\n";
    		toObject[fld]=fromObject[fields[fld]];
    	}
    	//ui.showToast(st);
    }catch (e){
        var sterror=e.message;
    }
} 

// Permite copiar un objeto json a un xone
function copyJsonToXone(objXone,jsonObject) {
	for (let fld in jsonObject) {
		objXone[fld]=jsonObject[fld];
	}
}

function copyJsonToVariables(destObj,jsonObject) {
	for (let fld in jsonObject) {
		destObj.setVariables(fld,jsonObject[fld]);
	}
}

function copyVariablesToObject(fromObject,destObj,jsonObject) {
	for (let fld in jsonObject) {
		destObj[fld]=fromObject.getVariables(jsonObject[fld]);
	}
}

function copyObjectToVariables(fromObject,destObj,jsonObject) {
	for (let fld in jsonObject) {
		destObj.setVariables(fld,fromObject[jsonObject[fld]]);
	}
}

function copyMapFieldToField(fromObject,destObj,fields) {
	for (let i=0;i<fields.length;i++) {
		destObj[fields[i]]=fromObject["MAP_"+fields[i]];
	}
}

async function sendMailTo(mailTo) {
    if (!isNothing(mailTo) && mailTo.length > 0 && isValidEmail(mailTo)) {
        ui.sendMail(mailTo);
    } else {
        //ui.msgBox("El email del contacto no es válido.", "AVISO", 0);
        var response=await userMsgBox("El email del contacto no es válido.", "¡Aviso!", 0, "#e04c41");
    }
}

async function doSetText(st) {
    await clipboard.setText(st);
}


/***
*
* Code from js_acciones.js
*
***/


var selectedSituaciones = [];

function unSelectSituacion(obj) {
     if (selectedSituaciones == null){
          selectedSituaciones = [];
     }
     
     selectedSituaciones.push(obj.MAP_CODIGO);
}

function selectSituacion(obj) {
     if (selectedSituaciones == null){
          selectedSituaciones = [];
          return;
     }
     
     if (selectedSituaciones.indexOf(obj.MAP_CODIGO) != -1)
        selectedSituaciones.splice(selectedSituaciones.indexOf(obj.MAP_CODIGO), 1);
        
    return;
}

async function loadSelectedSituaciones(objSelf, contentName, contentProp, load, showMessage){
   
    if (showMessage === 0) {
        // No se muestra mensaje.
    } else {
        ui.showToast("Cargando información...");
    }
    
    try {
        var ct = await objSelf.getContents(contentName);
        ct.unlock();
        ct.clear();
        await ct.loadAll();
        var firstTime = false;
        if (selectedSituaciones == null){
            firstTime = true;
            selectedSituaciones = [];
        }       
            
        objSelf.MAP_ROWSCOUNT = ct.count();
        for (let i=0; i<ct.count();i++){
            var obj = await ct.getItem(i);
            if (firstTime){
                selectedSituaciones.push(obj.MAP_CODIGO);
            } else {
                if (selectedSituaciones.indexOf(obj.MAP_CODIGO) > -1) {
                    obj.MAP_BGCOLOR_SEL = '#EEEEEE';
                    obj.MAP_BGCOLOR = '#EEEEEE';
                    obj.MAP_FORECOLOR_SEL='#888888';
                    obj.MAP_SEL = 0;
                } else {
                    obj.MAP_BGCOLOR_SEL = '#FFFFFF';
                    obj.MAP_FORECOLOR_SEL='#2C2C2C';
                    obj.MAP_SEL = 1;
                }
            }
        }
        
        ct.lock();
        if (load === 1) 
          ui.getView(objSelf).refresh(contentName + ',' + contentProp);
    } catch(e) {
        ui.showToast("Error de conexión...");
        var sterror=e.message;
        writelogExceptionJSv2(" cargarDatosSituaciones. ERROR: "+sterror,"funciones.js");        
    }
}

async function onchangeMAP_CODIGOREGION(objSelf){
    try {
        if (objSelf.ID!=0)
            return;
           
        var i;    
        var zonesContent = await objSelf.getContents('ZDataContent');
        var sectorContent = await objSelf.getContents('SDataContent');
        zonesContent.unlock();
        sectorContent.unlock();
        zonesContent.clear();
        sectorContent.clear();
        var stCodZonas="";
        var zonaColl=await appData.getCollection("ZonaOrganizativa");
        zonaColl.setFilter("z.BAJA=0 AND z.CODIGOREGION LIKE '"+objSelf.MAP_REGIONCODE+"'");
        await zonaColl.loadAll();
        for (i = 0;i <=zonaColl.getCount()-1 ;i++) {
            var objZona=await zonaColl.getItem(i);
            var zonesContentObj=await zonesContent.createObject();
            stCodZonas=addString(stCodZonas, "'"+objZona.CODIGO+"'", ",");
            var jsonObject={
                CODIGOSITUACION:objSelf.CODIGO,
                ISSELECTED:0,
                MAP_BGCOLOR_SEL:'#EEEEEE',
                MAP_NOMBREZONA:objZona.NOMBRE,
                CODIGOZONA:objZona.CODIGO,
                FECHACREACION: new Date(),
                IDUSUARIO:user.ID,
                ACTUALIZADO:1,  
                BAJA:0
            };
            copyJsonToXone(zonesContentObj,jsonObject);
            zonesContent.addItem(zonesContentObj);
        }
        
        var sectorColl=await appData.getCollection("SectorMaestro");
        sectorColl.setFilter("BAJA=0 AND CODIGOZONA IN ("+stCodZonas+")");
        await sectorColl.loadAll();
        for (i = 0;i <=sectorColl.getCount()-1 ;i++) {
            var objSector=await sectorColl.getItem(i);
            var sectorContentObj=await sectorContent.createObject();
            jsonObject={
                CODIGOSITUACION:objSelf.CODIGO,
                ISSELECTED:0,
                MAP_BGCOLOR_SEL:'#EEEEEE',
                MAP_NOMBRESECTOR:objSector.NOMBRE, 
                //MAP_NOMBREZONA:objSector.NOMBRE,
                CODIGOZONA:objSector.CODIGOZONA,
                CODIGOUNIDAD: objSector.CECO,
                FECHACREACION: new Date(),
                IDUSUARIO:user.ID,
                ACTUALIZADO:1,
                BAJA:0
            };
            copyJsonToXone(sectorContentObj,jsonObject);
            sectorContent.addItem(sectorContentObj);
        }        
        
        zonesContent.lock();
        sectorContent.lock();

        var relComitteeContent = await objSelf.getContents('CDataContent');
        relComitteeContent.unlock();
        relComitteeContent.setMacro("##CCIDNIVELPADRE##", objSelf.MAP_REGIONCOMMITTEE);
        relComitteeContent.clear();
        await relComitteeContent.loadAll();
        relComitteeContent.lock();
        
        ui.refresh();

    }catch (e) {
        var sterror=e.message;
        // writelogExceptionJSv2(" onchangeMAP_CODIGOREGION. ERROR: "+sterror,"funciones.js",false);   

    } 
      
}

//Esto sirve para salvar los sectores y las zonas al salvar una situacion
async function salvarUbicacionSituacion(objSelf) {
    try{    
        ui.showWaitDialog("Guardando Comite Relacionado...");
        var comiteContentSaveObj;
        var jsonObject;
        
        var zonesContent = await objSelf.getContents('ZDataContent');
        var sectorContent = await objSelf.getContents('SDataContent');
        var comiteContent = await objSelf.getContents('CDataContent');
        var comiteContentSave = await objSelf.getContents('ComiteRelacionadoEdit');
        
        for (var i = 0;i <=zonesContent.getCount()-1 ;i++) {
            await (await zonesContent.getItem(i)).save();
        }
    
        for (i = 0;i <=sectorContent.getCount()-1 ;i++) {
            await (await sectorContent.getItem(i)).save();
        }
        
        if (objSelf.MAP_RECORDSTATE=== "CREATE") {
            // DISP_TITULAR: 0- NO CONTESTO, 1-DISPONIBLE, 2-NO DISPONIBLE
            comiteContent.setMacro("##CCIDNIVELPADRE##", objSelf.MAP_REGIONCOMMITTEE);
            await comiteContent.loadAll();
            for (i = 0;i <=comiteContent.getCount()-1 ;i++) {
                var objComite=await comiteContent.getItem(i);
                
                if (objSelf.MAP_REGIONCODE=="CCE") {
                    if (objComite.MAP_NIVEL==1 || objComite.MAP_NIVEL==2) {
                        comiteContentSaveObj=await comiteContentSave.createObject();
                        jsonObject={
                            ORDEN:i,
                            CODIGOSITUACION:objSelf.CODIGO,
                            CODIGOCOMITE:objComite.CGSROWID,
                            IDSUPLENTE:objComite.IDSUPLENTE,
                            IDTITULAR:objComite.IDTITULAR,
                            DISP_SUPLENTE: 0,   
                            DISP_TITULAR: 0,
                            FECHACREACION: new Date(),
                            IDUSUARIO:user.ID,
                            ACTUALIZADO:1,
                            BAJA:0
                        };    
                        copyJsonToXone(comiteContentSaveObj,jsonObject);
                        comiteContentSave.addItem(comiteContentSaveObj);
                        await comiteContentSaveObj.save();
                    }
                } else {
                    comiteContentSaveObj=await comiteContentSave.createObject();
                    jsonObject={
                        ORDEN:i,
                        CODIGOSITUACION:objSelf.CODIGO,
                        CODIGOCOMITE:objComite.CGSROWID,
                        IDSUPLENTE:objComite.IDSUPLENTE,
                        IDTITULAR:objComite.IDTITULAR,
                        DISP_SUPLENTE: 0,   
                        DISP_TITULAR: 0,
                        FECHACREACION: new Date(),
                        IDUSUARIO:user.ID,
                        ACTUALIZADO:1,
                        BAJA:0
                    };    
                    copyJsonToXone(comiteContentSaveObj,jsonObject);
                    comiteContentSave.addItem(comiteContentSaveObj);
                    await comiteContentSaveObj.save();
                }
            }      
        }
        
        // ahora guardamos el comite para la coleccion y la tabla gen_comiteafectado, y tendremos una traza de disponibilidad 
        // con todas las acciones de cualquier usuario
        // todo gris, con la bola delante,  y disponjible, bola verde, no disponible, bola roja
        // cuando los 2 sea no disponible, fondo rojo de la celda. 
        // se pueden cambiar los usuarios cuando quieran....
        
        ui.hideWaitDialog();
    }catch (e) {
        let sterror=e.message;
        // writelogExceptionJSv2(" salvarUbicacionSituacion. ERROR: "+sterror,"js_acciones.js");
        ui.hideWaitDialog();
    }
}  

async function refrescarPantallaPrincipal(objSelf) {
    
    let dataContent = await objSelf.getContents("SituacionesContent");
    dataContent.unlock();
    dataContent.clear();
    await dataContent.loadAll();
    dataContent.lock();
    
    dataContent = await objSelf.getContents("SituacionesXUnidadContent");
    dataContent.unlock();
    dataContent.clear();
    await dataContent.loadAll();
    dataContent.lock();
    
    ui.refresh(); 
    
    await cargarDatosMapa(objSelf);
}

async function cargarDatosSituaciones(objSelf, cnt) {
    
    await ui.sleep(1);
    var codsit, haysit;
    codsit="";
    haysit=0;
    
    if (objSelf.MAP_ELIMINAR==99 || objSelf.MAP_REFRESHATRAS==1) {
        // loadData(objSelf, 'SituacionesContent', 'MAP_SITUSCONTENT', 1, 0, 0, 50);
        await loadSelectedSituaciones(objSelf, 'SituacionesContent', 'MAP_SITUSCONTENT', 1, 0);
        cnt=await objSelf.getContents("SituacionesContent");
        objSelf.MAP_REFRESHATRAS=0;
        objSelf.MAP_ELIMINAR=0;
    }
    
    for (let i = 0; i < cnt.getCount(); i++) {
        if ((await cnt.getItem(i)).MAP_SEL==1) {
            haysit=1;
            if (codsit.length>0) {
                codsit=codsit + ",";
            }
            codsit=codsit + "'" + (await cnt.getItem(i)).MAP_CODIGO + "'";
        }
    }
    if (haysit==1) {
        (await objSelf.getContents("MensajeDiarioABordoUltimas")).setMacro("##MACRO##","m.SITUACIONCODIGO IN (" + codsit + ")");
        (await objSelf.getContents("MapaPintarScript")).setMacro("##MACRO##",codsit);
        (await objSelf.getContents("SituacionesXUnidadContent")).setMacro("##MACRO##","s.BAJA=0 AND u.ISSELECTED=1 AND s.CODIGO IN (" + codsit + ")");
    } else {
        (await objSelf.getContents("MensajeDiarioABordoUltimas")).setMacro("##MACRO##","1=0");
        (await objSelf.getContents("SituacionesXUnidadContent")).setMacro("##MACRO##","1=0");
        (await objSelf.getContents("MapaPintarScript")).setMacro("##MACRO##","1=0");
    }
    await loadData(objSelf, 'MensajeDiarioABordoUltimas', 'MensajeDiarioABordoUltimas', 1, 0, 0, 5);
    await loadData(objSelf, 'SituacionesXUnidadContent', 'MAP_SITUSXUNITCONTENT', 1, 0, 0, 50);
    await cargarDatosMapa(objSelf);
}

function gruposSituacion(objSelf,grupo) {
    
    objSelf.MAP_OPTION=grupo;
    if (grupo==1) {
        ui.getView(objSelf).refresh("FRM_SITURELDATA");    
    } else if (grupo==2) {
        ui.getView(objSelf).refresh("FRM_ONBOARDDIARY");    
    } else if (grupo==3) {
        ui.getView(objSelf).refresh("FRM_CONTACTOS");    
    }
    
}

async function createNewSituationCCE(objSelf) {
    
    let response;
    response=await userMsgBox("¿Esta seguro de que desea activar el Comite Central de Emergencia?", "AVISO",1,"#e04c41");
    if(response === 1){
        await goToColl(objSelf, "NewSituacionExtraordinariaCCE");
    }
      
}

// ademas de ajustar los datos de la region, hay que incluir los datos de cambiar de zonas y 
// sectores.
async function activarCCE(objSelf){ 
    try {
        var response;
        //response = ui.msgBox("¿Esta seguro de que desea activar el Comite Central de Emergencia?", "AVISO", 4);
        response=await userMsgBox("¿Esta seguro de que desea activar el Comite Central de Emergencia?", "AVISO",1,"#e04c41");
      	//if( response != 6){
      	//    return;
        //}  
        if (response === 1) {
            // aqui tendremos que rellenar todo bien....
            //objSelf.MAP_IDREGION=getValueFromObjColl("RegionMaestro","ID","N","r.CODIGO='CCE'",null);
            ui.showWaitDialog("Actualizando datos del CCE.");
            await asignarDatosCCE(objSelf);
            var view=ui.getView(objSelf);
            if (view)
                view.refresh("MAP_CODIGOREGION","MAP_REGIONCODE","MAP_REGIONCOMMITTEE");
            // proceso para cambiar la region y modificar la creacion de las zonas y sectores...
            // a tener en cuenta no incluir las zonas o sectores que ya teniamos..
        }
    }catch (e) {
        
    } finally{
        ui.hideWaitDialog();
    }
}

async function asignarDatosCCE(objSelf){ 
    try {
        // aqui tendremos que rellenar todo bien....
        var collRegion=await appData.getCollection("RegionCCE");
        //collRegion.setMacro("##MACRO##","r.CODIGO='CCE'");
        await collRegion.loadAll();
        if (collRegion.getCount()>0){
            var objRegion=await collRegion.getItem(0);
            // objSelf.MAP_IDREGION=objRegion.ID;
            objSelf.MAP_CODIGOREGION=objRegion.NOMBRE;
            objSelf.MAP_REGIONCODE=objRegion.CODIGO;
            objSelf.MAP_REGIONCOMMITTEE=objRegion.IDNIVEL;
            
            await updateZonasSectoresComiteCCE(objSelf);
        }else{
            
        }
        
       
    }catch (e) {
    } 
}

async function updateZonasSectoresComiteCCE(objSelf){
    try {
        ui.showWaitDialog("Cargando datos...");
        
        var zonesContent = await objSelf.getContents('ZDataContent');
        var sectorContent = await objSelf.getContents('SDataContent');
        
        zonesContent.setMacro("##MACRO##", "z.CODIGOSITUACION='" + objSelf.CODIGO + "'");
        sectorContent.setMacro("##MACRO##", "sa.CODIGOSITUACION='" + objSelf.CODIGO + "'");
        (await objSelf.getContents('CDataContent')).setMacro("##MACRO##", "ca.CODIGOSITUACION='" + objSelf.CODIGO + "'");
                    
        // zonesContent.unlock();
        // sectorContent.unlock();
        var stCodZonas="";
        var stCodSector="";
        //revisamos las que ya tenemos...
        for (i = 0;i <=zonesContent.getCount()-1 ;i++) {
            stCodZonas=addString(stCodZonas, "'"+(await zonesContent.getItem(i)).CODIGOZONA+"'", ",");
        }
        for (i = 0;i <=sectorContent.getCount()-1 ;i++) {
            stCodSector=addString(stCodSector, "'"+(await sectorContent.getItem(i)).CODIGOUNIDAD+"'", ",");
        }
        //zonesContent.clear();
        //sectorContent.clear();
        
        var zonaColl=await appData.getCollection("ZonaOrganizativa");
        zonaColl.setFilter("z.BAJA=0");
        await zonaColl.loadAll();
        var i=0;
        for (i = 0;i <=zonaColl.getCount()-1 ;i++) {
            var objZona=await zonaColl.getItem(i);
            if (!stCodZonas.includes(objZona.CODIGO)) {
                var zonesContentObj=await zonesContent.createObject();
                stCodZonas=addString(stCodZonas, "'"+objZona.CODIGO+"'", ",");
                var jsonObject={
                    CODIGOSITUACION:objSelf.CODIGO,
                    ISSELECTED:0,
                    MAP_BGCOLOR_SEL:'#EEEEEE',
                    MAP_FORECOLOR_SEL:'#888888',
                    MAP_NOMBREZONA:objZona.NOMBRE,
                    CODIGOZONA:objZona.CODIGO,
                    FECHACREACION: new Date(),
                    IDUSUARIO:user.ID,
                    ACTUALIZADO:1,
                    BAJA:0
                };
                copyJsonToXone(zonesContentObj,jsonObject);
                zonesContent.addItem(zonesContentObj);
                if (objSelf.MAP_RECORDSTATE!='CREATE') {
                    await zonesContentObj.save();
                }
            }
        }
        zonesContent.lock();
        // ui.refresh("MAP_ZDATACONTENT");
        
        var sectorColl=await appData.getCollection("SectorMaestro");
        sectorColl.setFilter("BAJA=0");
        await sectorColl.loadAll();
        for (i = 0;i <=sectorColl.getCount()-1 ;i++) {
            var objSector=await sectorColl.getItem(i);
            if (!stCodSector.includes(objSector.CECO)) {
                var sectorContentObj=await sectorContent.createObject();
                jsonObject={
                    CODIGOSITUACION:objSelf.CODIGO,
                    ISSELECTED:0,
                    MAP_BGCOLOR_SEL:'#EEEEEE',
                    MAP_FORECOLOR_SEL:'#888888',
                    MAP_NOMBRESECTOR:objSector.NOMBRE, 
                    //MAP_NOMBREZONA:objSector.NOMBRE,
                    CODIGOZONA:objSector.CODIGOZONA,
                    CODIGOUNIDAD: objSector.CECO,
                    FECHACREACION: new Date(),
                    IDUSUARIO:user.ID,
                    ACTUALIZADO:1,
                    BAJA:0
                };
                copyJsonToXone(sectorContentObj,jsonObject);
                sectorContent.addItem(sectorContentObj);
                if (self.MAP_RECORDSTATE!='CREATE') {
                    await sectorContentObj.save();
                }
            }
        }        
        sectorContent.lock();
        // ui.refresh("MAP_SDATACONTENT");

        var comiteContentSave = await objSelf.getContents('ComiteRelacionadoEdit');
        var stCodComiteContentSaver="";
        for (i = 0;i <=comiteContentSave.getCount()-1 ;i++) {
            stCodComiteContentSaver=addString(stCodComiteContentSaver, "'"+(await comiteContentSave.getItem(i)).CODIGOCOMITE+"'", ",");
        }
        var relComitteeContent = await objSelf.getContents('CDataContent');
        relComitteeContent.unlock();
        relComitteeContent.setMacro("##CCIDNIVELPADRE##", objSelf.MAP_REGIONCOMMITTEE);
        relComitteeContent.clear();
        await relComitteeContent.loadAll();
        relComitteeContent.lock();
        for (i = 0;i <=relComitteeContent.getCount()-1 ;i++) {
            var objRelComitteer=await relComitteeContent.getItem(i);
            if (objRelComitteer.ROWID==='c53f665f-90e4-456d-b48d-b91b0ae6c966')
                var stop=1;
            if (!stCodComiteContentSaver.includes(objRelComitteer.ROWID)) {
                if (objSelf.MAP_REGIONCODE=="CCE") {
                    if (objRelComitteer.MAP_NIVEL==1 || objRelComitteer.MAP_NIVEL==2) {
                        let comiteContentSaveObj=await comiteContentSave.createObject();
                        jsonObject={
                            ORDEN:i,
                            CODIGOSITUACION:objSelf.CODIGO,
                            CODIGOCOMITE:objRelComitteer.ROWID,
                            IDSUPLENTE:objRelComitteer.IDSUPLENTE,
                            IDTITULAR:objRelComitteer.IDTITULAR,
                            DISP_SUPLENTE: 0,   
                            DISP_TITULAR: 0,
                            FECHACREACION: new Date(),
                            IDUSUARIO:user.ID,
                            ACTUALIZADO:1,
                            BAJA:0
                        };
                        copyJsonToXone(comiteContentSaveObj,jsonObject);
                        comiteContentSave.addItem(comiteContentSaveObj);
                        if (objSelf.MAP_RECORDSTATE!='CREATE') {
                            await comiteContentSaveObj.save();
                        }
                    } 
                } else {
                    let comiteContentSaveObj=await comiteContentSave.createObject();
                    jsonObject={
                        ORDEN:i,
                        CODIGOSITUACION:objSelf.CODIGO,
                        CODIGOCOMITE:objRelComitteer.ROWID,
                        IDSUPLENTE:objRelComitteer.IDSUPLENTE,
                        IDTITULAR:objRelComitteer.IDTITULAR,
                        DISP_SUPLENTE: 0,   
                        DISP_TITULAR: 0,
                        FECHACREACION: new Date(),
                        IDUSUARIO:user.ID,
                        ACTUALIZADO:1,
                        BAJA:0
                    };
                    copyJsonToXone(comiteContentSaveObj,jsonObject);
                    comiteContentSave.addItem(comiteContentSaveObj);
                    if (objSelf.MAP_RECORDSTATE!='CREATE') {
                        await comiteContentSaveObj.save();
                    }
                }
            }else{
                for (var j = 0;j <=comiteContentSave.getCount()-1 ;j++) {
                    var objExistRelComitteer=await comiteContentSave.getItem(j);
                    if (objExistRelComitteer.CODIGOCOMITE===objRelComitteer.ROWID) {
                        objExistRelComitteer.ORDEN=i;
                        await objExistRelComitteer.save();
                        break;
                    }
                }
            }
        } 
        
        zonesContent.lock();
        sectorContent.lock();
        ui.refresh("MAP_ZDATACONTENT","MAP_SDATACONTENT");
        // ui.refresh("SDataContent,MAP_SDATACONTENT,ZDataContent,MAP_ZDATACONTENT,CDataContent,MAP_CDATACONTENT");
        // ui.refresh("ZDataContent,MAP_ZDATACONTENT,CDataContent,MAP_CDATACONTENT");
    
        ui.hideWaitDialog();

    }catch (e) {
        ui.hideWaitDialog();
    } 
      
}

async function onEditorAction(objSelf) {
    
    switch (objSelf.getOwnerCollection().getName()) {
        case "SeguimientoPlanificada":
            await applyFilters(objSelf, "SeguimientoSituacionVigente", "DataContent", "MAP_DATACONTENT", 0, 'SeguimientoSituacionVigenteContador');
            break;
        case "SeguimientoEnCurso":
            await applyFilters(objSelf, "SeguimientoSituacionVigente", "DataContent", "MAP_DATACONTENT", 0, 'SeguimientoSituacionVigenteContador');
            break;
        case "HistoricoSituaciones":
            await applyFilters(objSelf, "HistoricoSituaciones", "DataContent", 'MAP_DATACONTENT', 0, 'HistoricoSituacionContador');
            break;
        case "ContactosListado":
            await applyFilters(objSelf, "Contacto", "ContactosListMaestro", 'ContactosListMaestro', 0, 'ContactosListMaestroContador');
            break;
        case "RepositorioListado":
            await applyFilters(objSelf, "Repositorio", "Repositorio", 'Repositorio', 0, 'RepositorioContador');
            break;
        case "UsuariosListado":
            await applyFilters(objSelf, "Usuarios", "UsuariosListMaestro", 'UsuariosListMaestro', 0, 'UsuariosListMaestroContador');
            break;
        case "ComitesListadoNivel1":
            await applyFilters(objSelf, "Comite", "DataContent", "MAP_DATACONTENT", objSelf.MAP_TIPO_NIVEL);
            break;
        case "RegionesListado":
            await applyFilters(objSelf, "Region", "DataContent", "MAP_DATACONTENT");
            break;
        case "ZonasListado":
            await applyFilters(objSelf, "ZonaOrganizativa", "DataContent", "MAP_DATACONTENT", 0, "ZonaOrgListContador");
            break;
        case "UnidadesListado":
            await applyFilters(objSelf, "UnidadOrganizativa", "DataContent", "MAP_DATACONTENT", 0, "UnidadOrgListContador");
            break;
        case "CausasListado":
            await applyFilters(objSelf, "Causa", "DataContent", "MAP_DATACONTENT");
            break;
        case "TrazabilidadListado":
            await applyFilters(objSelf, "TrazabilidadSeguridad", "TrazabilidadSeguridad", "TrazabilidadSeguridad");
            break;    
            
            
    }
}
   
async function AbrirMenuTeamsMeet(objSelf){
    try{
        var collSituaciones = await objSelf.getContents("SituacionesContent");
        var objSeleccionado = null;
        var numElementosSelecionados = 0;
        let objCreatTeams;
        
        if (objSelf.getOwnerCollection().getName()=='Inicio') {
            for(var i=0; i < collSituaciones.getCount(); i++){
                var item = await collSituaciones.getItem(i);
                if(item.MAP_SEL == 1){
                    if(numElementosSelecionados == 0){
                        numElementosSelecionados++;
                        objSeleccionado = item;
                    }else{
                        // hay mas de 1.
                        objSeleccionado = null;
                        break;
                    }
                }
            }
            objCreatTeams=await (await appData.getCollection("MenuCrearTeamMeet")).createObject();
            (await appData.getCollection("MenuCrearTeamMeet")).addItem(objCreatTeams);
            objCreatTeams.MAP_SITUACION_SELECCIONADA_O = objSeleccionado;
        } else {
            collSituaciones = (await appData.getCollection("SituacionVigenteScript")).createClone();
            objSeleccionado=await collSituaciones.findObject("s.ID="+objSelf.ID);
            objCreatTeams=await (await appData.getCollection("MenuCrearTeamMeetSituacion")).createObject();
            (await appData.getCollection("MenuCrearTeamMeetSituacion")).addItem(objCreatTeams);
            objCreatTeams.MAP_SITUACION_SELECCIONADA_O = objSeleccionado;
            objCreatTeams.MAP_EDITABLE=0;
        }
        ui.openEditView(objCreatTeams);
        // appData.pushValue(objCreatTeams);
    }catch (e) {
        var sterror=e.message;
        // writelogExceptionJSv2(" AbrirMenuTeamsMeet. ERROR: "+sterror,"funciones.js",false);   
    }
}

function PrepararMenuCrearTeamMeet(objSelf){
    try{
        teamMeetsNivelesSeleccionados = [];
        teamMeetsCargosSeleccionados = [];
        teamMeetsCorreosSeleccionados = [];
        
        objSelf.MAP_EDITABLE = 1;
        
        var objSeleccionado = objSelf.MAP_SITUACION_SELECCIONADA_O;
        if(objSeleccionado != null){
            // rellenamos el combo y los demas datos, y lo bloqueamos ....
            objSelf.MAP_SITUACION_NOMBRE = objSeleccionado.MAP_NOMBRE;
            objSelf.MAP_SITUACION_REGION = objSeleccionado.MAP_TIPOREGION;
            objSelf.MAP_SITUACION_FECHAINICIO = objSeleccionado.FECHAINICIO;
            objSelf.MAP_SITUACION_FECHAFINESTIMADA = objSeleccionado.FECHAFINESTIMADA;
            objSelf.MAP_IDSITUACION = objSeleccionado.ID;
            objSelf.MAP_EDITABLE = 0;
        } else {
            if (isNothing(objSelf.MAP_MSGCODE) || objSelf.MAP_MSGCODE.length==0) {
                objSelf.MAP_MSGCODE = CreateGuid();
            }
        }
        
        
        
    }catch (e) {
        var sterror=e.message;
        // writelogExceptionJSv2(" PrepararMenuCrearTeamMeet. ERROR: "+sterror,"funciones.js",false);   
    }
}

async function CrearTeamsMeet(objSelf){
    try{
        if(objSelf.MAP_IDSITUACION == 0){
            var response=await userMsgBox("Seleciona una situación extraordinaria", "¡Aviso!", 0,"#e04c41");
            return;
        }
        
        let extraSituationsColl = await appData.getCollection("SituacionExtraordinaria");
        let extraSituationObj = await extraSituationsColl.findObject("s.ID= " + objSelf.MAP_IDSITUACION );
        
        if(extraSituationObj != null){
            // createTeamsMeetDeepLinkForSituation(extraSituationObj);
            await createTeamsMeetDeepLinkForSituationFromEmails(extraSituationObj,teamMeetsCorreosSeleccionados);
        }
    }catch (e) {
        var sterror=e.message;
        // writelogExceptionJSv2(" CrearTeamsMeet. ERROR: "+sterror,"funciones.js",false);   
    }
}

async function fBeforeEditDisponibilidadListado(objSelf){
    try {
        var dispoContent = await objSelf.getContents('ComiteRelacionadoEditDisponibilidad');
        dispoContent.unlock();
        dispoContent.clear();
        var stMacro="(st.BAJA=0 AND st.ESTADO!='0020' AND (ca.IDSUPLENTE="+user.ID+" OR ca.IDTITULAR="+user.ID+"))";
        dispoContent.setMacro("##MACRO##", stMacro);        
        // dispoContent.setLinkFilter(stMacro);
        // dispoContent.setSort("ca.ORDEN ASC");
        await dispoContent.loadAll();
        //ui.showToast(dispoContent.getCount());
        dispoContent.lock();
    
        // var dispoContent = objSelf.getContents('ComiteRelacionadoEditDisponibilidad');
        // dispoContent.unlock();
        // dispoContent.clear();
        // var stMacro="(53434 3 st.BAJA=0 AND st.ESTADO!='0001' AND (ca.IDSUPLENTE="+user.ID+" OR ca.IDTITULAR="+user.ID+"))";
        // dispoContent.setMacro("##MACRO##", stMacro);        
        // dispoContent.loadAll();
        // ui.showToast(dispoContent.getCount());
        // dispoContent.lock();
        // //changeAvaibilityStateBG(objCrearDisponibility,objCrearDisponibility.MAP_DISPONIBLEINICIAL);
    }catch (e) {
        var sterror=e.message;
        // writelogExceptionJSv2(" isBloqueado. ERROR: "+sterror,"funciones.js",false);   
    }
}

async function changeAvaibilityStateBT(objSelf,iSelectedAvaibility) {
    try {
        if (iSelectedAvaibility ==1) {
            objSelf.MAP_DISPOBG="#358717";
            //cambiarAtributoProp(objSelf,"MAP_DISPO","bgcolor","#358717");
            if (objSelf.MAP_NODISPOBG == '#cc0000') {
                //objSelf.MAP_NODISPOBG = '#6f6f6f';
                //cambiarAtributoProp(objSelf,"MAP_NODISPO","bgcolor","##6f6f6f");
                objSelf.MAP_NODISPOBG="#6f6f6f";
                
            }
            objSelf.MAP_DISPONIBLE = 1;
        } else if (iSelectedAvaibility == 2) {
            //objSelf.MAP_NODISPOBG = '#cc0000';
            objSelf.MAP_NODISPOBG="#cc0000";
            //cambiarAtributoProp(objSelf,"MAP_NODISPO","bgcolor","#cc0000");
            if (objSelf.MAP_DISPOBG == '#358717') {
                //objSelf.MAP_DISPOBG = '#MAP_DISPOBG';
                cambiarAtributoProp(objSelf,"MAP_DISPO","bgcolor","#6f6f6f");
                objSelf.MAP_DISPOBG="#6f6f6f";
            }
            objSelf.MAP_DISPONIBLE = 2;
        }
        // var view=ui.getView(objSelf);
        // if (view)
        //     view.refresh("MAP_DISPO","MAP_DISPOPULSADO","MAP_NODISPO","MAP_NODISPOPULSADO");
        await saveCrearDisponibilidad(objSelf);
        ui.getView(objSelf.getParent()).refreshContentRow("ComiteRelacionadoEditDisponibilidad",objSelf.getObjectIndex());
        // var view=ui.getView(objSelf);
        // if (view)
        //     view.refresh("MAP_DISPO,MAP_NODISPO");
    }catch (e) {
        var sterror=e.message;
        // writelogExceptionJSv2(" changeAvaibilityStateBT. ERROR: "+sterror,"funciones.js",false);   
    }         
}

async function saveCrearDisponibilidad(objComiteRelacionadoEdit){ 
    try {
        await saveTrazaDisponibilidad(objComiteRelacionadoEdit,objComiteRelacionadoEdit.CODIGOSITUACION,objComiteRelacionadoEdit.CODIGOCOMITE);
        // aqui ahora tenemos que anotar los cambios: nuevo titular, nuevo suplente y limpiar las disponibilidades....
        // cambio de titular: quitamos disposnibilidad y ponemos el nuevo usuario
        if (objComiteRelacionadoEdit.IDTITULAR==user.ID){
            objComiteRelacionadoEdit.FDISP_TITULAR=new Date();
            objComiteRelacionadoEdit.DISP_TITULAR=objComiteRelacionadoEdit.MAP_DISPONIBLE;
            if (objComiteRelacionadoEdit.DISP_TITULAR===1) 
                objComiteRelacionadoEdit.MAP_ICONTITULAR='disponible.png';
            else if (objComiteRelacionadoEdit.DISP_TITULAR===2) 
                objComiteRelacionadoEdit.MAP_ICONTITULAR='noDisponible.png';
            else
                objComiteRelacionadoEdit.MAP_ICONTITULAR='desconocido.png';
        }else if (objComiteRelacionadoEdit.IDSUPLENTE==user.ID){
            objComiteRelacionadoEdit.FDISP_SUPLENTE=new Date();
            objComiteRelacionadoEdit.DISP_SUPLENTE=objComiteRelacionadoEdit.MAP_DISPONIBLE;
            if (objComiteRelacionadoEdit.DISP_SUPLENTE===1) 
                objComiteRelacionadoEdit.MAP_ICONSUPLENTE='disponible.png';
            else if (objComiteRelacionadoEdit.DISP_SUPLENTE===2) 
                objComiteRelacionadoEdit.MAP_ICONSUPLENTE='noDisponible.png';
            else
                objComiteRelacionadoEdit.MAP_ICONSUPLENTE='desconocido.png';
        }
        await objComiteRelacionadoEdit.save();
        replica.start();
    }catch (e) {
        var sterror=e.message;
        // writelogExceptionJSv2(" saveCrearDisponibilidad. ERROR: "+sterror,"funciones.js",false);   
    } 
}

async function saveTrazaDisponibilidad(objSelf,stCodigoSituacion,stCodigoComite){
    try {
        var collTraza=await appData.getCollection("TrazaDisponibilidad");
        var objTraza=await collTraza.createObject();
        objTraza.CODIGOSITUACION=stCodigoSituacion;
        objTraza.CODIGOCOMITE=stCodigoComite;
        objTraza.DISPONIBILIDAD=objSelf.MAP_DISPONIBLE;
        if (objSelf.IDTITULAR==user.ID)
            objTraza.IDTITULAR=objSelf.IDTITULAR;
        else if (objSelf.IDSUPLENTE==user.ID)
            objTraza.IDSUPLENTE=objSelf.IDSUPLENTE;
        else
            writeLogFunctionJSv2("saveTrazaComiteAfectado. Sin titular ni suplente: "+user.ID+" Situacion: "+stCodigoSituacion+" - COmite: "+stCodigoComite,"funciones.js",1,10);   
        //objTraza.IDUSUARIO=user.ID;
        await objTraza.save();
    }catch (e) {
        var sterror=e.message;
        // writelogExceptionJSv2(" saveTrazaComiteAfectado. ERROR: "+sterror,"funciones.js",false);   
    } 
}

async function eliminarDato(objSelf,coll) {
    
    try {
        let response; 
        if (objSelf.ID===0){
            response=await userMsgBox("No se puede eliminar un elemento no guardado", "AVISO",0,"#e04c41");  
        } else {
            if (coll=='SituacionExtraordinaria') {
                response=await userMsgBox("¿Está seguro de que desea eliminar esta situación extraordinaria?", "ATENCIÓN", 3,"#e04c41");
                if(response==1) {
                    objSelf.MAP_OBJINI.MAP_ELIMINAR=99;
                    objSelf.BAJA=1;
                    await objSelf.save();
                    objSelf.MAP_REFRESHATRAS = 1;
                    objSelf.MAP_OBJINI.MAP_REFRESHATRAS = 1;
                    await objSelf.executeNode("onBack");
                }
            } else if (coll=='Contacto') {
                response=await userMsgBox("¿Está seguro de que desea eliminar este contacto?", "ATENCIÓN", 3,"#e04c41");
                if(response==1) {
                    objSelf.BAJA=1;
                    await objSelf.save();
                    objSelf.MAP_PARENT.MAP_CAMBIOS=1;
                    await objSelf.executeNode("onBack");
                }
            } else if (coll=='Repositorio') {
                response=await userMsgBox("¿Está seguro de que desea eliminar este documento?", "ATENCIÓN", 3,"#e04c41");
                if(response==1) {
                    objSelf.BAJA=1;
                    await objSelf.save();
                    objSelf.getParent().MAP_CAMBIOS=1;
                    await objSelf.executeNode("onBack");
                }
            }
            
        }
    }catch (e) {
    } 
    
}/***
*
* Code from teamsFunctions.js
*
***/


var teamMeetsNivelesSeleccionados = [];
var teamMeetsCargosSeleccionados = [];
var teamMeetsCorreosSeleccionados = [];

async function createTeamsMeetDeepLinkForSituationFromEmails(situationObj, emails) {
    try {
        ui.showWaitDialog("Preparando convocatoria de Teams");
        var iMaxURLLength=2048;
        var uriaux="";
        var uri = "https://teams.microsoft.com/l/meeting/new?";
        var subject= APP_NAME+" - "+situationObj.MAP_NOMBRE;
        //var subject = APP_NAME+" - "+situationObj.MAP_NOMBRE.replace(/ /gi, '%20'); 
        subject=subject.replace(/ /gi, '%20'); 
        uri += "subject=" + subject; 
        
        // TODO: Poner para que obtenga los correos reales.
        var attendees = getAttendeesForSituationFromEmails(emails);
        
        var startDate = new Date();
        var endDate = addHours(startDate, 1);
        
        var startTime = addZero(startDate.getMonth()+1) + "%2F" + addZero(startDate.getDate()) + "%2F" + startDate.getFullYear() + "%20" 
            + addZero(startDate.getHours()) + "%3A" + addZero(startDate.getMinutes()) + "%3A" + addZero(startDate.getSeconds());
            
        var endTime = addZero(endDate.getMonth()+1) + "%2F" + addZero(endDate.getDate()) + "%2F" + endDate.getFullYear() + "%20" 
            + addZero(endDate.getHours()) + "%3A" + addZero(endDate.getMinutes()) + "%3A" + addZero(endDate.getSeconds());
        
        uri += "&startTime=" + startTime + "&endTime=" + endTime;
        
        var content = subject;
        
        uri += "&content=" + content;
        
        uriaux=uri + "&attendees=" + attendees;
        
        if (uriaux.length>iMaxURLLength){
            // aqui les mostramos que el tamaño supera el maximo disponible para una reunion de teams, 
            // pero tenemos que darle los correos para que copien y peguen...
            var response=await userMsgBox("El numero de destinatarios impide que se pueda generar la convocatoria de forma automática. \n\n ¿Desea copiar las direcciones de correo al portapapeles para incluirlas en una convocatoria manual? \n Si desea copiar las direcciones para incluirlas de forma manual debe seleccionar 'Si'. \n Posteriormente, en la reunión de Teams que se abrirá pegarlas con CONTROL+V en la sección 'Agregue asistentes requeridos'.", "AVISO", 3,"#e04c41");
          	if( response != 1){
          	    return;
            }else{
                await doSetText(attendees);
                ui.openUrl(uri);
            }           
        }else{
            ui.openUrl(uriaux);
        }
        

    }catch (e) {
        var sterror=e.message;
        writelogExceptionJSv2(" createTeamsMeetDeepLinkForSituation. ERROR: "+sterror,"teamsFunctions.js",false);   
    } finally{
        ui.hideWaitDialog();
    }
}

async function createTeamsMeetDeepLinkForSituation(situationObj) {
    try {
        ui.showWaitDialog("Preparando convocatoria de Teams");
        var iMaxURLLength=2048;
        var uriaux="";
        var uri = "https://teams.microsoft.com/l/meeting/new?";
        var subject= APP_NAME+" - "+situationObj.MAP_NOMBRE;
        //var subject = APP_NAME+" - "+situationObj.MAP_NOMBRE.replace(/ /gi, '%20'); 
        subject=subject.replace(/ /gi, '%20'); 
        uri += "subject=" + subject; 
        
        // TODO: Poner para que obtenga los correos reales.
        var attendees = await getAttendeesForSituation(situationObj);
        
        var startDate = new Date();
        var endDate = addHours(startDate, 1);
        
        var startTime = addZero(startDate.getMonth()+1) + "%2F" + addZero(startDate.getDate()) + "%2F" + startDate.getFullYear() + "%20" 
            + addZero(startDate.getHours()) + "%3A" + addZero(startDate.getMinutes()) + "%3A" + addZero(startDate.getSeconds());
            
        var endTime = addZero(endDate.getMonth()+1) + "%2F" + addZero(endDate.getDate()) + "%2F" + endDate.getFullYear() + "%20" 
            + addZero(endDate.getHours()) + "%3A" + addZero(endDate.getMinutes()) + "%3A" + addZero(endDate.getSeconds());
        
        uri += "&startTime=" + startTime + "&endTime=" + endTime;
        
        var content = subject;
        
        uri += "&content=" + content;
        
        uriaux=uri + "&attendees=" + attendees;
        
        // uri += "&attendees=" + attendees;
        
        if (uriaux.length>iMaxURLLength){
            // aqui les mostramos que el tamaño supera el maximo disponible para una reunion de teams, 
            // pero tenemos que darle los correos para que copien y peguen...
            var response=await userMsgBox("El numero de destinatarios impide que se pueda generar la convocatoria de forma automática. \n\n ¿Desea copiar las direcciones de correo al portapapeles para incluirlas en una convocatoria manual? \n Si desea copiar las direcciones para incluirlas de forma manual debe seleccionar 'Si'. \n Posteriormente, en la reunión de Teams que se abrirá pegarlas con CONTROL+V en la sección 'Agregue asistentes requeridos'.", "AVISO", 3,"#e04c41");
          	if( response != 1){
          	    return;
            }else{
                await doSetText(attendees);
                ui.openUrl(uri);
            }           
        }else{
            ui.openUrl(uriaux);
        }
        
        
        // ui.openUrl(uri);

    }catch (e) {
        var sterror=e.message;
        writelogExceptionJSv2(" createTeamsMeetDeepLinkForSituation. ERROR: "+sterror,"teamsFunctions.js",false);   
    } finally{
        ui.hideWaitDialog();
    }
}

async function getAttendeesForSituation(objSelf) {
    try {
         var count=0;
         var stUserEmail="";
        var comiteContentSave = await objSelf.getContents('ComiteRelacionadoEdit');
        comiteContentSave.setMacro("##MACRO##", "ca.CODIGOSITUACION='" + objSelf.CODIGO + "'");
        await comiteContentSave.loadAll();
        for (var i = 0;i <=comiteContentSave.getCount()-1 ;i++) {
            var objComiteSave=await comiteContentSave.getItem(i);
            if (isValidEmail(objComiteSave.MAP_TITULAREMAIL)){
                if (!stUserEmail.includes(objComiteSave.MAP_TITULAREMAIL)) {
                    if(jsconst_oper.prod)
                        stUserEmail=addString(stUserEmail,objComiteSave.MAP_TITULAREMAIL,",");
                    else
                        stUserEmail=addString(stUserEmail,"XX"+objComiteSave.MAP_TITULAREMAIL,",");
                    count++;
                }
            }
            if (isValidEmail(objComiteSave.MAP_SUPLENTEEMAIL)){
                if (!stUserEmail.includes(objComiteSave.MAP_SUPLENTEEMAIL)) {
                    if(jsconst_oper.prod)
                        stUserEmail=addString(stUserEmail,objComiteSave.MAP_SUPLENTEEMAIL,",");
                    else
                        stUserEmail=addString(stUserEmail,"XX"+objComiteSave.MAP_SUPLENTEEMAIL,",");
                    count++;
                }
            }
        }
        //if (stUserEmail.endsWith(",")) {
        //    stUserEmail = stUserEmail.slice(0, -1);
        //}
        return stUserEmail;
        
    }catch (e) {
        var sterror=e.message;
        // writelogExceptionJSv2(" getAttendeesForSituation. ERROR: "+sterror,"teamsFunctions.js",false);
        return "";
    } 
}

function isValidEmail(stEmail) {
    try {
        if (stEmail === 'Correo Desconocido')
            return false;
        if (stEmail.indexOf('@') < 0)
            return false;
        return true;
        
    } catch (e) {
        var sterror = e.message;
        writelogExceptionJSv2(" isValidEmail. ERROR: "+sterror, "teamsFunctions.js", false); 
        return false;
    } 
}

async function selecteditemNivelessituacionTeamMeet(objSelf){
    try {
        if (isBloqueado(objSelf))
            return;
        if (objSelf.MAP_ISSELECTED==0) {
            objSelf.MAP_ISSELECTED=1;
            teamMeetsNivelesSeleccionados.push(objSelf.ID_NIVEL);
        } else {
            objSelf.MAP_ISSELECTED=0;
            if(teamMeetsNivelesSeleccionados.indexOf(objSelf.ID_NIVEL) != -1){
                teamMeetsNivelesSeleccionados.splice(teamMeetsNivelesSeleccionados.indexOf(objSelf.ID_NIVEL),1);
            }
        }
        
        // let view = ui.getView(objSelf.getParent());
        // if(view != null){
        //     view.refreshContentRow("NivelesLoadall",objSelf.getObjectIndex());
        // }
        
        await CargarCargos(objSelf.getParent());
        
        ui.refresh("ComiteRelacionadoTeamMeet,CorreosTeamMeet");

    }catch (e) {
        var sterror=e.message;
        writelogExceptionJSv2(" selecteditemNivelessituacionTeamMeet. ERROR: "+sterror,"funciones.js",false);   
    } 
}

function SeleccionarCorreoTeamMeet(objSelf){
    try {
        if (isBloqueado(objSelf))
            return;
        if (objSelf.MAP_ISSELECTED==0) {
            objSelf.MAP_ISSELECTED=1;
            teamMeetsCorreosSeleccionados.push(objSelf.MAP_EMAIL);
        } else {
            objSelf.MAP_ISSELECTED=0;
            if(teamMeetsCorreosSeleccionados.indexOf(objSelf.MAP_EMAIL) != -1){
                teamMeetsCorreosSeleccionados.splice(teamMeetsCorreosSeleccionados.indexOf(objSelf.MAP_EMAIL),1);
            }
        }
        
        // let view = ui.getView(objSelf.getParent());
        // if(view != null){
        //     view.refreshContentRow("CorreosTeamMeet",objSelf.getObjectIndex());
        // }
        
    }catch (e) {
        var sterror=e.message;
        writelogExceptionJSv2(" SeleccionarCorreoTeamMeet. ERROR: "+sterror,"funciones.js",false);   
    } 
}

async function SeleccionarCargoTeamMeet(objSelf){
    try {
        if (isBloqueado(objSelf))
            return;
        if (objSelf.MAP_ISSELECTED==0) {
            objSelf.MAP_ISSELECTED=1;
            teamMeetsCargosSeleccionados.push(objSelf.MAP_ID_CARGO);
        } else {
            objSelf.MAP_ISSELECTED=0;
            if(teamMeetsCargosSeleccionados.indexOf(objSelf.MAP_ID_CARGO) != -1){
                teamMeetsCargosSeleccionados.splice(teamMeetsCargosSeleccionados.indexOf(objSelf.MAP_ID_CARGO),1);
            }
        }
        
        // let view = ui.getView(objSelf.getParent());
        // if(view != null){
        //     view.refreshContentRow("ComiteRelacionadoTeamMeet",objSelf.getObjectIndex());
        // }
        
        await CargarCorreos(objSelf.getParent());
        
        ui.refresh("CorreosTeamMeet");
    }catch (e) {
        var sterror=e.message;
        writelogExceptionJSv2(" SeleccionarCargoTeamMeet. ERROR: "+sterror,"funciones.js",false);   
    } 
}

async function CargarCargos(parent){
    
    let content = await parent.getContents("ComiteRelacionadoTeamMeet");
    content.unlock();
    content.clear();
    if (teamMeetsNivelesSeleccionados.length>0) { 
        content.setMacro("##MACRO##","ca.codigosituacion like '"+parent.MAP_SITUACION_CODIGO+"' AND c.IDNIVEL IN ("+teamMeetsNivelesSeleccionados.join(",")+")");
    } else {
        content.setMacro("##MACRO##","1=0");
    }
    await content.loadAll();
    content.lock();
    
    //recorremos para obtener los id, ya que por defecto estan todos seleccionados.
    teamMeetsCargosSeleccionados = [];
    
    for(let i=0;i < content.getCount();i++){
        let item = await content.getItem(i);
        if(item.MAP_ISSELECTED == 1){
            teamMeetsCargosSeleccionados.push(item.MAP_ID_CARGO);
        }
    }
    
    await CargarCorreos(parent);
}

async function CargarCorreos(parent){
    
    let content = await parent.getContents("CorreosTeamMeet");
    content.unlock();
    content.clear();
    if (teamMeetsCargosSeleccionados.length>0) { 
        content.setMacro("##MACRO##","ca.codigosituacion like '"+parent.MAP_SITUACION_CODIGO+"' AND c.ID IN ("+teamMeetsCargosSeleccionados.join(",")+")");
    } else {
        content.setMacro("##MACRO##","1=0");
    }
    await content.loadAll();
    content.lock();
    
    //recorremos para obtener los id, ya que por defecto estan todos seleccionados.
    teamMeetsCorreosSeleccionados = [];
    
    for(let i=0;i < content.getCount();i++){
        let item = await content.getItem(i);
        if(item.MAP_ISSELECTED == 1){
            teamMeetsCorreosSeleccionados.push(item.MAP_EMAIL);
        }
    }
}

async function onchangesituacionTeamMeet(objSelf) {
    if (objSelf.MAP_SITUACION_CODIGOREGION.length!=0)
    {
        
        let niveles=await objSelf.getContents("NivelesLoadall");
        let nivel;
        
        if (objSelf.MAP_SITUACION_CODIGOREGION!=='CCE'){
            niveles.setMacro("##MACRO##","ID_NIVEL>1");
        }else{
            niveles.setMacro("##MACRO##","ID_NIVEL>0");
        }
        try {
            ui.showWaitDialog("Cargando cargos y personas");
            
            let contentCargo = await objSelf.getContents("ComiteRelacionadoTeamMeet");
            contentCargo.unlock();
            contentCargo.clear();
            contentCargo.lock();
            
            let contentCorreo = await objSelf.getContents("CorreosTeamMeet");
            contentCorreo.unlock();
            contentCorreo.clear();
            contentCorreo.lock(); 
            
            niveles.unlock();   
            niveles.clear();   
            await niveles.loadAll();
            niveles.lock();   
            
            
            let vernivel=await objSelf.getContents("ComiteScript");
            vernivel.setMacro("##MACRO1##",user.ID);
            vernivel.setMacro("##MACRO2##",objSelf.MAP_SITUACION_CODIGO);
            await vernivel.loadAll();
            if (vernivel.getCount()>0) {
                nivel=await vernivel.getItem(0);
            }
            if (nivel){
                let veces=0;
                for (let i=0; i<niveles.getCount()-1; i++) {
                    let objnivel=await niveles.getItem(i);
                    let valornivel=objnivel.ID_NIVEL;
                    if (nivel.IDNIVEL <= valornivel && veces<2) {
                        veces=veces+1;
                        await selecteditemNivelessituacionTeamMeet(objnivel);
                    }
                }
            } else {
                ui.showToast("No pertenece al organigrama de la situación.");
            }
            ui.hideWaitDialog();
        } catch(e) {
            ui.hideWaitDialog();
        }
        ui.refresh("NivelesLoadall,ComiteRelacionadoTeamMeet,CorreosTeamMeet");
    }
}

function isBloqueado(objSelf){
    try {
        var objParent=objSelf.getParent();
        if  (objParent.MAP_BLOQUEADO===1){
            return true;
        }
        return false;
    }catch (e) {
        var sterror=e.message;
        writelogExceptionJSv2(" isBloqueado. ERROR: "+sterror,"funciones.js",false);   
        return true; // por si falla, bloqueado
        
    } 
}

function getAttendeesForSituationFromEmails(emails) {
    try {
        let stUserEmail="";
        
        for (var i = 0;i < emails.length ;i++) {
            let email = emails[i];
            if (isValidEmail(email)){
                if (!stUserEmail.includes(email)) {
                    if(jsconst_oper.prod)
                        stUserEmail=addString(stUserEmail,email,",");
                    else
                        stUserEmail=addString(stUserEmail,"XX"+email,",");
                }
            }
        }
        
        return stUserEmail;
        
    }catch (e) {
        var sterror=e.message;
        writelogExceptionJSv2(" getAttendeesForSituationFromEmails. ERROR: "+sterror,"teamsFunctions.js",false);
        return "";
    } 
}

async function getAttendeesForSituationOLD(situationObj)  {
    // TODO: Función que se encarga de obtener los correos correspondientes.
    let attendees = "";
    
    let affectedRegions = await appData.getCollection("ComiteRegionAfectada");
    let affectedZones = await appData.getCollection("ComiteZonaAfectada");
    let affectedUnits = await appData.getCollection("ComiteUnidadAfectada");
    
    
    affectedRegions.unlock();
    affectedRegions.setMacro("##MACRO##", "a.CODIGOSITUACION='" + situationObj.MAP_CODIGO + "'");
    await affectedRegions.loadAll();
    
    if (affectedRegions.count() > 0) {
        let affectedRegion = await affectedRegions.getItem(0);
        if (!isNothing(affectedRegion.MAP_TITULAREMAIL)) {
            attendees += affectedRegion.MAP_TITULAREMAIL;
        }
        
        if (!isNothing(affectedRegion.MAP_SUPLENTEEMAIL)) {
            attendees += ((attendees.length > 0) ? ',' : '') + affectedRegion.MAP_SUPLENTEEMAIL;
        }
            
        affectedZones.unlock();
        affectedZones.setMacro("##MACRO##", "c.IDNIVEL = " + (affectedRegion.MAP_NIVEL + 1) + " AND c.IDNIVELPADRE='" + affectedRegion.MAP_CODIGO 
            + "' AND (z.BAJA IS NULL OR z.BAJA = 0) AND a.CODIGOSITUACION='" + situationObj.MAP_CODIGO + "'");
        await affectedZones.loadAll();
        
        affectedUnits.unlock();
        
        var affectedZone, affectedUnit;
        for (let i = 0; i < affectedZones.count(); i++) {
            affectedZone = await affectedZones.getItem(i);
            
            if (!isNothing(affectedZone.MAP_TITULAREMAIL)) {
                attendees += ((attendees.length > 0) ? ',' : '') + affectedZone.MAP_TITULAREMAIL;
            }
            if (!isNothing(affectedZone,MAP_SUPLENTEEMAIL)) {
                attendees += ((attendees.length > 0) ? ',' : '') + affectedZone.MAP_SUPLENTEEMAIL;
            }
            
            affectedUnits.setMacro("##MACRO##", "c.IDNIVEL = " (affectedZone.MAP_NIVEL + 1) + " AND c.IDNIVELPADRE='" + affectedZone.MAP_CODIGO 
                + "' AND u.CODIGOZONA = '" + affectedZone.MAP_ZONACODIGO + "' AND (u.BAJA IS NULL OR u.BAJA = 0) AND a.CODIGOSITUACION='" + situationObj.MAP_CODIGO + "'");
            await affectedUnits.loadAll();
            
            for (let j = 0; j < affectedUnits.count(); j++) {
                affectedUnit = await affectedUnits.getItem(j);
                
                if (!isNothing(affectedUnit.MAP_TITULAREMAIL)) {
                attendees += ((attendees.length > 0) ? ',' : '') + affectedUnit.MAP_TITULAREMAIL;
                }
                if (!isNothing(affectedUnit,MAP_SUPLENTEEMAIL)) {
                    attendees += ((attendees.length > 0) ? ',' : '') + affectedUnit.MAP_SUPLENTEEMAIL;
                }
            }
        }
        
        affectedZones.setMacro("##MACRO##", "");
        affectedZones.lock();
        affectedUnits.setMacro("##MACRO##", "");
        affectedUnits.lock();
    }
    
    affectedRegions.setMacro("##MACRO##", "");
    affectedRegions.lock();
    return attendees;
}

async function AbrirMenuMensajes(objSelf){
    try{
        
        if (objSelf.MAP_MENSAJE.length!=0 || objSelf.MAP_FILEDESCRIPTION.length!=0 ) {

            // aqui para las llamadas desde el home
            var collSituaciones = await objSelf.getContents("SituacionesContent");
            var objSeleccionado = null;
            var numElementosSelecionados = 0;
            
            for(var i=0; i < collSituaciones.getCount(); i++){
                var item = await collSituaciones.getItem(i);
                if(item.MAP_SEL == 1){
                    if(numElementosSelecionados == 0){
                        numElementosSelecionados=1;
                        objSeleccionado = item;
                    }else{
                        numElementosSelecionados=2;
                        objSeleccionado = null;
                        break;
                    }
                }
            }
            var objCreatTeams;
            objCreatTeams = await (await appData.getCollection("MensajeDiarioABordo")).createObject();
            if (numElementosSelecionados==1) {
                objCreatTeams.CODIGO = CreateGuid();
                objCreatTeams.FILENAME=objSelf.MAP_FILENAME;
                objCreatTeams.FILEDESCRIPTION=objSelf.MAP_FILEDESCRIPTION;
                objCreatTeams.MENSAJETEXTO = objSelf.MAP_MENSAJE;
                objCreatTeams.FECHAMODIFICACION = new Date();
                objCreatTeams.FECHA = new Date();
                objCreatTeams.USUARIO= user.LOGIN;
                objCreatTeams.BAJA = 0;
                objCreatTeams.ACTUALIZADO = 1;
                objCreatTeams.SITUACIONCODIGO = objSeleccionado.MAP_CODIGO;
                await objCreatTeams.save();
                await objSelf.executeNode("executeAfterMensajes");
            } else {
                // objCreatTeams.MAP_SITUACIONNIVEL=getValueFromObjColl("TipoSituacionDisponible","ID","N","t.CODIGO IN ('Alerta')","t.ID DESC");;
                objCreatTeams.MAP_OBJINI = objSelf;
                objCreatTeams.MAP_SITUACION_SELECCIONADA_O = objSeleccionado;
                objCreatTeams.MAP_BLOQUEADO=0;
                objCreatTeams.MAP_NTEXT=objSelf.MAP_MENSAJE;
                objCreatTeams.MAP_FILENAME=objSelf.MAP_FILENAME;
                objCreatTeams.MAP_FILEDESCRIPTION=objSelf.MAP_FILEDESCRIPTION;
                objCreatTeams.FILENAME=objSelf.MAP_FILENAME;
                objCreatTeams.FILEDESCRIPTION=objSelf.MAP_FILEDESCRIPTION;
                objCreatTeams.MAP_ID_MENSAJE=-1;
                ui.openEditView(objCreatTeams);
            }
        } else {
            ui.showToast("Es obligatorio introducir un mensaje o adjunto");
        }    
    }catch (e) {
        var sterror=e.message;
        writelogExceptionJSv2(" AbrirMenuMensajes. ERROR: "+sterror,"funciones.js",false);   
    }
}/***
*
* Code from organization_structure.js
*
***/


async function addNewRecord(objSelf, existFilterCondition, collName, fromEditView, doRefresh) {
    let dataName = (collName == 'Usuarios') ? 'UsuariosMaestro' : 
        (collName == 'ZonaOrganizativa') ? 'ZonaOrganizativaMaestro' : 
        (collName == 'ComiteZonaAfectada') ? 'ZonaAfectada' : 
        (collName == 'ComiteUnidadAfectada') ? 'UnidadAfectada' : 
        (collName == 'ComiteRegionAfectada') ? 'RegionAfectada' : collName;
    
    let recordsColl = await appData.getCollection(dataName);
    recordsColl.clear();
    let recordObj = (existFilterCondition.length == 0) ? null : await recordsColl.findObject(existFilterCondition);
    
    if (!isNothing(recordObj)) {
        if (!fromEditView) {
            showMessage(objSelf, 'EXIST_RECORD', collName);
            return;
        } else {
            switch (collName) {
                case 'Nivel':
                    saveLevelRecord(objSelf, recordObj);
                    break;
                case 'Usuarios':
                    saveUserRecord(objSelf, recordObj);
                    break;
                case 'Comite':
                    saveComitteeRecord(objSelf, recordObj);
                    break;
                case 'Region':
                    saveRegionRecord(objSelf, recordObj);
                    break;
                case 'ZonaOrganizativa':
                    saveZoneRecord(objSelf, recordObj);
                    break;
                case 'UnidadOrganizativa':
                    saveUnitRecord(objSelf, recordObj);
                    break;
                case 'Causa':
                    saveReasonRecord(objSelf, recordObj);
                    break;
                case 'TipoUnidadOrganizativa':
                    saveOrgUnitRecord(objSelf, recordObj);
                    break;
                case 'SituacionExtraordinaria':
                    saveSituationRecord(objSelf, recordObj);
                    await saveReasonsTo(objSelf, recordObj);
                    await salvarUbicacionSituacion(objSelf);
                    
                    break;
                case 'TipoSituacion':
                    saveSituationTypeRecord(objSelf, recordObj);
                    break;
                case 'Estado':
                    saveStateRecord(objSelf, recordObj);
                    break;
                case 'UnidadAfectada':
                    saveAffectedUnitRecord(objSelf, recordObj);
                    break;
                case 'ComiteRegionAfectada':
                    await saveAffectedRegion(objSelf, recordObj);
                    ui.executeActionAfterDelay("updateRelatedComitee", 15);
                    break;
                case 'ComiteZonaAfectada':
                    await saveAffectedZone(objSelf, recordObj);
                    ui.executeActionAfterDelay("updateRelatedComitee", 15);
                    break;  
                case 'ComiteUnidadAfectada':
                    await saveAffectedUnit(objSelf, recordObj);
                    ui.executeActionAfterDelay("updateRelatedComitee", 15);
                    break;
                case 'MensajeDiarioABordo':
                    await saveMessageForSituation(objSelf, recordObj);
                    // createNewMessageForSituation(objSelf, recordsColl);
                    ui.executeActionAfterDelay("updateMessages", 1);
                    break;
                case 'SituacionDisponibilidad':
                    await saveAvaibilityForSituation(objSelf, recordObj);
                    break;
                case 'Contacto':
                    await saveContactRecord(objSelf, recordObj);
                    break;
                case 'ComiteRelacionadoEditScript':
                    await saveComiteRelacionadoRecord(objSelf, recordObj);
                    break;
            }
            await recordObj.save();
            if (collName=="SituacionExtraordinaria")
                objSelf.ID=recordObj.ID;
        }
    } else {
        switch (collName) {
            case 'Nivel':
                await createNewLevelRecord(objSelf, recordsColl);
                break;
            case 'Usuarios':
                await createNewUserRecord(objSelf, recordsColl);
                break;
            case 'Comite':
                await createNewComitteeRecord(objSelf, recordsColl);
                break;
            case 'Region':
                await createNewRegionRecord(objSelf, recordsColl);
                break;
            case 'ZonaOrganizativa':
                await createNewZoneRecord(objSelf, recordsColl);
                break;
            case 'UnidadOrganizativa':
                await createNewUnitRecord(objSelf, recordsColl);
                break;
            case 'Causa':
                await createNewReasonRecord(objSelf, recordsColl);
                break;
            case 'TipoUnidadOrganizativa':
                await createNewOrgUnitRecord(objSelf, recordsColl);
                break;
            case 'SituacionExtraordinaria':
                await createNewSituationRecord(objSelf, recordsColl);
                await addReasonsTo(objSelf, objSelf.MAP_CODIGO);
                await salvarUbicacionSituacion(objSelf);
                if (objSelf.MAP_SALVARCERRAR==0) {
                    objSelf.MAP_RECORDSTATE='EDIT';
                    await objSelf.executeNode("after-edit");
                }
                ui.showToast("Situación salvada correctamente.");
                break;
            case 'TipoSituacion':
                createNewSituationTypeRecord(objSelf, recordsColl);
                break;
            case 'Estado':
                await createNewStateRecord(objSelf, recordsColl);
                break;
            case 'UnidadAfectada':
                await createNewAffectedUnitRecord(objSelf, recordsColl);
                break;
            case 'ComiteRegionAfectada':
                await createNewAffectedRegion(objSelf.MAP_CODIGOSITUACION, objSelf.MAP_REGIONCODIGO, objSelf.MAP_IDTITULAR, objSelf.MAP_IDSUPLENTE, recordsColl);
                break;
            case 'ComiteZonaAfectada':
                await createNewAffectedZone(objSelf.MAP_CODIGOSITUACION, objSelf.MAP_ZONACODIGO, objSelf.MAP_IDTITULAR, objSelf.MAP_IDSUPLENTE, recordsColl);
                break;
            case 'ComiteUnidadAfectada':
                await createNewAffectedRegion(objSelf.MAP_CODIGOSITUACION, objSelf.MAP_UNIDAD, objSelf.MAP_IDTITULAR, objSelf.MAP_IDSUPLENTE, recordsColl);
                break;
            case 'MensajeDiarioABordo':
                await createNewMessageForSituation(objSelf, recordsColl);
                ui.executeActionAfterDelay("updateMessages", 1);
                break;
            case 'SituacionDisponibilidad':
                await createNewAvaibilityForSituation(objSelf, recordsColl);
                break;
            case 'Contacto':
                await createNewContactRecord(objSelf, recordsColl);
                break;
            case 'ComiteRelacionadoEditScript':
                createNewComiteRelacionadoRecord(objSelf, recordsColl);
                break;
        }
    }
    
    if (doRefresh) {
        let parent = objSelf.MAP_PARENT;
        if (!isNothing(parent)) {
            let dataContent = await parent.getContents("DataContent");
            dataContent.unlock();
            dataContent.clear();
            await dataContent.loadAll();
            dataContent.lock();
            parent.MAP_ROWSCOUNT = dataContent.count();
            parent.MAP_SELECTEDROWSCOUNT = 0;
            ui.getView(parent).refresh("DataContent,MAP_DATACONTENT,MAP_ROWSCOUNT,MAP_SELECTEDROWSCOUNT");
        }
    }
}
  
async function addNewRecordAndClose(objSelf, existFilterCondition, collName, fromEditView) {
    await addNewRecord(objSelf, existFilterCondition, collName, fromEditView);
    
    if (objSelf.getOwnerCollection().getName()=="SituacionExtraordinaria") {
        await objSelf.MAP_OBJINI.executeNode("executeAfter");
    }
    if (objSelf.getOwnerCollection().getName()=="Contacto") {
        await objSelf.MAP_PARENT.executeNode("executeAfter");
    }
    if (objSelf.getOwnerCollection().getName()=="ComiteRelacionadoEdit" ) {
        await objSelf.getParent().executeNode("executeAfter");
    }
    if (objSelf.getOwnerCollection().getName()=="Region") {
        await objSelf.MAP_PARENT.executeNode("executeAfter");
    }
    if (objSelf.getOwnerCollection().getName()=="MensajeDiarioABordo") {
        await objSelf.MAP_OBJINI.executeNode("executeAfterMensajes");
    }
    appData.failWithMessage(-8100, "##EXIT##");
}

async function deleteRecord(objSelf, collName) {
    if (!isNothing(objSelf)) {
        let msg = "¿Está seguro que desea eliminar este registro?";
        let toastMsg = "";
        switch (collName) {
            case 'Causa':
                msg += " Causa: " + objSelf.MAP_NOMBRE;
                toastMsg = "Causa: " + objSelf.MAP_NOMBRE + " eliminada.";
                break;
            case 'TipoSituacion':
                msg += " Tipo de Situación: " + objSelf.MAP_NOMBRE;
                toastMsg = "Tipo de Situación " + objSelf.MAP_NOMBRE + " eliminada.";
                break;
            case 'Estado':
                msg += " Estado: " + objSelf.MAP_NOMBRE;
                toastMsg = "Estado: " + objSelf.MAP_NOMBRE + " eliminado.";
        }
        //let msgResult = ui.msgBox(msg, "AVISO", 4);
        let response=await userMsgBox(msg, "AVISO", 1, "#e04c41");
        if (response === 1) {
            await objSelf.deleteObject();
            ui.showToast(toastMsg);
            
            let parent = objSelf.MAP_PARENT;
            if (!isNothing(parent)) {
                let dataContent = await parent.getContents("DataContent");
                dataContent.unlock();
                dataContent.clear();
                await dataContent.loadAll();
                dataContent.lock();
                ui.getView(parent).refresh("DataContent,MAP_DATACONTENT");
            }
            appData.failWithMessage(-8100, "##EXIT##");
        }
    }
}

async function createNewLevelRecord(objSelf, levelColl) {
    let levelObj = await levelColl.createObject({
        DESCRIPCION: objSelf.MAP_DESCRIPCION,
        CODIGO:  objSelf.MAP_CODIGO,
        BAJA: objSelf.MAP_BAJA,
        ACTUALIZADO: 1
    });
    levelColl.addItem(levelObj);
    await levelObj.save();
}

function saveLevelRecord(objSelf, levelRecord) {
    levelRecord.DESCRIPCION = objSelf.MAP_DESCRIPCION;
    levelRecord.CODIGO = objSelf.MAP_CODIGO;
    levelRecord.BAJA = objSelf.MAP_BAJA;
    levelRecord.ACTUALIZADO = 3;
}

async function createNewUserRecord(objSelf, usersColl) {
    let userObj = await usersColl.createObject({
        NOMBRE: objSelf.MAP_NOMBRE,
        EMAIL:  objSelf.MAP_EMAIL,
        DIRECCION: objSelf.MAP_DIRECCION,
        TELEFONO: objSelf.MAP_TELEFONO,
        LOGIN: objSelf.MAP_NUMEXP.trim(),
        USERTYPE: (objSelf.MAP_ISADMINUSER == 1) ? 'ADMIN' : '',
        BAJA: objSelf.MAP_BAJA,
        ACTUALIZADO: 1
    });
        
    usersColl.addItem(userObj);
    await userObj.save();
}

function saveUserRecord(objSelf, userObj) {
    userObj.NOMBRE = objSelf.MAP_NOMBRE;
    userObj.EMAIL = objSelf.MAP_EMAIL;
    userObj.TELEFONO = objSelf.MAP_TELEFONO;
    userObj.LOGIN = objSelf.MAP_NUMEXP.trim();
    userObj.USERTYPE = (objSelf.MAP_ISADMINUSER == 1) ? 'ADMIN' : '';
    userObj.BAJA = objSelf.MAP_BAJA;
    userObj.ACTUALIZADO = 3;
}

async function createNewComitteeRecord(objSelf, comitteesColl) {
    let comitteeObj = await comitteesColl.createObject({
        DESCRIPCION: objSelf.MAP_DESCRIPCION,
        CODIGO:  objSelf.MAP_CODIGO,
        IDNIVEL: objSelf.MAP_IDNIVEL,
        IDSUPLENTE: objSelf.MAP_IDSUPLENTE,
        IDTITULAR: objSelf.MAP_IDTITULAR,
        IDNIVELPADRE: objSelf.MAP_NIVELID,
        BAJA: objSelf.MAP_BAJA,
        ACTUALIZADO: 1
    });
        
    comitteesColl.addItem(comitteeObj);
    await comitteeObj.save();
}

function saveComitteeRecord(objSelf, comitteeObj) {
    comitteeObj.DESCRIPCION = objSelf.MAP_DESCRIPCION;
    comitteeObj.CODIGO = objSelf.MAP_CODIGO;
    comitteeObj.IDNIVEL = objSelf.MAP_IDNIVEL;
    comitteeObj.IDSUPLENTE = objSelf.MAP_IDSUPLENTE;
    comitteeObj.IDTITULAR = objSelf.MAP_IDTITULAR;
    comitteeObj.IDNIVELPADRE = objSelf.MAP_NIVELID;
    comitteeObj.BAJA = objSelf.MAP_BAJA;
    comitteeObj.ACTUALIZADO = 3;
}

async function createNewRegionRecord(objSelf, regionsColl) {
    let regionObj = await regionsColl.createObject({
        NOMBRE: objSelf.MAP_NOMBRE,
        CODIGO:  objSelf.MAP_CODIGO,
        FECHACREACION: new Date(),
        FECHAMODIFICACION: new Date(),
        USUARIOCREACION: user.ID,
        USUARIO: user.ID,
        BAJA: objSelf.MAP_BAJA,
        ACTUALIZADO: 1
    });
    regionsColl.addItem(regionObj);
    await regionObj.save();
}

function saveRegionRecord(objSelf, regionRecord) {
    regionRecord.NOMBRE = objSelf.MAP_NOMBRE;
    regionRecord.CODIGO = objSelf.MAP_CODIGO;
    regionRecord.IDNIVEL = objSelf.IDNIVEL;
    regionRecord.FECHAMODIFICACION = new Date(),
    regionRecord.USUARIO = user.ID;
    regionRecord.BAJA = objSelf.MAP_BAJA;
    regionRecord.ACTUALIZADO = 3;
}

async function createNewZoneRecord(objSelf, zoneColl) {
    let zoneObj = await zoneColl.createObject({
        NOMBRE: objSelf.MAP_NOMBRE,
        CODIGO:  objSelf.MAP_CODIGO,
        TIPOZONA: objSelf.MAP_TIPOID,
        CODIGOREGION: objSelf.MAP_REGIONID,
        BAJA: objSelf.MAP_BAJA,
        ACTUALIZADO: 1
    });
    zoneColl.addItem(zoneObj);
    await zoneObj.save();
}

function saveZoneRecord(objSelf, zoneRecord) {
    zoneRecord.NOMBRE = objSelf.MAP_NOMBRE;
    zoneRecord.CODIGO = objSelf.MAP_CODIGO;
    zoneRecord.TIPOZONA = objSelf.MAP_TIPOZONA;
    zoneRecord.CODIGOREGION = objSelf.MAP_CODIGOREG;
    zoneRecord.BAJA = objSelf.MAP_BAJA;
    zoneRecord.ACTUALIZADO = 3;
}

async function createNewUnitRecord(objSelf, unitColl) {
    let unitObj = await unitColl.createObject({
        NOMBRE: objSelf.MAP_NOMBRE,
        CECO:  objSelf.MAP_CODIGO,
        TIPOUNIDADORG: objSelf.MAP_TIPOID,
        IDZONA: objSelf.MAP_ZONAID,
        BAJA: objSelf.MAP_BAJA,
        IDNIVEL: objSelf.MAP_NIVELID,
        IDTITULAR: objSelf.MAP_IDTITULAR,
        IDSUPLENTE: objSelf.MAP_IDSUPLENTE,
        ACTUALIZADO: 1
    });
    unitColl.addItem(unitObj);
    await unitObj.save();
}

function saveUnitRecord(objSelf, unitRecord) {
    unitRecord.NOMBRE = objSelf.MAP_NOMBRE;
    unitRecord.CECO = objSelf.MAP_CODIGO;
    unitRecord.TIPOUNIDADORG = objSelf.MAP_TIPOID;
    unitRecord.IDZONA = objSelf.MAP_ZONAID;
    unitRecord.BAJA = objSelf.MAP_BAJA;
    unitRecord.IDNIVEL = objSelf.MAP_NIVELID;
    unitRecord.IDTITULAR = objSelf.MAP_IDTITULAR;
    unitRecord.IDSUPLENTE = objSelf.MAP_IDSUPLENTE;
    unitRecord.ACTUALIZADO = 3;
}

async function createNewReasonRecord(objSelf, reasonColl) {
    let reasonObj = await reasonColl.createObject({
        NOMBRE: objSelf.MAP_NOMBRE,
        CODIGO:  objSelf.MAP_CODIGO,
        ICON: objSelf.MAP_ICON,
        BAJA: objSelf.MAP_BAJA,
        ACTUALIZADO: 1
    });
    reasonColl.addItem(reasonObj);
    await reasonObj.save();
}

function saveReasonRecord(objSelf, reasonRecord) {
    reasonRecord.NOMBRE = objSelf.MAP_NOMBRE;
    reasonRecord.CODIGO = objSelf.MAP_CODIGO;
    reasonRecord.ICON = objSelf.MAP_ICON;
    reasonRecord.BAJA = objSelf.MAP_BAJA;
    reasonRecord.ACTUALIZADO = 3;
}

async function createNewOrgUnitRecord(objSelf, orgUnitColl) {
    let orgUnitObj = await orgUnitColl.createObject({
        NOMBRE: objSelf.MAP_NOMBRE,
        CODIGO:  objSelf.MAP_CODIGO,
        BAJA: objSelf.MAP_BAJA,
        ACTUALIZADO: 1
    });
    orgUnitColl.addItem(orgUnitObj);
    await orgUnitObj.save();
}

function saveOrgUnitRecord(objSelf, orgUnitRecord) {
    orgUnitRecord.NOMBRE = objSelf.MAP_NOMBRE;
    orgUnitRecord.CODIGO = objSelf.MAP_CODIGO;
    orgUnitRecord.BAJA = objSelf.MAP_BAJA;
    orgUnitRecord.ACTUALIZADO = 3;
}

async function createNewAffectedCommitteeRecord(committeeCode, situationCode, idTitular, idSuplente, currentDate, affectedCommitteeColl) {
    let affectedComitteeObj = await affectedCommitteeColl.createObject({
            CODIGOCOMITE: committeeCode,
            COMITEID: committeeCode,
            CODIGOSITUACION:  situationCode,
            IDTITULAR: idTitular,
            IDSUPLENTE: idSuplente,
            TITULARID: idTitular,
            SUPLENTEID: idSuplente,
            FECHACREACION: currentDate,
            FECHAMODIFICACION: currentDate,
            IDUSUARIO: user.ID,
            BAJA: 0,
            ACTUALIZADO: 1
        });
        
        affectedCommitteeColl.addItem(affectedComitteeObj);
        await affectedComitteeObj.save();
}

async function createRelatedCommittee(objSelf, situationCode, regionCode, regionsCommitteeCode) {
    let committeeColl = await appData.getCollection("Comite");
    //let regionCommitteeObj = committeeColl.findObject("c.CODIGO='" + regionsCommitteeCode + "'");
    let regionCommitteeObj = await committeeColl.findObject("c.ID='" + regionsCommitteeCode + "'");
    
    if (!isNothing(regionCommitteeObj)) {
        // Si existe un cargo del comité asociado a esta región se añade el comité relacionado a la 
        // situación.
        let affectedCommitteeColl = await appData.getCollection("ComiteAfectado");
        let currentDate = new Date();
        
        
        // Se añade el cargo de comité de la región como afectado para la situación.
        await createNewAffectedCommitteeRecord(regionsCommitteeCode, situationCode, regionCommitteeObj.MAP_IDTITULAR, regionCommitteeObj.MAP_IDSUPLENTE, currentDate, affectedCommitteeColl);
        
        // Se obtiene el comité relacionado a esa región.
        let relatedCommitteeColl = await appData.getCollection("ComiteRelacionado");
        relatedCommitteeColl.unlock();
        relatedCommitteeColl.setMacro("##CCIDNIVELPADRE##", regionCommitteeObj.ID);
        await relatedCommitteeColl.loadAll();
        
        // Se añaden los cargos del comité relacionado de la región como afectados para la situación.
        let relatedCommitteeObj;
        let relatedCommitteeCount = relatedCommitteeColl.getCount();
        for (let i = 0; i < relatedCommitteeCount; i++) {
            relatedCommitteeObj = await relatedCommitteeColl.getItem(i);
            await createNewAffectedCommitteeRecord(relatedCommitteeObj.ID, situationCode, relatedCommitteeObj.TITULARID, relatedCommitteeObj.SUPLENTEID, currentDate, affectedCommitteeColl);
        }
        affectedCommitteeColl.setMacro("##CCIDNIVELPADRE##", "");
        affectedCommitteeColl.clear();
        affectedCommitteeColl.lock();
    }
}

async function addAffectedAreasTo(objSelf, situationCode, regionCode) {
    let affectedRegions = await appData.getCollection("RegionAfectada");
    let affectedZones = await appData.getCollection("ZonaAfectada");
    let affectedUnits = await appData.getCollection("UnidadAfectada");
    
    let defaultAffectedRegions = await appData.getCollection("Region");
    defaultAffectedRegions.unlock();
    defaultAffectedRegions.setMacro("##MACRO##", "r.ID = '" + regionCode + "' AND (r.BAJA IS NULL OR r.BAJA = 0)");
    await defaultAffectedRegions.loadAll();
    
    if (defaultAffectedRegions.count() > 0) {
        let affectedRegion = await defaultAffectedRegions.getItem(0);
        let cceRegionID = (isIBDServer() == false) ? getDevEnvSetts().cceRegionid : getProdEnvSetts().cceRegionid;
        if (regionCode != cceRegionID) { 
            // Situación Extraordinaria: única región afectada la seleccionada previamente.
            await createNewAffectedRegion(situationCode, affectedRegion.MAP_CODIGO, affectedRegion.ID, affectedRegion.MAP_IDTITULAR, affectedRegion.MAP_IDSUPLENTE, affectedRegions);
        } else {
            // Situación Extraordinaria de CCE: todas las regiones seleccionadas previamente se consideran afectadas.
            let affectedRegionObj;
            let selectedRegions = await objSelf.getContents('RDataContent');
            for (let h = 0; h < selectedRegions.count(); h++) {
                affectedRegionObj = await selectedRegions.getItem(h);
                if (affectedRegionObj.MAP_ISSELECTED == 1) {
                    await createNewAffectedRegion(situationCode, affectedRegionObj.MAP_CODIGO, affectedRegionObj.ID, affectedRegionObj.MAP_IDTITULAR, affectedRegionObj.MAP_IDSUPLENTE, affectedRegions);
                }
            }
        }
        
        let selectedZones = await objSelf.getContents('ZDataContent');
        let selectedUnits = await objSelf.getContents('SDataContent');
        let affectedZone, affectedUnit;
        
        for (let i = 0; i < selectedZones.count(); i++) {
            affectedZone = await selectedZones.getItem(i);
            if (affectedZone.MAP_ISSELECTED == 1) {
                await createNewAffectedZone(situationCode, affectedZone.ID, affectedZone.MAP_CODIGO, affectedZones);
            }
        }
        
        for (let j = 0; j < selectedUnits.count(); j++) {
            affectedUnit = await selectedUnits.getItem(j);
            if (affectedUnit.MAP_ISSELECTED == 1) {
                await createNewAffectedUnit(situationCode, affectedUnit.MAP_CODIGO, affectedUnit.MAP_ZONAID, affectedUnit.IDTITULAR, affectedUnit.IDSUPLENTE, affectedUnits);
            }
        }
        await createRelatedCommittee(objSelf, situationCode, regionCode, affectedRegion.IDNIVEL);
    } 
}

async function saveAffectedAreasTo(objSelf, situationCode, regionCode) {
    let affectedRegions = await appData.getCollection("RegionAfectada");
    let affectedZones = await appData.getCollection("ZonaAfectada");
    let affectedUnits = await appData.getCollection("UnidadAfectada");
    
    affectedRegions.unlock();
    let affectedRegion = await affectedRegions.findObject("a.CODIGOSITUACION='" + situationCode + "'");

    if (!isNothing(affectedRegion)) {
        let affectedZone, affectedUnit;
        
        if (affectedRegion.CODIGOREGION != regionCode) {
            affectedRegion.BAJA = 1;
            
            affectedZones.unlock();
            affectedZones.setMacro("##MACRO##", "a.CODIGOSITUACION='" + situationCode + "' AND z.CODIGOREGION = '" + affectedRegion.CODIGOREGION + "' AND (a.BAJA IS NULL OR a.BAJA = 0)");
            await affectedZones.loadAll();
            
            for (let i = 0; i < affectedZones.count(); i++) {
                affectedZone = await affectedZones.getItem(i);
                affectedZone.BAJA = 1;
                await affectedZone.save();
            }
            
            affectedZones.setMacro("##MACRO##", "");
            affectedZones.lock();
            
            affectedUnits.unlock();
            affectedUnits.setMacro("##MACRO##", "a.CODIGOSITUACION='" + situationCode + "' AND z.CODIGOREGION = '" + affectedRegion.CODIGOREGION + "' AND (a.BAJA IS NULL OR a.BAJA = 0)");
            await affectedUnits.loadAll();
            
            for (let j = 0; j < affectedUnits.count(); j++) {
                affectedUnit = await affectedUnits.getItem(i);
                affectedUnit.BAJA = 1;
                await affectedZone.save();
            }
            
            affectedUnits.setMacro("##MACRO##", "");
            affectedUnits.lock();
            
            await affectedRegion.save();
            affectedRegions.lock();
            await addAffectedAreasTo(objSelf, situationCode, regionCode);
        } else {
            let selectedZones = await objSelf.getContents('ZDataContent');
            let selectedUnits = await objSelf.getContents('SDataContent');
            
            let cceRegionID = (isIBDServer() == false) ? getDevEnvSetts().cceRegionid : getProdEnvSetts().cceRegionid;
            if (regionCode != cceRegionID) { 
                let affectedRegionObj;
                let selectedRegions = await objSelf.getContents('RDataContent');
                for (let h = 0; h < selectedRegions.count(); h++) {
                    affectedRegionObj = await selectedRegions.getItem(h);
                    if (affectedRegionObj.MAP_ISSELECTED == 1 && isNothing(affectedRegionObj.CODIGOSITUACION)) {
                        await createNewAffectedRegion(situationCode, affectedRegionObj.ID, affectedRegionObj.MAP_IDTITULAR, affectedRegionObj.MAP_IDSUPLENTE, affectedRegions);
                    } else if (affectedRegionObj.MAP_ISSELECTED == 0 && !isNothing(affectedRegionObj.CODIGOSITUACION) && affectedRegionObj.CODIGOSITUACION == situationCode) {
                        affectedRegionObj.BAJA = 1;
                        await affectedRegionObj.save();
                    }
                }
            }
            
            for (let i = 0; i < selectedZones.count(); i++) {
                affectedZone = await selectedZones.getItem(i);
                if (affectedZone.MAP_ISSELECTED == 1 && isNothing(affectedZone.CODIGOSITUACION)) {
                    await createNewAffectedZone(situationCode, affectedZone.CODIGO, affectedZone.IDTITULAR, affectedZone.IDSUPLENTE, affectedZones);
                } else if (affectedZone.MAP_ISSELECTED == 0 && !isNothing(affectedZone.CODIGOSITUACION) && affectedZone.CODIGOSITUACION == situationCode) {
                    affectedZone.BAJA = 1;
                    await affectedZone.save();
                }
            }
            
            for (let i = 0; i < selectedUnits.count(); i++) {
                affectedUnit = await selectedUnits.getItem(i);
                if (affectedUnit.MAP_ISSELECTED == 1 && isNothing(affectedUnit.CODIGOSITUACION)) {
                    await createNewAffectedUnit(situationCode, affectedUnit.MAP_CODIGO, affectedZone.CODIGO, affectedUnit.IDTITULAR, affectedUnit.IDSUPLENTE, affectedUnits);
                } else if (affectedUnit.MAP_ISSELECTED == 0 && !isNothing(affectedUnit.CODIGOSITUACION) && affectedUnit.CODIGOSITUACION == situationCode) {
                    affectedUnit.BAJA = 1;
                    await affectedUnit.save();
                }
            }
        }
    }
}

async function addDefaultAffectedAreasTo(objSelf, situationCode, regionCode) {
    let affectedRegions = await appData.getCollection("RegionAfectada");
    let affectedZones = await appData.getCollection("ZonaAfectada");
    let affectedUnits = await appData.getCollection("UnidadAfectada");
    
    let defaultAffectedRegions = await appData.getCollection("Region");
    defaultAffectedRegions.unlock();
    defaultAffectedRegions.setMacro("##MACRO##", "r.CODIGO = '" + regionCode + "' AND (r.BAJA IS NULL OR r.BAJA = 0)");
    await defaultAffectedRegions.loadAll();
    
    if (defaultAffectedRegions.count() > 0) {
        let affectedRegion = await defaultAffectedRegions.getItem(0);
        await createNewAffectedRegion(situationCode, affectedRegion.MAP_CODIGO, affectedRegion.MAP_IDTITULAR, affectedRegion.MAP_IDSUPLENTE, affectedRegions);
        
        let defaultAffectedZones = await appData.getCollection("ZonaOrganizativa");
        defaultAffectedZones.unlock();
        defaultAffectedZones.setMacro("##MACRO##", "z.CODIGOREGION = '" + regionCode + "' AND (z.BAJA IS NULL OR z.BAJA = 0) AND z.TIPOZONA in ('ZONA')");
        await defaultAffectedZones.loadAll();
        
        let defaultAffectedUnits = await appData.getCollection("UnidadOrganizativa");
        defaultAffectedUnits.unlock();
        
        let affectedZone, affectedUnit;
        for (let i = 0; i < defaultAffectedZones.count(); i++) {
            affectedZone = await defaultAffectedZones.getItem(i);
            await createNewAffectedZone(situationCode, affectedZone.CODIGO, affectedZone.IDTITULAR, affectedZone.IDSUPLENTE, affectedZones);
            
            defaultAffectedUnits.setMacro("##MACRO##", "u.CODIGOZONA = '" + affectedZone.CODIGO + "' AND (u.BAJA IS NULL OR u.BAJA = 0) AND u.TIPOUNIDADORG in ('SECTOR')");
            await defaultAffectedUnits.loadAll();
            
            for (let j = 0; j < defaultAffectedUnits.count(); j++) {
                affectedUnit = await defaultAffectedUnits.getItem(j);
                await createNewAffectedUnit(situationCode, affectedUnit.MAP_CODIGO, affectedZone.CODIGO, affectedUnit.IDTITULAR, affectedUnit.IDSUPLENTE, affectedUnits);
            }
        }
        
        defaultAffectedZones.setMacro("##MACRO##", "");
        defaultAffectedZones.lock();
        defaultAffectedUnits.setMacro("##MACRO##", "");
        defaultAffectedUnits.lock();
    }
    
    defaultAffectedRegions.setMacro("##MACRO##", "");
    defaultAffectedRegions.lock();
}

function isStartDateOnThePast(startDate) {
    // TODO: Precisar cuando se considera con fecha del día que está en estado 'En Curso'.
    let currentDate = new Date();
    return startDate <= currentDate;
}

function getActiveStateCode() {
    
    return '0010';
}

async function createNewSituationRecord(objSelf, situationColl) {
    let activeStateCode = getActiveStateCode();
    
    if (isStartDateOnThePast(objSelf.MAP_FECHAINICIO) && objSelf.MAP_ESTADOCODE!='0020') {
        objSelf.MAP_ESTADOCODE = activeStateCode;
    }
    
    if (objSelf.MAP_ESTADOCODE == activeStateCode) {
        // Se comprueba si existe una situación extraordinaria 'En Curso' en la misma región.
        let existedSituationObj = await situationColl.findObject("s.ESTADO = '" + activeStateCode + "' AND s.CODIGOREGION = '" + objSelf.MAP_IDREGION + "'");
        if (!isNothing(existedSituationObj)) {
            // De existir se da la opción de modificar la preexistente.
            //let alertAnswer = ui.msgBox("Existe una situación extraordinaria 'En Curso' en la región " + objSelf.MAP_CODIGOREGION + ". ¿Desea modificar la situación extraordinaria preexistente?", "AVISO", 4);
            let response=await userMsgBox("Existe una situación extraordinaria 'En Curso' en la región " + objSelf.MAP_CODIGOREGION + ". ¿Desea modificar la situación extraordinaria preexistente?", "AVISO",1,"#e04c41");
            if (response === 1) {
                ui.pushValueAndExit(existedSituationObj);
            } 
            return;
        } 
    }
    
    objSelf.CODIGO=objSelf.MAP_CODIGO;
    
    let situationObj = await situationColl.createObject({
        NOMBRE: objSelf.MAP_NOMBRE,
        CODIGO:  objSelf.MAP_CODIGO,
        CODIGOTIPO: objSelf.MAP_TIPOCODE,
        CODIGOREGION: objSelf.MAP_REGIONCODE,
        REGIONID: objSelf.MAP_IDREGION,
        ESTADO: objSelf.MAP_ESTADOCODE,
        FECHAINICIO: objSelf.MAP_FECHAINICIO,
        FECHAFINESTIMADA: objSelf.MAP_FECHAFINESTIMADA,
        FECHACREACION: new Date(),
        IDUSUARIO: user.ID,
        BAJA: 0,
        ACTUALIZADO: 1
    });
    await situationObj.save();
    objSelf.ID=situationObj.ID;
}  

function saveSituationRecord(objSelf, situationRecord) {
    
    situationRecord.ESTADO="0000";
    situationRecord.ESTADO = objSelf.MAP_ESTADOCODE;    
    // LM solo si no es finalizada, comprobamos si debe activarse por fecha incio en el pasado
    if (objSelf.MAP_ESTADOCODE!=='0020') {
        if (isStartDateOnThePast(objSelf.MAP_FECHAINICIO)) {
            situationRecord.ESTADO = getActiveStateCode();
            objSelf.MAP_ESTADOCODE="En Curso";
        } else {
            situationRecord.ESTADO = objSelf.MAP_ESTADOCODE;
        }
    } 
    
    situationRecord.NOMBRE = objSelf.MAP_NOMBRE;
    situationRecord.CODIGOTIPO = objSelf.MAP_CODIGOTIPO;
    situationRecord.CODIGOREGION = objSelf.MAP_REGIONCODE;
    situationRecord.REGIONID = objSelf.MAP_IDREGION;
    
    situationRecord.FECHAINICIO = objSelf.MAP_FECHAINICIO;
    situationRecord.FECHAFINESTIMADA = objSelf.MAP_FECHAFINESTIMADA;
    situationRecord.BAJA = objSelf.MAP_BAJA;
    situationRecord.ACTUALIZADO = 3;
    
    
    objSelf.MAP_RECORDSTATE="EDIT";
    objSelf.MAP_HIDEBTEDITTITLE=0;
    objSelf.MAP_BLOQUEADO=1;
}

async function createNewStateRecord(objSelf, statesColl) {
    let stateObj = await statesColl.createObject({
        NOMBRE: objSelf.MAP_NOMBRE,
        CODIGO:  objSelf.MAP_CODIGO,
        FECHACREACION: new Date(),
        IDUSUARIO: user.ID,
        BAJA: objSelf.MAP_BAJA,
        ACTUALIZADO: 1
    });
    statesColl.addItem(stateObj);
    await stateObj.save();
}

function saveStateRecord(objSelf, stateRecord) {
    stateRecord.NOMBRE = objSelf.MAP_NOMBRE;
    stateRecord.CODIGO = objSelf.MAP_CODIGO;
    stateRecord.BAJA = objSelf.MAP_BAJA;
    stateRecord.ACTUALIZADO = 3;
}

async function createNewAffectedUnitRecord(objSelf, affectedUnitColl) {
    let parent = objSelf.getParent();
    let affectedUnitObj = await affectedUnitColl.createObject({
        CODIGOSITUACION: parent.MAP_CODIGOSITUACION,
        CODIGOZONA: objSelf.MAP_CODIGOZONA,
        CODIGOUNIDAD:  objSelf.MAP_CODIGOUNIDAD,
        FECHACREACION: new Date(),
        IDUSUARIO: user.ID,
        BAJA: objSelf.MAP_BAJA,
        ACTUALIZADO: 1
    });
    affectedUnitColl.addItem(affectedUnitObj);
    await affectedUnitObj.save();
}

function saveAffectedUnitRecord(objSelf, affectedUnitRecord) {
    let parent = objSelf.getParent();
    affectedUnitRecord.CODIGOSITUACION = parent.MAP_CODIGOSITUACION;
    affectedUnitRecord.CODIGOUNIDAD = objSelf.MAP_CODIGOUNIDAD;
    affectedUnitRecord.CODIGOZONA = objSelf.MAP_CODIGOZONE;
    affectedUnitRecord.FECHACREACION = new Date();
    affectedUnitRecord.IDUSUARIO = user.ID;
    affectedUnitRecord.BAJA = objSelf.MAP_BAJA;
    affectedUnitRecord.ACTUALIZADO = 3;
}

async function createNewAffectedRegion(situationCode, regionCode, regionID, idTitular, idSuplente, affectedRegionColl) {
    let affectedRegionObj = await affectedRegionColl.createObject({
        CODIGOSITUACION: situationCode,
        CODIGOREGION: regionCode,
        REGIONID: regionID,
        IDTITULAR: idTitular,
        IDSUPLENTE: idSuplente,
        FECHACREACION: new Date(),
        IDUSUARIO: user.ID,
        BAJA: 0,
        ACTUALIZADO: 1
    });
    affectedRegionColl.addItem(affectedRegionObj);
    await affectedRegionObj.save();
}

async function saveAffectedRegion(objSelf, affectedRegionRecord) {  
    //TODO: Actualizar IDUSUARIO y FECHAMODIFICACION.
    affectedRegionRecord.IDTITULAR = objSelf.MAP_IDTITULAR;
    affectedRegionRecord.IDSUPLENTE = objSelf.MAP_IDSUPLENTE;
    affectedRegionRecord.ACTUALIZADO = 3;
    await affectedRegionRecord.save();
}

async function createNewAffectedZone(situationCode, zoneID, zoneCode, affectedZoneColl) {
    // TODO: Actualizar USUARIOCREACION en lugar de IDUSUARIO.
    let affectedZoneObj = await affectedZoneColl.createObject({
        CODIGOSITUACION: situationCode,
        CODIGOZONA: zoneCode,
        IDZONA: zoneID,
        FECHACREACION: new Date(),
        IDUSUARIO: user.ID,
        BAJA: 0,
        ACTUALIZADO: 1
    });
    affectedZoneColl.addItem(affectedZoneObj);
    await affectedZoneObj.save();
}

async function saveAffectedZone(objSelf, affectedZoneRecord) {
    //TODO: Actualizar IDUSUARIO y FECHAMODIFICACION.
    affectedZoneRecord.IDTITULAR = objSelf.MAP_IDTITULAR;
    affectedZoneRecord.IDSUPLENTE = objSelf.MAP_IDSUPLENTE;
    affectedZoneRecord.ACTUALIZADO = 3;
    await affectedZoneRecord.save();
}

async function createNewAffectedUnit(situationCode, unitCode, zoneCode, idTitular, idSuplente, affectedUnitColl) {
    let affectedUnitObj = await affectedUnitColl.createObject({
        CODIGOSITUACION: situationCode,
        CODIGOZONA: zoneCode,
        IDZONA: zoneCode,
        CODIGOUNIDAD: unitCode,
        IDTITULAR: idTitular,
        IDSUPLENTE: idSuplente,
        FECHACREACION: new Date(),
        IDUSUARIO: user.ID,
        BAJA: 0,
        ACTUALIZADO: 1
    });
    affectedUnitColl.addItem(affectedUnitObj);
    await affectedUnitObj.save();
}

async function saveAffectedUnit(objSelf, affectedUnitRecord) {
    //TODO: Actualizar IDUSUARIO y FECHAMODIFICACION.
    affectedUnitRecord.IDTITULAR = objSelf.MAP_IDTITULAR;
    affectedUnitRecord.IDSUPLENTE = objSelf.MAP_IDSUPLENTE;
    affectedUnitRecord.ACTUALIZADO = 3;
    await affectedUnitRecord.save();
}

async function createNewMessageForSituation(objSelf, messagesColl) {
    let currentDate = new Date();
    let messageObj = await messagesColl.createObject({
        TITULO: objSelf.MAP_NTITLE,
        CODIGO: objSelf.MAP_MSGCODE,
        MENSAJETEXTO: objSelf.MAP_NTEXT,
        FILENAME: objSelf.MAP_FILENAME,
        FILEDESCRIPTION: objSelf.MAP_FILEDESCRIPTION,
        FECHA: currentDate,
        USUARIO: user.LOGIN,
        SITUACIONCODIGO: objSelf.MAP_CODIGO,
        FECHAMODIFICACION: currentDate,
        BAJA: 0,
        ACTUALIZADO: 1 
    });
    messagesColl.addItem(messageObj);
    await messageObj.save();
    
    objSelf.MAP_NTITLE="";
    objSelf.MAP_MSGCODE="";
    objSelf.MAP_NTEXT="";
    objSelf.MAP_FILENAME="";
    objSelf.MAP_FILEDESCRIPTION="";
    objSelf.MAP_HAYFILE=0;
    if (objSelf.getOwnerCollection().getName()=="SituacionExtraordinaria") {
        await loadData(objSelf,"NDataContent","MAP_NDATACONTENT",0,0,0,100);
    }
}

async function saveMessageForSituation(objSelf, messageRecord) {
    messageRecord.TITULO = objSelf.MAP_NTITLE;
    messageRecord.MENSAJETEXTO = objSelf.MAP_NTEXT;
    
    if (objSelf.MAP_HAYFILE==1) {
        messageRecord.FILENAME = objSelf.MAP_FILENAME;
        messageRecord.FILEDESCRIPTION = objSelf.MAP_FILEDESCRIPTION; 
    }
    
    await messageRecord.save();
    
    objSelf.MAP_NTITLE="";
    objSelf.MAP_MSGCODE="";
    objSelf.MAP_NTEXT="";
    objSelf.MAP_FILENAME="";
    objSelf.MAP_FILEDESCRIPTION="";
    objSelf.MAP_HAYFILE=0;
    objSelf.MAP_ID_MENSAJE=0;
    if (objSelf.getOwnerCollection().getName()=="SituacionExtraordinaria") {
        await loadData(objSelf,"NDataContent","MAP_NDATACONTENT",0,0,0,100);
    }
}

async function createNewFileForSituation(objSelf, filesColl) {
    let currentDate = new Date();
    let fileObj = await filesColl.createObject({
        FILENAME: objSelf.MAP_FILE,
        FECHA: currentDate,
        IDUSUARIO: user.ID,
        IDMENSAJE: objSelf.MAP_MSGCODE,
        BAJA: 0,
        ACTUALIZADO: 1
    });
    
    await fileObj.save();
}

async function createNewAvaibilityForSituation(objSelf, avaibilitiesColl) {
    // TODO: Guardar trazas de modificaciones en disponibilidad.
    let currentDate = new Date();
    let avaibility = objSelf.MAP_AVAIBILITY;
    //let avaibility = ((objSelf.MAP_DISPOBG == '#358717') ? 'Disponible' : (objSelf.MAP_NODISPOBG == '#358717') ? 'No Disponible' : 'Desconocido');
    let avaibilityObj = await avaibilitiesColl.createObject({
        CODIGOSITUACION: objSelf.MAP_SITUACIONCODIGO,
        IDCOMITE: objSelf.MAP_NIVELID,
        IDUSUARIO: objSelf.MAP_IDUSUARIO,
        DISPONIBILIDAD: avaibility,
        FECHACREACION: currentDate,
        FECHAMODIFICACION: currentDate,
        USUARIOCREACION: user.ID,
        USUARIO: user.ID,
        BAJA: 0,
        ACTUALIZADO: 1
    });
    
    await avaibilityObj.save();
}

async function saveAvaibilityForSituation(objSelf, avaibilityRecord) {
    // TODO: Guardar trazas de modificaciones en disponibilidad.
    avaibilityRecord.CODIGOSITUACION = objSelf.MAP_SITUACIONCODIGO;
    avaibilityRecord.IDCOMITE = objSelf.MAP_NIVELID;
    avaibilityRecord.IDUSUARIO = objSelf.MAP_IDUSUARIO;
    avaibilityRecord.DISPONIBILIDAD = objSelf.MAP_AVAIBILITY;
    //avaibilityRecord.DISPONIBILIDAD = ((objSelf.MAP_DISPOBG == '#358717') ? 'Disponible' : (objSelf.MAP_NODISPOBG == '#358717') ? 'No Disponible' : 'Desconocido');
    avaibilityRecord.USUARIO = user.ID;
    avaibilityRecord.FECHAMODIFICACION = new Date();
    avaibilityRecord.ACTUALIZADO = 3;
    await avaibilityRecord.save();
}

async function createNewContactRecord(objSelf, contactsColl) {
    let currentDate = new Date();
    let contactObj = await contactsColl.createObject({
        NOMBRE: objSelf.MAP_NOMBRE,
        DESCRIPCION: objSelf.MAP_DESCRIPCION,
        TELEFONO: objSelf.MAP_TELEFONO,
        EMAIL: objSelf.MAP_EMAIL,
        ESCONTACTOGLOBAL: objSelf.MAP_CONTACTOGLOBAL,
        REGIONCODIGO: (isNothing(objSelf.MAP_REGIONCODE) ? '' : objSelf.MAP_REGIONCODE),
        ZONACODIGO: (isNothing(objSelf.MAP_ZONACODE) ? '' : objSelf.MAP_ZONACODE),
        UNIDADCODIGO: (isNothing(objSelf.MAP_UNITCODE) ? '' : objSelf.MAP_UNITCODE),
        FECHACREACION: currentDate,
        FECHAMODIFICACION: currentDate,
        USUARIOCREACION: user.LOGIN,
        BAJA: 0,
        ACTUALIZADO: 1
    });
    await contactObj.save();
}

function createNewComiteRelacionadoRecord(objSelf, contactsColl) {
    
}

async function saveComiteRelacionadoRecord(objSelf, contactRecord) {
    // if (objSelf.MAP_NEWIDTITULAR > 0 ) {
    //     contactRecord.IDTITULAR = objSelf.MAP_NEWIDTITULAR;
    // }
    // if (objSelf.MAP_NEWIDSUPLENTE > 0 ) {
    //     contactRecord.IDSUPLENTE = objSelf.MAP_NEWIDSUPLENTE;
    // }
    
    var response;
    if (objSelf.IDTITULAR==objSelf.MAP_NEWIDTITULAR){
        response =await userMsgBox("Por favor, incluya un usuario titular diferente al asignado actualmente.", "AVISO",0,"#e04c41");
        return;
    }
    if (objSelf.IDSUPLENTE==objSelf.MAP_NEWIDSUPLENTE){
        response =await userMsgBox("Por favor, incluya un usuario suplente diferente al asignado actualmente.", "AVISO",0,"#e04c41");
        return;
    }        

    if (objSelf.MAP_NEWIDTITULAR==objSelf.MAP_NEWIDSUPLENTE){
        response =await userMsgBox("Por favor, incluya nuevos usuarios titular y suplente diferentes.", "AVISO",0,"#e04c41");
        return;
    } 
    // saveTrazaComiteAfectado(objSelf);
    
    if (objSelf.MAP_NEWIDTITULAR!==0){
        contactRecord.IDTITULAR=objSelf.MAP_NEWIDTITULAR;
        contactRecord.FDISP_TITULAR=null;
        contactRecord.DISP_TITULAR=0;
        contactRecord.NOTIFY_PUSH_TITULAR=0;
        contactRecord.FNOTIFY_PUSH_TITULAR=null;
        contactRecord.NOTIFY_MAIL_TITULAR=0;
        contactRecord.FNOTIFY_MAIL_TITULAR=null;
        contactRecord.MAP_TITULAREDIT=objSelf.MAP_NEWTITULAREDIT;
        // campos del grid...
        contactRecord.MAP_TITULAR=objSelf.MAP_NEWTITULAREDIT;
        contactRecord.MAP_TITULARPHONE=objSelf.MAP_NEWSTITULARTELEFONOEDIT;
        contactRecord.MAP_TITULAREMAIL=objSelf.MAP_NEWTITULAREMAILEDIT;
        contactRecord.MAP_NEWIDTITULAR=0;
        contactRecord.MAP_ICONTITULAR="desconocido.png";
    }

    if (objSelf.MAP_NEWIDSUPLENTE!==0){
        contactRecord.IDSUPLENTE=objSelf.MAP_NEWIDSUPLENTE;
        contactRecord.FDISP_SUPLENTE=null;
        contactRecord.DISP_SUPLENTE=0;
        contactRecord.NOTIFY_PUSH_SUPLENTE=0;
        contactRecord.FNOTIFY_PUSH_SUPLENTE=null;
        contactRecord.NOTIFY_MAIL_SUPLENTE=0;
        contactRecord.FNOTIFY_MAIL_SUPLENTE=null;
        
        contactRecord.MAP_SUPLENTEEDIT=objSelf.MAP_NEWSUPLENTEEDIT;
        // campos del grid...
        contactRecord.MAP_SUPLENTE=objSelf.MAP_NEWSUPLENTEEDIT;
        contactRecord.MAP_SUPLENTEPHONE=objSelf.MAP_NEWSUPLENTETELEFONOEDIT;
        contactRecord.MAP_SUPLENTEEMAIL=objSelf.MAP_NEWSUPLENTEEMAILEDIT;            
        contactRecord.MAP_NEWIDSUPLENTE=0;
        contactRecord.MAP_ICONSUPLENTE="desconocido.png";
    }
    contactRecord.FECHAMODIFICACION = new Date();
    contactRecord.ACTUALIZADO = 3;
    
    await contactRecord.save();
}

async function saveContactRecord(objSelf, contactRecord) {
    contactRecord.NOMBRE = objSelf.MAP_NOMBRE;
    contactRecord.DESCRIPCION = objSelf.MAP_DESCRIPCION;
    contactRecord.TELEFONO = objSelf.MAP_TELEFONO;
    contactRecord.EMAIL = objSelf.MAP_EMAIL;
    contactRecord.ESCONTACTOGLOBAL = objSelf.MAP_CONTACTOGLOBAL;
    contactRecord.REGIONCODIGO = (isNothing(objSelf.MAP_REGIONCODE) ? '' : objSelf.MAP_REGIONCODE);
    contactRecord.ZONACODIGO = (isNothing(objSelf.MAP_ZONACODE) ? '' : objSelf.MAP_ZONACODE);
    contactRecord.UNIDADCODIGO = (isNothing(objSelf.MAP_UNITCODE) ? '' : objSelf.MAP_UNITCODE);
    contactRecord.USUARIO = user.LOGIN;
    contactRecord.FECHAMODIFICACION = new Date();
    contactRecord.ACTUALIZADO = 3;
    await contactRecord.save();
}

async function applyFilters(objSelf, context, contentName, contentProp, nivel, countColl) {
    let filterMacro = "";
    switch(context) {
        case 'Nivel':
            if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                filterMacro += "UPPER(n.DESCRIPCION) like '%" + objSelf.MAP_DESCRIPFILTER.toUpperCase() + "%'"; 
            }
            if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(n.CODIGO) like '%" + objSelf.MAP_CODFILTER.toUpperCase() + "%'";
            }
            if (objSelf.MAP_BAJAFILTER == 1) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "n.BAJA=1";
            }
            if (objSelf.MAP_ACTIVOFILTER == 1) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "n.BAJA=0";
            }
            break;
        case 'Comite':
            if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                filterMacro += "UPPER(c.DESCRIPCION) like '%" + objSelf.MAP_DESCRIPFILTER.toUpperCase() + "%'"; 
            }
            if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(c.CODIGO) like '%" + objSelf.MAP_CODFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "c.BAJA=" + objSelf.MAP_BAJAFILTER;
            }
            if (objSelf.MAP_ACTIVOFILTER == 1) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "c.BAJA=0";
            }
            if (!isNothing(objSelf.MAP_TITULARFILTER) && objSelf.MAP_TITULARFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "(UPPER(c.IDTITULAR) like '%" + objSelf.MAP_TITULARFILTER.toUpperCase() + "%' OR UPPER(t.NOMBRE) like '%" + objSelf.MAP_TITULARFILTER.toUpperCase() + "%')";
            }
            if (!isNothing(objSelf.MAP_SUPLENTEFILTER) && objSelf.MAP_SUPLENTEFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "(UPPER(c.IDSUPLENTE) like '%" + objSelf.MAP_SUPLENTEFILTER.toUpperCase() + "%' OR UPPER(s.NOMBRE) like '%" + objSelf.MAP_TITULARFILTER.toUpperCase() + "%')";
            }
            if (!isNothing(objSelf.MAP_COMASOCFILTER) && objSelf.MAP_COMASOCFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "(UPPER(gc2.DESCRIPCION) like '%" + objSelf.MAP_COMASOCFILTER.toUpperCase() + "%')";
            }
            
            if (!isNothing(nivel) && nivel != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                
                filterMacro += "c.IDNIVEL=" + nivel;
            }
            break;
        case 'Region':
            if (!isNothing(objSelf.MAP_NOMFILTER) && objSelf.MAP_NOMFILTER != '') {
                filterMacro += "UPPER(r.NOMBRE) like '%" + objSelf.MAP_NOMFILTER.toUpperCase() + "%'"; 
            }
            if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(r.CODIGO) like '%" + objSelf.MAP_CODFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "r.BAJA=" + objSelf.MAP_BAJAFILTER;
            }
            if (objSelf.MAP_ACTIVOFILTER == 1) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "r.BAJA=0";
            }
            break;
        case 'ZonaOrganizativa':
            if (!isNothing(objSelf.MAP_NOMFILTER) && objSelf.MAP_NOMFILTER != '') {
                filterMacro += "UPPER(z.NOMBRE) like '%" + objSelf.MAP_NOMFILTER.toUpperCase() + "%'"; 
            }
            if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(z.CODIGO) like '%" + objSelf.MAP_CODFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_REGFILTER) && objSelf.MAP_REGFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(r.CODIGO) like '%" + objSelf.MAP_REGIONID.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_TIPOZONAFILTER) && objSelf.MAP_TIPOZONAFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(t.NOMBRE) like '%" + objSelf.MAP_TIPOZONAFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "z.BAJA=" + objSelf.MAP_BAJAFILTER;
            }
            if (objSelf.MAP_ACTIVOFILTER == 1) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "z.BAJA=0";
            }
            break;
        case 'UnidadOrganizativa':
            if (!isNothing(objSelf.MAP_NOMFILTER) && objSelf.MAP_NOMFILTER != '') {
                filterMacro += "UPPER(u.NOMBRE) like '%" + objSelf.MAP_NOMFILTER.toUpperCase() + "%'"; 
            }
            if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(u.CECO) like '%" + objSelf.MAP_CODFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_ZONEFILTER) && objSelf.MAP_ZONEFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(z.NOMBRE) like '%" + objSelf.MAP_ZONEFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_TIPOUNIDADFILTER) && objSelf.MAP_TIPOUNIDADFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(t.NOMBRE) like '%" + objSelf.MAP_TIPOUNIDADFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "u.BAJA=" + objSelf.MAP_BAJAFILTER;
            }
            if (objSelf.MAP_ACTIVOFILTER == 1) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "u.BAJA=0";
            }
            break;
        case 'Causa':
            if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                filterMacro += "UPPER(c.NOMBRE) like '%" + objSelf.MAP_DESCRIPFILTER.toUpperCase() + "%'"; 
            }
            if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(c.CODIGO) like '%" + objSelf.MAP_CODFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "c.BAJA=" + objSelf.MAP_BAJAFILTER;
            }
            if (objSelf.MAP_ACTIVOFILTER == 1) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "c.BAJA=0";
            }
            break;
        case 'TipoUnidadOrganizativa':
            if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                filterMacro += "UPPER(t.NOMBRE) like '%" + objSelf.MAP_DESCRIPFILTER.toUpperCase() + "%'"; 
            }
            if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(t.CODIGO) like '%" + objSelf.MAP_CODFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "t.BAJA=" + objSelf.MAP_BAJAFILTER;
            }
            if (objSelf.MAP_ACTIVOFILTER == 1) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "t.BAJA=0";
            }
            break;
        case 'Usuarios':
            if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                filterMacro += "UPPER(u.NOMBRE) like '%" + objSelf.MAP_DESCRIPFILTER.toUpperCase() + "%'"; 
            }
            if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(u.LOGIN) like '%" + objSelf.MAP_CODFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_EMAILFILTER) && objSelf.MAP_EMAILFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(u.EMAIL) like '%" + objSelf.MAP_EMAILFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_PHONEFILTER) && objSelf.MAP_PHONEFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(u.TELEFONO) like '%" + objSelf.MAP_PHONEFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "u.BAJA=" + objSelf.MAP_BAJAFILTER;
            }
            break;
        case 'TipoSituacion':
            if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                filterMacro += "UPPER(t.NOMBRE) like '%" + objSelf.MAP_DESCRIPFILTER.toUpperCase() + "%'"; 
            }
            if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(t.CODIGO) like '%" + objSelf.MAP_CODFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "t.BAJA=" + objSelf.MAP_BAJAFILTER;
            }
            break;
        case 'Estado':
            if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                filterMacro += "UPPER(s.NOMBRE) like '%" + objSelf.MAP_DESCRIPFILTER.toUpperCase() + "%'"; 
            }
            if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(s.CODIGO) like '%" + objSelf.MAP_CODFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "s.BAJA=" + objSelf.MAP_BAJAFILTER;
            }
            break;
        case 'SeguimientoSituacionVigente':
            if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                filterMacro += "UPPER(s.NOMBRE) like '%" + objSelf.MAP_DESCRIPFILTER.toUpperCase() + "%'"; 
            }
            if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(s.CODIGO) like '%" + objSelf.MAP_CODFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_TYPFILTER) && objSelf.MAP_TYPFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(t.CODIGO) like '%" + objSelf.MAP_TIPOID.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_REGFILTER) && objSelf.MAP_REGFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(r.CODIGO) like '%" + objSelf.MAP_REGIONID.toUpperCase() + "%'";
            }
            if (objSelf.MAP_BAJAFILTER == 1) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "s.BAJA=1";
            }
            if (objSelf.MAP_ACTIVOFILTER == 1) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "s.BAJA=0";
            }
            break;
        case 'HistoricoSituaciones':
            if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                filterMacro += "UPPER(s.NOMBRE) like '%" + objSelf.MAP_DESCRIPFILTER.toUpperCase() + "%'"; 
            }
            if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(s.CODIGO) like '%" + objSelf.MAP_CODFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_TYPFILTER) && objSelf.MAP_TYPFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(t.NOMBRE) like '%" + objSelf.MAP_TYPFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_REGFILTER) && objSelf.MAP_REGFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(r.CODIGO) like '%" + objSelf.MAP_REGIONID.toUpperCase() + "%'";
            }
            if (objSelf.MAP_BAJAFILTER == 1) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "s.BAJA=1";
            }
            if (objSelf.MAP_ACTIVOFILTER == 1) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "s.BAJA=0";
            }
            break;
        case 'Contacto':
            if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                filterMacro += "UPPER(c.NOMBRE) like '%" + objSelf.MAP_DESCRIPFILTER.toUpperCase() + "%'"; 
            }
            if (!isNothing(objSelf.MAP_INFOFILTER) && objSelf.MAP_INFOFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(c.DESCRIPCION) like '%" + objSelf.MAP_INFOFILTER.toUpperCase() + "%'"; 
            }
            if (!isNothing(objSelf.MAP_EMAILFILTER) && objSelf.MAP_EMAILFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(c.EMAIL) like '%" + objSelf.MAP_EMAILFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_PHONEFILTER) && objSelf.MAP_PHONEFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(c.TELEFONO) like '%" + objSelf.MAP_PHONEFILTER.toUpperCase() + "%'";
            }
            if (!isNothing(objSelf.MAP_REGFILTER) && objSelf.MAP_REGFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                /*
                filterMacro += "UPPER(CASE WHEN c.ESCONTACTOGLOBAL = 1 THEN 'Todas las regiones' " +
                    "WHEN c.UNIDADCODIGO IS NOT NULL AND c.UNIDADCODIGO != '' AND u.CECO IS NOT NULL THEN u.NOMBRE " +
                    "WHEN (c.UNIDADCODIGO IS NULL OR u.CECO IS NULL) AND c.ZONACODIGO IS NOT NULL AND c.ZONACODIGO != '' AND z.CODIGO IS NOT NULL THEN z.NOMBRE " +
                    "WHEN (c.ZONACODIGO IS NULL OR z.CODIGO IS NULL)  AND c.REGIONCODIGO IS NOT NULL AND c.REGIONCODIGO != '' AND r.CODIGO IS NOT NULL THEN r.NOMBRE " +
                    "ELSE 'Desconocido' END) like '%" + objSelf.MAP_REGFILTER.toUpperCase() + "%'";
                */
                filterMacro += " (r.NOMBRE like '%" + objSelf.MAP_REGFILTER.toUpperCase() + "%' OR c.ESCONTACTOGLOBAL=1)";
            }  
            
            if (objSelf.MAP_BAJAFILTER == 1) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "c.BAJA=1";
            }
            if (objSelf.MAP_ACTIVOFILTER == 1) {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "c.BAJA=0";
            }
            break;
        case 'RepositorioListado':
            if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                filterMacro += "UPPER(r.NOMBRE) like '%" + objSelf.MAP_DESCRIPFILTER.toUpperCase() + "%'"; 
            }
            if (!isNothing(objSelf.MAP_INFOFILTER) && objSelf.MAP_INFOFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(r.DESCRIPCION) like '%" + objSelf.MAP_INFOFILTER.toUpperCase() + "%'"; 
            }/*
            if (!isNothing(objSelf.MAP_CARPETA) && objSelf.MAP_CARPETA != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(p.NOMBRE) like '%" + objSelf.MAP_CARPETA.toUpperCase() + "%'"; 
            }*/
            break;
        case 'Carpetas':
            if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                filterMacro += "UPPER(r.NOMBRE) like '%" + objSelf.MAP_DESCRIPFILTER.toUpperCase() + "%'"; 
            }
            if (!isNothing(objSelf.MAP_INFOFILTER) && objSelf.MAP_INFOFILTER != '') {
                if (filterMacro.length > 0) {
                    filterMacro += " AND ";
                }
                filterMacro += "UPPER(r.DESCRIPCION) like '%" + objSelf.MAP_INFOFILTER.toUpperCase() + "%'"; 
            }
            break;
        case 'TrazabilidadSeguridad':
            if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                filterMacro += "UPPER(USUARIO) like '%" + objSelf.MAP_DESCRIPFILTER.toUpperCase() + "%'"; 
            }
            break;
    }
    
    let dataContent = await objSelf.getContents(contentName);
    let refreshProps = "MAP_AREALLSELECTED,MAP_ROWSCOUNT,MAP_SELECTEDROWSCOUNT,";
    if (context == 'Usuarios') {
        refreshProps += contentName;
    } else {
        refreshProps += contentName + "," + contentProp;
    }
    
    dataContent.unlock();
    dataContent.setMacro("##MACRO##", filterMacro);
    dataContent.clear();
    
    objSelf.MAP_AREALLSELECTED = 0;
    objSelf.MAP_SELECTEDROWSCOUNT = 0;
    
    if (context == 'Usuarios' || context == 'ZonaOrganizativa' 
        || context == 'UnidadOrganizativa' || context == 'HistoricoSituaciones'
        || context == 'SeguimientoSituacionVigente' || context == 'Contacto' 
        || context=='RepositorioListado') {
        let fromValue, toValue;
        await loadData(objSelf, contentName, contentProp, 0, 0, 0, objSelf.MAP_PAG_LEN);
        let ctr = await appData.getCollection(countColl);
        ctr.setMacro("##MACRO##", filterMacro);
        await ctr.loadAll();
        objSelf.MAP_TOTAL_REGISTROS = (await ctr.getItem(0)).MAP_CONTADOR;
        fromValue = 0; 
        toValue = objSelf.MAP_PAG_LEN;
        if (toValue > objSelf.MAP_TOTAL_REGISTROS) 
            toValue = objSelf.MAP_TOTAL_REGISTROS;
        objSelf.MAP_ROWSCOUNT = "Filas de " + fromValue + " a " + toValue + " / " + objSelf.MAP_TOTAL_REGISTROS;
    } else {
        await dataContent.loadAll();
        dataContent.lock();
        objSelf.MAP_ROWSCOUNT = dataContent.count();
    }
    
    
    ui.getView(objSelf).refresh(refreshProps);
}

async function deleteFilters(objSelf, context, contentName, contentProp, nivel, countColl) {
    let propsToRefresh = "MAP_AREALLSELECTED,MAP_ROWSCOUNT,MAP_SELECTEDROWSCOUNT," + 
        ((context == 'Usuarios') ? 'UsuariosListMaestro' : (context == 'Contacto') ? 'ContactosListMaestro' : 'DataContent,MAP_DATACONTENT');
    let refreshProps = "";
    let dataContent = await objSelf.getContents(contentName);
    
    if (!isNothing(dataContent)) {
        switch(context) {
            case 'Nivel':
                if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                    objSelf.MAP_DESCRIPFILTER = ''; 
                }
                if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                    objSelf.MAP_CODFILTER = '';
                }
                if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                    objSelf.MAP_BAJAFILTER = 0;
                }
                if (!isNothing(objSelf.MAP_ACTIVOFILTER)) {
                    objSelf.MAP_ACTIVOFILTER = 0;
                }
                refreshProps = "MAP_DESCRIPFILTER,MAP_BAJAFILTER,MAP_ACTIVOFILTER";
                break;
            case 'Comite':
                objSelf.MAP_DESCRIPFILTER = '';  
                objSelf.MAP_CODFILTER = '';
                objSelf.MAP_TITULARFILTER = '';
                objSelf.MAP_SUPLENTEFILTER = '';
                objSelf.MAP_BAJAFILTER = 0;
                objSelf.MAP_ACTIVOFILTER = 1;
                objSelf.MAP_COMASOCFILTER = '';
                refreshProps = "MAP_DESCRIPFILTER,MAP_CODFILTER,MAP_NIVELFILTER,MAP_TITULARFILTER,MAP_SUPLENTEFILTER,MAP_BAJAFILTER,MAP_ACTIVOFILTER,MAP_COMASOCFILTER";
                break;
            case 'Region':
                if (!isNothing(objSelf.MAP_NOMFILTER) && objSelf.MAP_NOMFILTER != '') {
                    objSelf.MAP_NOMFILTER = '';
                }
                if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                    objSelf.MAP_CODFILTER = '';
                }
                if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                    objSelf.MAP_BAJAFILTER = 0;
                }
                if (!isNothing(objSelf.MAP_ACTIVOFILTER)) {
                    objSelf.MAP_ACTIVOFILTER = 0;
                }
                refreshProps = "MAP_NOMFILTER,MAP_CODFILTER,MAP_BAJAFILTER,MAP_ACTIVOFILTER";
                break;
            case 'ZonaOrganizativa':
                if (!isNothing(objSelf.MAP_NOMFILTER) && objSelf.MAP_NOMFILTER != '') {
                    objSelf.MAP_NOMFILTER = '';
                }
                if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                    objSelf.MAP_CODFILTER = '';
                }
                if (!isNothing(objSelf.MAP_REGFILTER) && objSelf.MAP_REGFILTER != '') {
                    objSelf.MAP_REGFILTER = '';
                }
                if (!isNothing(objSelf.MAP_TIPOZONAFILTER) && objSelf.MAP_TIPOZONAFILTER != '') {
                    objSelf.MAP_TIPOZONAFILTER = '';
                }
                if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                    objSelf.MAP_BAJAFILTER = 0;
                }
                refreshProps = "MAP_NOMFILTER,MAP_CODFILTER,MAP_REGFILTER,MAP_TIPOZONAFILTER,MAP_BAJAFILTER";
                break;
            case 'UnidadOrganizativa':
                if (!isNothing(objSelf.MAP_NOMFILTER) && objSelf.MAP_NOMFILTER != '') {
                    objSelf.MAP_NOMFILTER = '';
                }
                if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                    objSelf.MAP_CODFILTER = '';
                }
                if (!isNothing(objSelf.MAP_ZONEFILTER) && objSelf.MAP_ZONEFILTER != '') {
                    objSelf.MAP_ZONEFILTER = '';
                }
                if (!isNothing(objSelf.MAP_TIPOUNIDADFILTER) && objSelf.MAP_TIPOUNIDADFILTER != '') {
                    objSelf.MAP_TIPOUNIDADFILTER = '';
                }
                if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                    objSelf.MAP_BAJAFILTER = 0;
                }
                if (!isNothing(objSelf.MAP_ACTIVOFILTER)) {
                    objSelf.MAP_ACTIVOFILTER = 0;
                }
                refreshProps = "MAP_NOMFILTER,MAP_CODFILTER,MAP_ZONEFILTER,MAP_TIPOUNIDADFILTER,MAP_BAJAFILTER,MAP_ACTIVOFILTER";
                break;
            case 'Causa':
                if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                    objSelf.MAP_DESCRIPFILTER = '';
                }
                if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                    objSelf.MAP_CODFILTER = '';
                }
                if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                    objSelf.MAP_BAJAFILTER = 0;
                }
                if (!isNothing(objSelf.MAP_ACTIVOFILTER)) {
                    objSelf.MAP_ACTIVOFILTER = 0;
                }
                refreshProps = "MAP_DESCRIPFILTER,MAP_CODFILTER,MAP_BAJAFILTER,MAP_ACTIVOFILTER";
                break;
            case 'TipoUnidadOrganizativa':
                if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                    objSelf.MAP_DESCRIPFILTER = '';
                }
                if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                    objSelf.MAP_CODFILTER = '';
                }
                if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                    objSelf.MAP_BAJAFILTER = 0;
                }
                if (!isNothing(objSelf.MAP_ACTIVOFILTER)) {
                    objSelf.MAP_ACTIVOFILTER = 0;
                }
                refreshProps = "MAP_DESCRIPFILTER,MAP_CODFILTER,MAP_BAJAFILTER,MAP_ACTIVOFILTER";
                break;
            case 'Usuarios':
                objSelf.MAP_DESCRIPFILTER = ''; 
                objSelf.MAP_CODFILTER = '';
                objSelf.MAP_EMAILFILTER = '';
                objSelf.MAP_PHONEFILTER = '';
                objSelf.MAP_BAJAFILTER = 0;
                objSelf.MAP_ACTIVOFILTER = 1;
                refreshProps = "MAP_DESCRIPFILTER,MAP_CODFILTER,MAP_EMAILFILTER,MAP_PHONEFILTER,MAP_BAJAFILTER,MAP_ACTIVOFILTER";
                break;
            case 'TipoSituacion':
                if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                    objSelf.MAP_DESCRIPFILTER = '';
                }
                if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                    objSelf.MAP_CODFILTER = '';
                }
                if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                    objSelf.MAP_BAJAFILTER = 0;
                }
                refreshProps = "MAP_DESCRIPFILTER,MAP_CODFILTER,MAP_BAJAFILTER";
                break;
            case 'Estado':
                if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                    objSelf.MAP_DESCRIPFILTER = '';
                }
                if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                    objSelf.MAP_CODFILTER = '';
                }
                if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                    objSelf.MAP_BAJAFILTER = 0;
                }
                refreshProps = "MAP_DESCRIPFILTER,MAP_CODFILTER,MAP_BAJAFILTER";
                break;
            case 'SeguimientoSituacionVigente':
                if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                    objSelf.MAP_DESCRIPFILTER = '';
                }
                if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                    objSelf.MAP_CODFILTER = '';
                }
                if (!isNothing(objSelf.MAP_TYPFILTER) && objSelf.MAP_TYPFILTER != '') {
                    objSelf.MAP_TYPFILTER = '';
                }
                if (!isNothing(objSelf.MAP_REGFILTER) && objSelf.MAP_REGFILTER != '') {
                    objSelf.MAP_REGFILTER = '';
                }
                // if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                //     objSelf.MAP_BAJAFILTER = 0;
                // }
                // if (!isNothing(objSelf.MAP_ACTIVOFILTER)) {
                //     objSelf.MAP_ACTIVOFILTER = 0;
                // }
                refreshProps = "MAP_DESCRIPFILTER,MAP_CODFILTER,MAP_TYPFILTER,MAP_REGFILTER,MAP_BAJAFILTER,MAP_ACTIVOFILTER";
                break;
            case 'HistoricoSituaciones':
                if (!isNothing(objSelf.MAP_DESCRIPFILTER) && objSelf.MAP_DESCRIPFILTER != '') {
                    objSelf.MAP_DESCRIPFILTER = '';
                }
                if (!isNothing(objSelf.MAP_CODFILTER) && objSelf.MAP_CODFILTER != '') {
                    objSelf.MAP_CODFILTER = '';
                }
                if (!isNothing(objSelf.MAP_TYPFILTER) && objSelf.MAP_TYPFILTER != '') {
                    objSelf.MAP_TYPFILTER = '';
                }
                if (!isNothing(objSelf.MAP_REGFILTER) && objSelf.MAP_REGFILTER != '') {
                    objSelf.MAP_REGFILTER = '';
                }
                // if (!isNothing(objSelf.MAP_BAJAFILTER)) {
                //     objSelf.MAP_BAJAFILTER = 0;
                // }
                // if (!isNothing(objSelf.MAP_ACTIVOFILTER)) {
                //     objSelf.MAP_ACTIVOFILTER = 0;
                // }
                refreshProps = "MAP_DESCRIPFILTER,MAP_CODFILTER,MAP_TYPFILTER,MAP_REGFILTER,MAP_BAJAFILTER,MAP_ACTIVOFILTER";
                break;
            case 'Contacto':
                objSelf.MAP_DESCRIPFILTER = '';
                objSelf.MAP_INFOFILTER = '';
                objSelf.MAP_EMAILFILTER = '';
                objSelf.MAP_PHONEFILTER = '';
                objSelf.MAP_REGFILTER = '';
                objSelf.MAP_BAJAFILTER = 0;
                objSelf.MAP_ACTIVOFILTER = 0;
                refreshProps = "MAP_INFOFILTER,MAP_DESCRIPFILTER,MAP_EMAILFILTER,MAP_PHONEFILTER,MAP_REGFILTER,MAP_BAJAFILTER,MAP_ACTIVOFILTER";
                break;
            case 'RepositorioListado':
                objSelf.MAP_DESCRIPFILTER = '';
                objSelf.MAP_INFOFILTER = '';
                objSelf.MAP_CARPETA="";
                break;
            case 'TrazabilidadSeguridad':
                objSelf.MAP_DESCRIPFILTER = '';
                break;
        }
        
        await applyFilters(objSelf, context, contentName, contentProp, nivel, countColl);
        
        //TODO REVISAR
        // applyFilters(objSelf, "SeguimientoSituacionVigente", "DataContent", "MAP_DATACONTENT", 0, 'SeguimientoSituacionVigenteContador');
        
        
        /*
        dataContent.unlock();
        
        if (context == 'Comite' && !isNothing(nivel) && nivel != '') {
            dataContent.setMacro("##MACRO##", "c.IDNIVEL=" + nivel);
        } else {
            dataContent.setMacro("##MACRO##", "1=1");
        }
    
        objSelf.MAP_AREALLSELECTED = 0;
        objSelf.MAP_SELECTEDROWSCOUNT = 0;
        
        if (context == 'Usuarios' || context == 'ZonaOrganizativa' || context == 'UnidadOrganizativa'
            || context == 'HistoricoSituaciones' || context == 'Contacto') {
            let fromValue, toValue;
            loadData(objSelf, contentName, contentProp, 0, 0, 0, objSelf.MAP_PAG_LEN);
            let ctr = appData.getCollection(countColl);
            ctr.setMacro("##MACRO##", "1=1");
            ctr.loadAll();
            objSelf.MAP_TOTAL_REGISTROS = ctr.getItem(0).MAP_CONTADOR;
            fromValue = 0; 
            toValue = objSelf.MAP_PAG_LEN;
            if (toValue > objSelf.MAP_TOTAL_REGISTROS) 
                toValue = objSelf.MAP_TOTAL_REGISTROS;
            objSelf.MAP_ROWSCOUNT = "Filas de " + fromValue + " a " + toValue + " / " + objSelf.MAP_TOTAL_REGISTROS;
        } else {
            dataContent.clear();
            dataContent.loadAll();
            dataContent.lock();
            objSelf.MAP_ROWSCOUNT = dataContent.count();
        }
        
        if (refreshProps.length > 0) {
            refreshProps = propsToRefresh + "," + refreshProps; 
        } else {
            refreshProps = propsToRefresh;
        }
        ui.getView(objSelf).refresh(refreshProps);
        */
        
    }
}

async function addUserToComittee(objSelf) {
    if (objSelf.MAP_TITULAR == 1) {
        objSelf.MAP_IDTITULAR = objSelf.MAP_SELUSERNUMEXP;
    } else if (objSelf.MAP_SUPLENTE == 1) {
        objSelf.MAP_IDSUPLENTE = objSelf.MAP_SELUSERNUMEXP;
    }
    
    await addNewRecord(objSelf, "c.CODIGO = '" + objSelf.MAP_CODIGO + "'", "Comite", true);
    
    let dataContent = await objSelf.getContents("UsersContent");
    dataContent.unlock();
    dataContent.clear();
    await dataContent.loadAll();
    dataContent.lock();
    ui.getView(objSelf).refresh("UsersContent,MAP_USERSCONTENT");
    
}

async function selectUnitForExtraSituation(objSelf) {
    let parent = objSelf.getParent();
    
    await addNewRecord(objSelf, "a.CODIGOSITUACION = '" + parent.MAP_CODIGOSITUACION + "' AND a.CODIGOZONA = '" + objSelf.MAP_CODIGOZONA + "' AND a.CODIGOUNIDAD = '" + objSelf.MAP_CODIGOUNIDAD + "'", "UnidadAfectada", true);
    
    let dataContent = await objSelf.getContents("UnitsContent");
    dataContent.unlock();
    dataContent.clear();
    await dataContent.loadAll();
    dataContent.lock();
    ui.getView(objSelf).refresh("UnitsContent,MAP_UNITSCONTENT");
}

async function askForDeleteUserFromComittee(objSelf) {
    let parent = objSelf.getParent();
    //let result = ui.msgBox("¿Quiere eliminar este usuario del Comité " + parent.MAP_DESCRIPCION + "?", "AVISO", 4);
    let response=await userMsgBox("¿Quiere eliminar este usuario del Comité " + parent.MAP_DESCRIPCION + "?", "AVISO",1,"#e04c41");
    if (response === 1) {
        let comitteeObj = await getRecord("Comite", "c.CODIGO='" + parent.MAP_CODIGO + "'");
        if (objSelf.MAP_TITULARIDAD == "TITULAR") {
            parent.MAP_IDTITULAR = "";
            comitteeObj.IDTITULAR = "";
        } else if (objSelf.MAP_TITULARIDAD == "SUPLENTE") {
            parent.MAP_IDSUPLENTE = "";
            comitteeObj.IDSUPLENTE= "";
        }
        
        await comitteeObj.save();
    
        let dataContent = await parent.getContents("UsersContent");
        dataContent.unlock();
        dataContent.clear();
        await dataContent.loadAll();
        dataContent.lock();
        ui.getView(parent).refresh("UsersContent,MAP_USERSCONTENT");
    }
}

async function getRecord(collName, filterCondition) {
    let dataColl = await appData.getCollection(collName);
    return await dataColl.findObject(filterCondition);
}

async function loadComitteeDataIfPossible(objSelf) {
    let comitteeObj = await getRecord("Comite", "c.CODIGO='" + objSelf.MAP_CODIGO + "'");
    
    if (!isNothing(comitteeObj)) {
        objSelf.MAP_DESCRIPCION = comitteeObj.DESCRIPCION;
        objSelf.MAP_IDNIVEL = comitteeObj.IDNIVEL;
    }
    
    let comitteeCode = (!isNothing(objSelf.MAP_CODIGO) && objSelf.MAP_CODIGO != '') ? objSelf.MAP_CODIGO : '-';
    let usersInComitteeContent = await objSelf.getContents('DataContent');
    usersInComitteeContent.unlock();
    usersInComitteeContent.setMacro("##MACRO##", "c.CODIGO = '" + comitteeCode + "'");
    await usersInComitteeContent.loadAll();
    usersInComitteeContent.lock();
                    
    let usersWithoutComitteeContent = await objSelf.getContents('UsersContent');
    usersWithoutComitteeContent.unlock();
    usersWithoutComitteeContent.setMacro("##MACRO##", "c.CODIGO IS NULL OR c.CODIGO != '" + comitteeCode + "'");
    await usersWithoutComitteeContent.loadAll();
    usersWithoutComitteeContent.lock();
                    
    ui.getView(objSelf).refresh("DataContent,MAP_DATACONTENT,UsersContent,MAP_USERSCONTENT");
}

async function showFormToAddAffectedZoneTo(objSelf) {
    let affectedZonesColl = await appData.getCollection("SeleccionarZonaAfectada");
    let affectedZoneObj = await affectedZonesColl.createObject();
    affectedZoneObj.MAP_PARENT = objSelf;
    affectedZoneObj.MAP_CODIGOSITUACION = objSelf.MAP_CODIGO;
    affectedZoneObj.MAP_CODIGOREGION = objSelf.MAP_REGIONCODE;
    appData.pushValue(affectedZoneObj);
}

async function showFormToAddAffectedUnitTo(objSelf) {
    let affectedUnitsColl = await appData.getCollection("SeleccionarUnidadAfectada");
    let affectedUnitObj = await affectedUnitsColl.createObject();
    affectedUnitObj.MAP_CODIGOSITUACION = objSelf.MAP_CODIGO;
    affectedUnitObj.MAP_CODIGOREGION = objSelf.MAP_REGIONCODE;
    appData.pushValue(affectedUnitObj);
}

async function changeVisibilityForReasons(objSelf, visibility) {
    
    let activas = await objSelf.getContents("CausasSituContent");
    let seleccionar = await objSelf.getContents("CausasContent");
    let existe=0;
        
    let refreshProps = "FRM_CSOUTCONT,FRM_CAUSASSITU,FRM_CAUSAS,FRM_SELECTALL";
    objSelf.MAP_SHOWCAUSASTOSELECT = visibility;
    
    if (objSelf.MAP_SHOWSTATES !== 0) {
        objSelf.MAP_SHOWSTATES = 0;
        refreshProps = "FRM_ESTADOSEL,FRM_ESTADOSCONT," + refreshProps;
    } else if (objSelf.MAP_SHOWREGIONS !== 0) {
        objSelf.MAP_SHOWREGIONS = 0;
        refreshProps = "FRM_REGIONSEL,FRM_REGIONSCONT," + refreshProps;
    } else if (objSelf.MAP_SHOWTYPES != 0) {
        objSelf.MAP_SHOWTYPES = 0;
        refreshProps = "FRM_TIPOSEL,FRM_TIPOSCONT," + refreshProps;
    }
    
    objSelf.MAP_VISIBILITY=visibility;
    
    if (objSelf.MAP_VISIBILITY==1) {
        objSelf.MAP_VISIBILITY=99;
        for (let i = 0; i < seleccionar.getCount(); i++){
            (await seleccionar.getItem(i)).MAP_ISSELECTED=0;    
        }
        // debugger;
        for (let j = 0; j < activas.getCount(); j++) {
            for (let i = 0; i < seleccionar.getCount(); i++){
                if ((await seleccionar.getItem(i)).MAP_NOMBRE==(await activas.getItem(j)).MAP_NOMBRE) {
                    // ui.showToast("Valor: " + seleccionar.getItem(i).MAP_NOMBRE + ".:" + i);
                    (await seleccionar.getItem(i)).MAP_ISSELECTED=1;
                }
            }
        }
        
    }
    if (objSelf.MAP_VISIBILITY==0) {
        objSelf.MAP_CAUSAST="";
        for (let i = 0; i < activas.getCount(); i++) {
            objSelf.MAP_CAUSAST=objSelf.MAP_CAUSAST + (await activas.getItem(i)).MAP_NOMBRE;
            if (i != activas.getCount()-1) {
                objSelf.MAP_CAUSAST=objSelf.MAP_CAUSAST + ",";    
            }
        }
    }
    
    ui.refresh(refreshProps);
    objSelf.MAP_VISIBILITY=0;
    
}

function changeComitteesVisibility(objSelf, visibility) {
    let refreshProps = "FRM_COMITTEESEL,FRM_COMITTEECONT";
    objSelf.MAP_SHOWCOMITTEE = visibility;
    
    if (objSelf.MAP_SHOWTITULAROPTIONS !== 0) {
        objSelf.MAP_SHOWTITULAROPTIONS = 0;
        refreshProps = "FRM_TITULARSEL,FRM_TITULARCONT," + refreshProps;
    } else if (objSelf.MAP_SHOWSUPLENTEOPTIONS !== 0) {
        objSelf.MAP_SHOWSUPLENTEOPTIONS = 0;
        refreshProps = "FRM_SUPLENTESEL,FRM_SUPLENTECONT," + refreshProps;
    }
    
    ui.refresh(refreshProps);
}

function changeHoldersVisibility(objSelf, visibility) {
    let refreshProps = "FRM_TITULARSEL,FRM_TITULARCONT";
    objSelf.MAP_SHOWTITULAROPTIONS = visibility;
    
    if (objSelf.MAP_SHOWCOMITTEE !== 0) {
        objSelf.MAP_SHOWCOMITTEE = 0;
        refreshProps = "FRM_COMITTEESEL,FRM_COMITTEECONT," + refreshProps;
    } else if (objSelf.MAP_SHOWSUPLENTEOPTIONS !== 0) {
        objSelf.MAP_SHOWSUPLENTEOPTIONS = 0;
        refreshProps = "FRM_SUPLENTESEL,FRM_SUPLENTECONT," + refreshProps;
    }
    
    ui.refresh(refreshProps);
}

function changeSubstitutesVisibility(objSelf, visibility) {
    let refreshProps = "FRM_SUPLENTESEL,FRM_SUPLENTECONT";
    objSelf.MAP_SHOWSUPLENTEOPTIONS = visibility;
    
    if (objSelf.MAP_SHOWCOMITTEE !== 0) {
        objSelf.MAP_SHOWCOMITTEE = 0;
        refreshProps = "FRM_COMITTEESEL,FRM_COMITTEECONT," + refreshProps;
    } else if (objSelf.MAP_SHOWTITULAROPTIONS !== 0) {
        objSelf.MAP_SHOWTITULAROPTIONS = 0;
        refreshProps = "FRM_TITULARSEL,FRM_TITULARCONT," + refreshProps;
    }
    
    ui.refresh(refreshProps);
}

function changeRegionsVisibility(objSelf, visibility) {
    let refreshProps = "FRM_REGIONSEL,FRM_REGIONSCONT";
    objSelf.MAP_SHOWREGIONS = visibility;
    
    if (objSelf.MAP_SHOWSTATES !== 0) {
        objSelf.MAP_SHOWSTATES = 0;
        refreshProps = "FRM_ESTADOSEL,FRM_ESTADOSCONT," + refreshProps;
    } else if (objSelf.MAP_SHOWCAUSASTOSELECT !== 0) {
        objSelf.MAP_SHOWCAUSASTOSELECT = 0;
        refreshProps = "FRM_CSOUTCONT,FRM_CAUSASSITU,FRM_CAUSAS,FRM_SELECTALL," + refreshProps;
    } else if (objSelf.MAP_SHOWTYPES != 0) {
        objSelf.MAP_SHOWTYPES = 0;
        refreshProps = "FRM_TIPOSEL,FRM_TIPOSCONT," + refreshProps;
    }
    
    ui.refresh(refreshProps);
}

function changeStatesVisibility(objSelf, visibility) {
    let refreshProps = "FRM_ESTADOSEL,FRM_ESTADOSCONT";
    objSelf.MAP_SHOWSTATES = visibility;
    
    if (objSelf.MAP_SHOWREGIONS !== 0) {
        objSelf.MAP_SHOWREGIONS = 0;
        refreshProps = "FRM_REGIONSEL,FRM_REGIONSCONT," + refreshProps;
    } else if (objSelf.MAP_SHOWCAUSASTOSELECT !== 0) {
        objSelf.MAP_SHOWCAUSASTOSELECT = 0;
        refreshProps = "FRM_CSOUTCONT,FRM_CAUSASSITU,FRM_CAUSAS,FRM_SELECTALL," + refreshProps;
    } else if (objSelf.MAP_SHOWTYPES != 0) {
        objSelf.MAP_SHOWTYPES = 0;
        refreshProps = "FRM_TIPOSEL,FRM_TIPOSCONT," + refreshProps;
    }
    
    ui.refresh(refreshProps);
}

function changeTypesVisibility(objSelf, visibility) {
    let refreshProps = "FRM_TIPOSEL,FRM_TIPOSCONT";
    objSelf.MAP_SHOWTYPES = visibility;
    
    if (objSelf.MAP_SHOWSTATES !== 0) {
        objSelf.MAP_SHOWSTATES = 0;
        refreshProps = "FRM_ESTADOSEL,FRM_ESTADOSCONT," + refreshProps;
    } else if (objSelf.MAP_SHOWREGIONS !== 0) {
        objSelf.MAP_SHOWREGIONS = 0;
        refreshProps = "FRM_REGIONSEL,FRM_REGIONSCONT," + refreshProps;
    } else if (objSelf.MAP_SHOWCAUSASTOSELECT !== 0) {
        objSelf.MAP_SHOWCAUSASTOSELECT = 0;
        refreshProps = "FRM_CSOUTCONT,FRM_CAUSASSITU,FRM_CAUSAS,FRM_SELECTALL," + refreshProps;
    }
    
    ui.refresh(refreshProps);
}

function changeAvaibilityStateBG(objSelf, selectedAvaibility) {
    if (selectedAvaibility == 'Available') {
        objSelf.MAP_AVAIBILITY = 'Disponible';
        objSelf.MAP_DISPOBG = '#358717';
        if (objSelf.MAP_NODISPOBG == '#cc0000') {
            objSelf.MAP_NODISPOBG = '#6f6f6f';
        }
    } else if (selectedAvaibility == 'NotAvailable') {
        objSelf.MAP_NODISPOBG = '#cc0000';
        objSelf.MAP_AVAIBILITY = 'No Disponible';
        if (objSelf.MAP_DISPOBG == '#358717') {
            objSelf.MAP_DISPOBG = '#6f6f6f';
        }
    }
}

async function openEditViewOfExtraSituationFrom (objSelf) {
    let cceRegionID = (isIBDServer() == false) ? getDevEnvSetts().cceRegionid : getProdEnvSetts().cceRegionid;
    let extraSituationsColl;
    
    
    if (objSelf.CODIGOREGION == cceRegionID) {
        // Es una situación extraordinaria de CCE
        extraSituationsColl = await appData.getCollection("SituacionExtraordinariaCCE");
        extraSituationsColl = extraSituationsColl.createClone();
        extraSituationsColl.clear();
    } else {
        // Es una situación extraordinaria ordinaria
        extraSituationsColl = await appData.getCollection("SituacionExtraordinaria");
        extraSituationsColl = extraSituationsColl.createClone();
        extraSituationsColl.clear();
    }
    extraSituationsColl.setMacro("##MACRO##","s.CODIGO='" + objSelf.MAP_CODIGO + "'");
    await extraSituationsColl.loadAll();
    
    if (extraSituationsColl.getCount() > 0) {
        let extraSituationObj=await extraSituationsColl.getItem(0);
        extraSituationObj.MAP_RECORDSTATE = 'EDIT';
        extraSituationObj.MAP_BLOQUEADO = 1;
        extraSituationObj.MAP_OBJINI = objSelf.getParent();
        appData.pushValue(extraSituationObj);
    }
}

async function openEditViewFor(objSelf, collName, filterCond) {
    let collection = await appData.getCollection(collName);
    let collObj = await collection.findObject(filterCond);
    if (!isNothing(collObj)) {
        let parent = objSelf.getParent();
        if (!isNothing(parent)) {
            objSelf.MAP_SITUACIONEXTRA = parent.MAP_SITUACIONEXTRA;
        }
        appData.pushValue(collObj);
    }
}

async function updateData(objSelf, collName, contentName, contentProp, countColl) {
    let dataType = (collName == 'Nivel' || collName == 'SeguimientoSituacionVigente' 
        || collName == 'Comite' || collName == 'Region' 
        || collName == 'Causa' || collName == 'TipoUnidadOrganizativa') ? 'Data' : 
        (collName == 'Usuarios' || collName == 'ZonaOrganizativa' || collName == 'UnidadOrganizativa'
        || collName == 'HistoricoSituaciones' || collName == 'Contacto') ? 'DataWithNavigation' : collName;
    switch(dataType) {
        case 'Data':
            /*  Aplica para: 'Nivel', 'SeguimientoSituacionVigente', 'Comite', 
              'Region', 'Causa', 'TipoUnidadOrganizativa'  */
            let content = await objSelf.getContents("DataContent");
            content.unlock();
            content.clear();
            await content.loadAll();
            content.lock();
            objSelf.MAP_AREALLSELECTED = 0;
            objSelf.MAP_ROWSCOUNT = content.count();
            objSelf.MAP_SELECTEDROWSCOUNT = 0;
            ui.refresh("MAP_AREALLSELECTED,MAP_SELECTEDROWSCOUNT,MAP_ROWSCOUNT,DataContent,MAP_DATACONTENT");
            break;
        case 'DataWithNavigation':
            /*  Aplica para: 'Usuarios', ZonaOrganizativa', 'UnidadOrganizativa', 'HistoricoSituaciones'  */
            let fromValue, toValue;
            await loadData(objSelf, contentName, contentProp, 1, 0, 0, objSelf.MAP_PAG_LEN);
            let ctr = await appData.getCollection(countColl);
            await ctr.loadAll();
            objSelf.MAP_TOTAL_REGISTROS = (await ctr.getItem(0)).MAP_CONTADOR;
            fromValue = 0; 
            toValue = objSelf.MAP_PAG_LEN;
            if (toValue > objSelf.MAP_TOTAL_REGISTROS) 
                toValue = objSelf.MAP_TOTAL_REGISTROS;
            objSelf.MAP_AREALLSELECTED = 0;
            objSelf.MAP_ROWSCOUNT = "Filas de " + fromValue + " a " + toValue + " / " + objSelf.MAP_TOTAL_REGISTROS;
            objSelf.MAP_SELECTEDROWSCOUNT = 0;
            break;
    }
}

function getSortConditionFor(dataName, fieldName, order) {
    let sortCondition = "";
    switch(dataName) {
        case 'Nivel':
            sortCondition = fieldName + ' ' + order;
            break;
        case 'SituacionExtraordinaria':
            if (fieldName == "CODIGO") {
                sortCondition = "s.CODIGO";
            } else if (fieldName == "DESCRIPCION") {
                sortCondition = "s.NOMBRE";
            } else if (fieldName == "TIPO") {
                sortCondition = "t.NOMBRE";
            } else if (fieldName == "REGION") {
                sortCondition = "r.NOMBRE";
            } else if (fieldName == "FECHAFINESTIMADA") {
                sortCondition = "s.FECHAFINESTIMADA";
            } else if (fieldName == 'BAJA') {
                sortCondition = "s.BAJA";
            }
            
            if (!isNothing(sortCondition) && sortCondition.length > 0) {
                sortCondition += ' ' + order;
            }
            break;
        case 'Usuarios':
            if (fieldName == "NOMBRE") {
                sortCondition = "u.NOMBRE";
            } else if (fieldName == "NUMEXPEDIENTE") {
                sortCondition = "u.NUMEXPEDIENTE";
            } else if (fieldName == "EMAIL") {
                sortCondition = "u.EMAIL";
            } else if (fieldName == "TELEFONO") {
                sortCondition = "u.TELEFONO";
            } else if (fieldName == 'BAJA') {
                sortCondition = "u.BAJA";
            }
            
            if (!isNothing(sortCondition) && sortCondition.length > 0) {
                sortCondition += ' ' + order;
            }
            break;
        case 'Comite':
            if (fieldName == "DESCRIPCION") {
                sortCondition = "c.DESCRIPCION";
            } else if (fieldName == "MAP_TITULARL") {
                sortCondition = "MAP_TITULARL";
            } else if (fieldName == "MAP_SUPLENTEL") {
                sortCondition = "MAP_SUPLENTEL";
            } else if (fieldName == 'BAJA') {
                sortCondition = "c.BAJA";
            } else if (fieldName == "COMITE_ASOCIADO") {
                sortCondition = "MAP_COMITEASOCIADO1 " + order;
            }
            if (!isNothing(sortCondition) && sortCondition.length > 0 && fieldName != 'COMITE_ASOCIADO') {
                sortCondition += ' ' + order;
            }
            break;
        case 'Region':
            if (fieldName == "NOMBRE") {
                sortCondition = "r.NOMBRE";
            } else if (fieldName == "CODIGO") {
                sortCondition = "r.CODIGO";
            } else if (fieldName == "ALIAS") {
                sortCondition = "r.ALIAS";
            } else if (fieldName == 'BAJA') {
                sortCondition = "r.BAJA";
            }
            
            if (!isNothing(sortCondition) && sortCondition.length > 0) {
                sortCondition += ' ' + order;
            }
            break;
        case 'ZonaOrganizativa':
            if (fieldName == "NOMBRE") {
                sortCondition = "z.NOMBRE";
            } else if (fieldName == "CODIGO") {
                sortCondition = "z.CODIGO";
            } else if (fieldName == "CODIGOREGION") {
                sortCondition = "z.CODIGOREGION";
            } else if (fieldName == "TIPOZONA") {
                sortCondition = "z.TIPOZONA";
            } else if (fieldName == 'BAJA') {
                sortCondition = "z.BAJA";
            }
            
            if (!isNothing(sortCondition) && sortCondition.length > 0) {
                sortCondition += ' ' + order;
            }
            break;
        case 'UnidadOrganizativa':
            if (fieldName == "NOMBRE") {
                sortCondition = "u.NOMBRE";
            } else if (fieldName == "ZONA") {
                sortCondition = "z.NOMBRE";
            } else if (fieldName == "TIPOZONA") {
                sortCondition = "t.NOMBRE";
            } else if (fieldName == 'BAJA') {
                sortCondition = "u.BAJA";
            }
            
            if (!isNothing(sortCondition) && sortCondition.length > 0) {
                sortCondition += ' ' + order;
            }
            break;
        case 'Causa':
            if (fieldName == "NOMBRE") {
                sortCondition = "c.NOMBRE";
            } else if (fieldName == "CODIGO") {
                sortCondition = "c.CODIGO";
            } else if (fieldName == 'BAJA') {
                sortCondition = "c.BAJA";
            }
            
            if (!isNothing(sortCondition) && sortCondition.length > 0) {
                sortCondition += ' ' + order;
            }
            break;
        case 'TipoUnidadOrganizativa':
            if (fieldName == "NOMBRE") {
                sortCondition = "t.NOMBRE";
            } else if (fieldName == "CODIGO") {
                sortCondition = "t.CODIGO";
            } else if (fieldName == 'BAJA') {
                sortCondition = "t.BAJA";
            }
            
            if (!isNothing(sortCondition) && sortCondition.length > 0) {
                sortCondition += ' ' + order;
            }
            break;
        case 'Contacto':
            if (fieldName == "NOMBRE") {
                sortCondition = "c.NOMBRE";
            } else if (fieldName == "DESCRIPCION") {
                sortCondition = "c.DESCRIPCION";
            } else if (fieldName == "EMAIL") {
                sortCondition = "c.EMAIL";
            } else if (fieldName == 'TELEFONO') {
                sortCondition = "c.TELEFONO";
            } else if (fieldName == 'MAP_CONTEXTO') {
                sortCondition = "MAP_CONTEXTO";
            }
            
            if (!isNothing(sortCondition) && sortCondition.length > 0) {
                sortCondition += ' ' + order;
            }
            break;
        case 'Carpetas':
            if (fieldName == "NOMBRE") {
                sortCondition = "r.NOMBRE";
            } else if (fieldName == "DESCRIPCION") {
                sortCondition = "r.DESCRIPCION";
            } else if (fieldName == "REGION") {
                sortCondition = "c.NOMBRE";
            } 
            if (!isNothing(sortCondition) && sortCondition.length > 0) {
                sortCondition += ' ' + order;
            }
            break;
    }
    return sortCondition;
}

async function sortData(objSelf, dataName, fieldName, order, buttonName, contentName, contentProp, countColl) {
    let dataType = (dataName == 'Nivel' || dataName == 'SeguimientoSituacionVigente' 
        || dataName == 'Comite' || dataName == 'Region' 
        || dataName == 'Causa' || dataName == 'TipoUnidadOrganizativa'
        || dataName == 'Carpetas') ? 'Data' : 
        (dataName == 'Usuarios' || dataName == 'ZonaOrganizativa' || dataName == 'UnidadOrganizativa'
        || dataName == 'HistoricoSituaciones' || dataName == 'Contacto') ? 'DataWithNavigation' : dataName;
        
    // En caso de cambio de campo para ordenar el listado siempre ordenamos de forma ascendente.
    // En cualquier otro caso invertimos el orden actual.
    if (objSelf.MAP_FIELDNAME != fieldName || order === 'DESC') {
        objSelf.MAP_ORDER = 'ASC';
        objSelf.setFieldPropertyValue(buttonName, 'path', 'upArrow.png');
    } else {
        objSelf.MAP_ORDER = 'DESC';
        objSelf.setFieldPropertyValue(buttonName, 'path', 'downArrow.png');
    }
        
    // Guardamos el campo por el que se ordena el listado.
    objSelf.MAP_FIELDNAME = fieldName;
    
    // Obtenemos la expresión para ordenar el listado.
    if (dataName == "SeguimientoSituacionVigente" || dataName == "HistoricoSituaciones") {
        dataName = "SituacionExtraordinaria";
    }
    
    let sortCondition = getSortConditionFor(dataName, fieldName, objSelf.MAP_ORDER);
    
    if (!isNothing(sortCondition) && sortCondition.length > 0) {
        let content, refreshProps;
    
        content = await objSelf.getContents(contentName);
        refreshProps = contentName + ',' + contentProp + ',' + buttonName;
        content.unlock();
        content.setSort(sortCondition);
        
        switch(dataType) {
            case 'Data':
                await content.loadAll();
                break;
            case 'DataWithNavigation':
                await loadData(objSelf, contentName, contentProp, 0, 0, 0, objSelf.MAP_PAG_LEN);
                let fromValue, toValue;
                let ctr = await appData.getCollection(countColl);
                await ctr.loadAll();
                objSelf.MAP_TOTAL_REGISTROS = (await ctr.getItem(0)).MAP_CONTADOR;
                fromValue = 0; 
                toValue = objSelf.MAP_PAG_LEN;
                if (toValue > objSelf.MAP_TOTAL_REGISTROS) 
                    toValue = objSelf.MAP_TOTAL_REGISTROS;
                objSelf.MAP_AREALLSELECTED = 0;
                objSelf.MAP_ROWSCOUNT = "Filas de " + fromValue + " a " + toValue + " / " + objSelf.MAP_TOTAL_REGISTROS;
                objSelf.MAP_SELECTEDROWSCOUNT = 0;
                break;
        }
        
        content.lock();
        ui.refresh(refreshProps);
        
    }
}

async function selectOrUnselectAll(objSelf, dataName, contentName) {
    let dataType = (dataName == 'Nivel' || dataName == 'SeguimientoSituacionVigente' 
        || dataName == 'HistoricoSituaciones'
        || dataName == 'Comite' || dataName == 'Region' || dataName == 'ZonaOrganizativa' 
        || dataName == 'UnidadOrganizativa' || dataName == 'Causa' || dataName == 'TipoUnidadOrganizativa') ? 'Data' : dataName;
    
    let content;
    switch(dataType) {
        case 'Data':
            /* Aplica para: 'Nivel', 'SeguimientoSituacionVigente', 'HistoricoSituaciones', 'Usuarios', 'Comite', 
              'Region', 'ZonaOrganizativa', 'TipoUnidadOrganizativa' */
            content = await objSelf.getContents("DataContent");
            content.unlock();
            for (let i = 0; i < content.count(); i++) {
                let element = await content.getItem(i);
                element.MAP_ISSELECTED = objSelf.MAP_AREALLSELECTED;
            }
            content.lock();
            break;
        case 'CausasEnSituacion':
             /* Aplica para: 'CausasContent' en SituacionExtraordinaria */
            content = await objSelf.getContents(contentName);
            content.unlock();
            for (let i = 0; i < content.count(); i++) {
                let element = await content.getItem(i);
                element.MAP_ISSELECTED = objSelf.MAP_AREALLSELECTED;
            }
            content.lock();
            break;
        case 'Usuarios':
            if (objSelf.MAP_SELECTEDROWSCOUNT >= 0) {
                content = await objSelf.getContents('UsuariosListMaestro');
                content.unlock();
                for (let i = 0; i < content.count(); i++) {
                    let element = await content.getItem(i);
                    element.MAP_ISSELECTED = objSelf.MAP_AREALLSELECTED;
                }
                content.lock();
            } else {
                // En este caso solo dejamos el contador de los seleccionados a 0.
                // Este caso se produce porque se pierden los marcajes al usar el paginado.
                objSelf.MAP_SELECTEDROWSCOUNT = 0;
            }
            break;
        case 'Contacto':
            if (objSelf.MAP_SELECTEDROWSCOUNT >= 0) {
                content = await objSelf.getContents('ContactosListMaestro');
                content.unlock();
                for (let i = 0; i < content.count(); i++) {
                    let element = await content.getItem(i);
                    element.MAP_ISSELECTED = objSelf.MAP_AREALLSELECTED;
                }
                content.lock();
            } else {
                // En este caso solo dejamos el contador de los seleccionados a 0.
                // Este caso se produce porque se pierden los marcajes al usar el paginado.
                objSelf.MAP_SELECTEDROWSCOUNT = 0;
            }
            break;
        case 'ContactosEnSituacion':
            if (objSelf.MAP_SELECTEDROWSCOUNT >= 0) {
                content = await objSelf.getContents('ContactosListMaestro');
                content.unlock();
                for (let i = 0; i < content.count(); i++) {
                    let element = await content.getItem(i);
                    element.MAP_ISSELECTED = objSelf.MAP_CAREALLSELECTED;
                }
                content.lock();
            } else {
                // En este caso solo dejamos el contador de los seleccionados a 0.
                // Este caso se produce porque se pierden los marcajes al usar el paginado.
                objSelf.MAP_SELECTEDROWSCOUNT = 0;
            }
            break;
        
    }
}

async function deleteData(objSelf, dataName) {
    let dataType = (dataName == 'Nivel' || dataName == 'Usuarios' || dataName == 'Comite' 
        || dataName == 'Region' || dataName == 'ZonaOrganizativa' || dataName == 'UnidadOrganizativa'
        || dataName == 'Causa' || dataName == 'TipoUnidadOrganizativa' || dataName == 'Contacto') ? 'Data' : dataName;
    let dataColl = await appData.getCollection(dataName);
    let content, refreshProps;
    
    if (dataName == 'Usuarios') {
        content = await objSelf.getContents('UsuariosListMaestro');
        refreshProps = 'UsuariosListMaestro';
    } else if (dataName == 'Contacto') {
        content = await objSelf.getContents('ContactosListMaestro');
        refreshProps = 'ContactosListMaestro';
    } else {
        content = await objSelf.getContents("DataContent");   
        refreshProps = 'DataContent,MAP_DATACONTENT';
    }
    content.unlock();
    
    let elementObj;
    
    for (let i = 0; i < content.count(); i++) {
        let element = await content.getItem(i);
        if (element.MAP_ISSELECTED == 1) {
            switch(dataType) {
                case 'Data':
                    /* Aplica para: 'Nivel', 'Usuarios', 'Comite', 'Region', 'ZonaOrganizativa', 'UnidadOrganizativa', 
                      'Causa', 'TipoUnidadOrganizativa', 'Contacto'  */
                    element.BAJA = 1;
                    await element.save();
                    break;
                case 'SituacionExtraordinaria':
                    elementObj = await dataColl.findObject("s.CODIGO == '" + element.MAP_CODIGO + "'");
                    if (!isNothing(elementObj)) {
                        elementObj.BAJA = 1;
                        await elementObj.save();
                    }
                    break;
            }
        }
    }
    
    if (dataName == 'Usuarios' || dataName == 'Contacto') {
        let contentName = (dataName == 'Usuarios') ? 'UsuariosListMaestro' : 'ContactosListMaestro';
        let counterCollName = (dataName == 'Usuarios') ? 'UsuariosListMaestroContador' : 'ContactosListMaestroContador';
        let fromValue, toValue;
        await loadData(objSelf, contentName, contentName, 1, 0, objSelf.MAP_PAG_INI, objSelf.MAP_PAG_LEN);
        let ctr = await appData.getCollection(counterCollName);
        await ctr.loadAll();
        objSelf.MAP_TOTAL_REGISTROS = (await ctr.getItem(0)).MAP_CONTADOR;
        fromValue = 0; 
        toValue = objSelf.MAP_PAG_LEN;
        if (fromValue > objSelf.MAP_TOTAL_REGISTROS) 
            toValue = objSelf.MAP_TOTAL_REGISTROS;
        objSelf.MAP_AREALLSELECTED = 0;
        objSelf.MAP_ROWSCOUNT = "Filas de " + fromValue + " a " + toValue + " / " + objSelf.MAP_TOTAL_REGISTROS;
        objSelf.MAP_SELECTEDROWSCOUNT = 0;
    } else {
        content.clear();
        await content.loadAll();
        content.lock();
        ui.refresh(refreshProps);
    }
}

function updateSelectedRowsCount(objSelf) {
    let parent = objSelf.getParent();
    if (objSelf.MAP_ISSELECTED == 1) {
        parent.MAP_SELECTEDROWSCOUNT += 1;
    } else if (objSelf.MAP_ISSELECTED == 0 && parent.MAP_SELECTEDROWSCOUNT > 0) {
        parent.MAP_SELECTEDROWSCOUNT -= 1;
        if (parent.MAP_SELECTEDROWSCOUNT == 0 && parent.MAP_AREALLSELECTED == 1) {
            parent.MAP_AREALLSELECTED = 0;
        }
    }
    //ui.refreshValue("MAP_SELECTEDROWSCOUNT");
}

async function addSelectedZonesTo(objSelf, situationCode) {
    let dataColl = await appData.getCollection("ZonaAfectada");
    let content = await objSelf.getContents("ZonesContent");
    content.unlock();
    
    for (let i = 0; i < content.count(); i++) {
        let element = await content.getItem(i);
        if (element.MAP_ISSELECTED == 1) {
            await createNewAffectedZone(situationCode, element.MAP_CODIGO, element.MAP_TITULAR, element.MAP_SUPLENTE, dataColl);
        }
    }
    content.clear();
    await content.loadAll();
    content.lock();
    
    let dataContent = await objSelf.getContents("DataContent");
    dataContent.unlock();
    await dataContent.loadAll();
    dataContent.lock();
    
    ui.refresh("ZonesContent,MAP_ZONESCONTENT,DataContent,MAP_DATACONTENT");
   
    dataColl = null;
    content = null;
    dataContent = null;
    objSelf.MAP_EDITEDDATA = 1;
}

async function addSelectedUnitsTo(objSelf, situationCode) {
    let dataColl = await appData.getCollection("UnidadAfectada");
    let content = await objSelf.getContents("UnitsContent");
    content.unlock();
    
    for (let i = 0; i < content.count(); i++) {
        let element = await content.getItem(i);
        if (element.MAP_ISSELECTED == 1) {
            await createNewAffectedUnit(situationCode, element.MAP_CODIGO, element.MAP_CODIGOZONA, element.MAP_TITULAR, element.MAP_SUPLENTE, dataColl);
        }
    }
    content.clear();
    await content.loadAll();
    content.lock();
    
    let dataContent = await objSelf.getContents("DataContent");
    dataContent.unlock();
    await dataContent.loadAll();
    dataContent.lock();
    
    ui.refresh("UnitsContent,MAP_UNITSCONTENT,DataContent,MAP_DATACONTENT");
   
    dataColl = null;
    content = null;
    dataContent = null;
    objSelf.MAP_EDITEDDATA = 1;
}

async function removeSelectedZonesTo(objSelf, situationCode) {
    let content = await objSelf.getContents("DataContent");
    //let editState = 1;
    content.unlock();
    //let unidadesAffColl = appData.getCollection("UnidadAfectada");
    //unidadesAffColl.unlock();
    
    for (let i = 0; i < content.count(); i++) {
        let element = await content.getItem(i);
        if (element.MAP_ISSELECTED == 1) {
            //unidadesAffColl.setMacro("##MACRO##", "u.CODIGOZONA = '" + element.CODIGO + "' AND (u.BAJA IS NULL OR u.BAJA = 0) AND u.TIPOUNIDADORG in ('SECTOR')");
            //unidadesAffColl.loadAll();
            //let unitsCount = unidadesAffColl.getCount();
            //if (unitsCount > 0 && editState != 2) 
                //editState = 2;
            //for (let j = 0; j < unitsCount; j++) {
            //    let unidadObj = unidadesAffColl.getItem(i);
            //    unidadObj.deleteObject();
            //}
            await element.deleteObject();
        }
    }
    
    //unidadesAffColl.setMacro("##MACRO##", "");
    //unidadesAffColl.lock();
    
    content.clear();
    await content.loadAll();
    content.lock();
    
    content = await objSelf.getContents("ZonesContent");
    content.unlock();
    await content.loadAll();
    content.lock();
    
    ui.refresh("DataContent,MAP_DATACONTENT,ZonesContent,MAP_ZONESCONTENT");
    
    content = null;
    objSelf.MAP_EDITEDDATA = 1;
}

async function removeSelectedUnitsTo(objSelf, situationCode) {
    let content = await objSelf.getContents("DataContent");
    content.unlock();
    
    for (let i = 0; i < content.count(); i++) {
        let element = await content.getItem(i);
        if (element.MAP_ISSELECTED == 1) {
            await element.deleteObject();
        }
    }
    content.clear();
    await content.loadAll();
    content.lock();
    
    content = await objSelf.getContents("UnitsContent");
    content.unlock();
    await content.loadAll();
    content.lock();
    
    ui.refresh("DataContent,MAP_DATACONTENT,UnitsContent,MAP_UNITSCONTENT");
    
    content = null;
    objSelf.MAP_EDITEDDATA = 1;
}

function getFilterConditions(textFilterCondition) {
    let textFilters = textFilterCondition.split(' ');
    
    let filtersConditions = [];
    
    for (let i = 0; i < textFilters.length; i++) {
        let filterText = textFilters[i].trim();
        
        if (filterText.length > 0) {
            filtersConditions.push(filterText.toUpperCase());
        }
    }
    return filtersConditions;
}

async function applyFilterForContent(objSelf, dataName, contentName, contentProp, filterCondition) {
    let content = await objSelf.getContents(contentName);
    
    let situationCode = objSelf.MAP_CODIGOSITUACION;
    let filtersConds = getFilterConditions(filterCondition);
    
    let macroForContent = '';
    
    for (let i = 0; i < filtersConds.length; i++) {
        if (macroForContent.length != 0) {
            macroForContent += " OR ";
           
        } else if (macroForContent.length == 0) {
            macroForContent += "(";
        }
        switch(dataName) {
            case 'Zones':
                macroForContent += "UPPER(z.CODIGO) like '%" + filtersConds[i] + "%' OR UPPER(CONCAT(CONCAT(t.NOMBRE, ' '), z.NOMBRE)) like '%" + filtersConds[i] + 
                    "%' OR UPPER(r.CODIGO) like '%" + filtersConds[i] + "%' OR UPPER(r.NOMBRE) like '%" + filtersConds[i] + "%'";
                //TODO: Añadir el campo ALIAS para tenerlo en cuenta en la búsqueda:  OR UPPER(r.ALIAS) like '%" + filtersConds[i] + "%'.
                break;
            case 'Units':
                macroForContent += "UPPER(o.CECO) like '%" + filtersConds[i] + "%' OR UPPER(o.NOMBRE) like '%" + filtersConds[i] + 
                    "%' OR UPPER(o.CODIGOZONA) like '%" + filtersConds[i] + "%' OR UPPER(z.NOMBRE) like '%" + filtersConds[i] + "%'";
                //TODO: Añadir el campo ALIAS para tenerlo en cuenta en la búsqueda:  OR UPPER(r.ALIAS) like '%" + filtersConds[i] + "%'.
                break;
        }
    }
    
    let addCloseParenthesis = (macroForContent.length != 0);
     
    if (macroForContent.length != 0) {
        macroForContent += ") AND (";
    }
    
    let contentGName = (contentName == 'ZonesContent' || contentName == 'UnitsContent') ? 'NotSelectedData' : contentName;
    
    switch(contentGName) {
        case 'NotSelectedData':
            macroForContent += "z.CODIGOREGION ='" + objSelf.MAP_CODIGOREGION + "' AND a.CODIGOSITUACION IS NULL";
            break;
        case 'DataContent':
            macroForContent += "z.CODIGOREGION ='" + objSelf.MAP_CODIGOREGION + "' AND a.CODIGOSITUACION = '" + situationCode + "'";
            break;
    }
    
    if (addCloseParenthesis) {
        macroForContent += ")";
    }
    
    content.unlock();
    content.setMacro("##MACRO##", macroForContent);
    content.clear();
    await content.loadAll();
    content.lock();
    
    ui.refresh(contentName + "," + contentProp);
}

async function applyFilterForZoneContent(objSelf, contentName, contentProp, filterCondition) {
    let content = await objSelf.getContents(contentName);
    content.unlock();
    
    let situationCode = objSelf.MAP_CODIGOSITUACION;
    let filtersConds = getFilterConditions(filterCondition);
    
    let macroForContent = '';
    
    for (let i = 0; i < filtersConds.length; i++) {
        if (macroForContent.length != 0) {
            macroForContent += " OR ";
           
        } else if (macroForContent.length == 0) {
            macroForContent += "(";
        }
        macroForContent += "UPPER(z.CODIGO) like '%" + filtersConds[i] + "%' OR UPPER(CONCAT(CONCAT(t.NOMBRE, ' '), z.NOMBRE)) like '%" + filtersConds[i] + 
            "%' OR UPPER(r.CODIGO) like '%" + filtersConds[i] + "%' OR UPPER(r.NOMBRE) like '%" + filtersConds[i] + "%'";
        //TODO: Añadir el campo ALIAS para tenerlo en cuenta en la búsqueda:  OR UPPER(r.ALIAS) like '%" + filtersConds[i] + "%'.
    }
    
    let addCloseParenthesis = (macroForContent.length != 0);
     
    if (macroForContent.length != 0) {
        macroForContent += ") AND (";
    }
    
    switch(contentName) {
        case 'ZonesContent':
            macroForContent += "a.CODIGOSITUACION IS NULL OR a.CODIGOSITUACION != '" + situationCode + "'";
            break;
        case 'DataContent':
            macroForContent += "a.CODIGOSITUACION = '" + situationCode + "'";
            break;
    }
    
    if (addCloseParenthesis) {
        macroForContent += ")";
    }
    
    content.setMacro("##MACRO##", macroForContent);
    content.clear();
    await content.loadAll();
    content.lock();
    
    ui.refresh(contentName + "," + contentProp);
}

async function applyFilterForReasons(objSelf) {
    let filterCondition = objSelf.MAP_CAUSASFILTER;
    let content = await objSelf.getContents("CausasContent");
    let filterForContent = '';
    
    if(!isNothing(filterCondition) && filterCondition != '') {
        let filtersConds = getFilterConditions(filterCondition);
        
        for (let i = 0; i < filtersConds.length; i++) {
            if (filterForContent.length != 0) {
                filterForContent += " OR "
               
            } else if (filterForContent.length == 0) {
                filterForContent += "("
            }
            filterForContent += "UPPER(r.NOMBRE) like '%" + filtersConds[i] + "%'";
        }
    }
         
    if (filterForContent.length != 0) {
        filterForContent += ")";
    }
    
    content.unlock();
    content.setMacro("##FILTER##", filterForContent);
    content.clear();
    await content.loadAll();
    content.lock();
    
    ui.refresh("CausasContent,MAP_CAUSAS");
}

function getfilterSentenceFor(contentName, filterCond) {
    let resultedCond;
    switch(contentName) {
        case 'ComitteeContent':
            resultedCond = "UPPER(c.DESCRIPCION) like '%" + filterCond.toUpperCase() + "%'";
            break;
        case 'HoldersContent':
            resultedCond = "UPPER(u.NOMBRE) like '%" + filterCond.toUpperCase() + "%'";
            break;
        case 'SubstitutesContent':
            resultedCond = "UPPER(u.NOMBRE) like '%" + filterCond.toUpperCase() + "%'";
            break;  
        case 'TypesContent':
            resultedCond = "UPPER(t.NOMBRE) like '%" + filterCond.toUpperCase() + "%'";
            break;
        case 'StatesContent':
            resultedCond = "UPPER(s.NOMBRE) like '%" + filterCond.toUpperCase() + "%'";
            break;
        case 'RegionsContent':
            resultedCond = "UPPER(r.NOMBRE) like '%" + filterCond.toUpperCase() + "%'";
            break;
    }
    
    return resultedCond;
}

async function applyFilterFor(objSelf, filterCondition, contentName, refreshProps) {
    let content = await objSelf.getContents(contentName);
    let filterForContent = '';
    
    if(!isNothing(filterCondition) && filterCondition != '') {
        let filtersConds = getFilterConditions(filterCondition);
        
        for (let i = 0; i < filtersConds.length; i++) {
            if (filterForContent.length != 0) {
                filterForContent += " AND "
               
            } else if (filterForContent.length == 0) {
                filterForContent += "("
            }
            filterForContent += getfilterSentenceFor(contentName, filtersConds[i]);
        }
    }
         
    if (filterForContent.length != 0) {
        filterForContent += ")";
    }
    
    content.unlock();
    content.setMacro("##MACRO##", filterForContent);
    content.clear();
    await content.loadAll();
    content.lock();
    
    ui.refresh(refreshProps);
}

async function addReasonsTo(situationObj, situationCode) {
    let selectedReasons = await situationObj.getContents("CausasSituContent");
    
    let reasonsColl = await appData.getCollection("CausaSituacion");
    reasonsColl.unlock();
    let selectedReasonObj, reasonObj;
    
    for (let i = 0; i < selectedReasons.count(); i++) {
        selectedReasonObj = await selectedReasons.getItem(i);
        reasonObj = await reasonsColl.findObject("c.SITUACIONCODIGO='" + situationObj.MAP_CODIGO + "' AND c.CAUSACODIGO='" + selectedReasonObj.CAUSACODIGO + "'");
        if (isNothing(reasonObj)) {
            reasonObj = await reasonsColl.createObject({
                CAUSACODIGO: selectedReasonObj.CAUSACODIGO,
                CAUSAID: selectedReasonObj.CAUSAID,
                SITUACIONCODIGO: situationObj.MAP_CODIGO,
                USUARIOCODIGO: user.ID,
                FECHACREACION: new Date(),
                BAJA: 0,
                ACTUALIZADO: 1
            });
            reasonsColl.addItem(reasonObj);
            await reasonObj.save();
        }
    }
    reasonsColl.lock();
    
}

async function saveReasonsTo(objSelf, situationObj) {
    //let selectedReasons = situationObj.getContents("CausasSituContent");
    let selectedReasons = await objSelf.getContents("CausasContent");
 
    let reasonsColl = await appData.getCollection("CausaSituacion");
    reasonsColl.unlock();
    reasonsColl.setMacro("##MACRO##", "");
    
    let selectedReasonObj, reasonObj;
    
    //let reasonsForSituation = "";
    let selectedReasonsCount = selectedReasons.count();
    
    // Añade las causas que se hayan incorporado a la situación.
    for (let i = 0; i < selectedReasonsCount; i++) {
        selectedReasonObj = await selectedReasons.getItem(i);
        
        reasonObj = await reasonsColl.findObject("c.SITUACIONCODIGO='" + situationObj.MAP_CODIGO + "' AND c.CAUSACODIGO='" + selectedReasonObj.CODIGO + "'");
        //if (isNothing(reasonObj)) {
        if (isNothing(reasonObj) && selectedReasonObj.MAP_ISSELECTED == 1) {
            reasonObj = await reasonsColl.createObject({
                //CAUSACODIGO: selectedReasonObj.CAUSACODIGO,
                CAUSACODIGO: selectedReasonObj.CODIGO,
                //CAUSAID: selectedReasonObj.CAUSAID,
                CAUSAID: selectedReasonObj.ID,
                SITUACIONCODIGO: situationObj.MAP_CODIGO,
                USUARIOCODIGO: user.LOGIN,
                FECHACREACION: new Date(),
                BAJA: 0,
                ACTUALIZADO: 1
            });
            reasonsColl.addItem(reasonObj);
            await reasonObj.save();    
        } else if (!isNothing(reasonObj) && selectedReasonObj.MAP_ISSELECTED == 0 && reasonObj.BAJA != 1) {
            reasonObj.BAJA = 1;
            await reasonObj.save();
        } else if (!isNothing(reasonObj) && selectedReasonObj.MAP_ISSELECTED == 1 && reasonObj.BAJA == 1) {
            reasonObj.BAJA = 0;
            await reasonObj.save();
        }
        //if(reasonsForSituation.length == 0) {
        //    reasonsForSituation = "('" + selectedReasonObj.CAUSACODIGO + "'";
        //} else {
        //    reasonsForSituation += ", '" + selectedReasonObj.CAUSACODIGO + "'";
        //}
    }
    
    /*
    let reasonsCollMacro = "c.SITUACIONCODIGO='" + situationObj.MAP_CODIGO + "'";
  
    if (reasonsForSituation.length > 0) {
        reasonsForSituation += ")";
        reasonsCollMacro += " AND c.CAUSACODIGO NOT IN" + reasonsForSituation;
    }
    
    reasonsColl.setMacro("##MACRO##", reasonsCollMacro);
    reasonsColl.loadAll();
    let reasonsForSituationCount = reasonsColl.getCount();
    
    // Elimina las causas que se hayan eliminado de la situación.
    for (let j = 0; j < reasonsForSituationCount; j++) {
        reasonObj = reasonsColl.getItem(j);
        reasonObj.BAJA = 1;
        reasonObj.save();
    }
    
    reasonsColl.setMacro("##MACRO##", "");
    reasonsColl.clear();
    */
    reasonsColl.lock();
}

async function addReasonTo(reason, situationObj) {
    if (isNothing(situationObj.MAP_CODIGO) || situationObj.MAP_CODIGO == '') {
        return;
    }
    
    let availableReasons = await situationObj.getContents("CausasContent");
    let selectedReasons = await situationObj.getContents("CausasSituContent");
    let existe=0;
    
    for (let j = 0; j < selectedReasons.getCount(); j++) {
        if ((await selectedReasons.getItem(j)).MAP_NOMBRE==reason.MAP_NOMBRE) {
            existe=1;
        }
    }
    if (existe==0) {
        let obj=await selectedReasons.createObject({
            MAP_NOMBRE: reason.MAP_NOMBRE,
            CAUSACODIGO: reason.MAP_CODIGO,
            CAUSAID: reason.ID,
            //CAUSACODIGO: reason.MAP_CODIGO,
            SITUACIONCODIGO: situationObj.MAP_CODIGO,
            USUARIOCODIGO: user.LOGIN,
            FECHACREACION: new Date(),
            BAJA: 0,
            ACTUALIZADO: 1
        });
        selectedReasons.addItem(obj);
    }
    
    ui.refresh("MAP_CAUSASSITU,MAP_CAUSAST");
}

async function deleteReasonFrom(situationCode, reasonCode, reasonName, situationObj, objdelete) {
    let reasonsColl = await situationObj.getContents("CausasSituContent");
    for (let i = 0; i < reasonsColl.getCount(); i++){
        if ((await reasonsColl.getItem(i)).MAP_NOMBRE==reasonName) {
            reasonsColl.removeItem(i);   
        }
    }
    
    ui.refresh("MAP_CAUSASSITU,MAP_CAUSAST");
}
    
async function addNewZoneToSituation(objSelf, situationCode) {
    await addNewRecord(objSelf, "z.CODIGO = '" + objSelf.MAP_CODIGO + "'", "ZonaOrganizativa", true, false);
    let dataColl = await appData.getCollection("ZonaAfectada");
    await createNewAffectedZone(situationCode, objSelf.MAP_CODIGO, dataColl)
    
    let dataContent = await objSelf.getContents("DataContent");
    dataContent.unlock();
    await dataContent.loadAll();
    dataContent.lock();
    
    ui.refresh("DataContent,MAP_DATACONTENT");
   
    dataColl = null;
    dataContent = null;
}

async function addNewUnitToSituation(objSelf, situationCode) {
    await addNewRecord(objSelf, "CECO = '" + objSelf.MAP_CODIGO + "'", "UnidadOrganizativa", true);
    let dataColl = await appData.getCollection("UnidadAfectada");
    await createNewAffectedUnit(situationCode, objSelf.MAP_CODIGO, objSelf.MAP_CODIGOZONE, dataColl)
    
    let dataContent = await objSelf.getContents("DataContent");
    dataContent.unlock();
    await dataContent.loadAll();
    dataContent.lock();
    
    ui.refresh("DataContent,MAP_DATACONTENT");
   
    dataColl = null;
    dataContent = null;
}

async function addNewZoneToSituationAndClose(objSelf, situationCode) {
    await addNewZoneToSituation(objSelf, situationCode);

    objSelf.MAP_CREATENEW = 0;
    objSelf.MAP_NOMBRE = "";
    objSelf.MAP_CODIGO = "";
    objSelf.MAP_REGIONID = 0;
    objSelf.MAP_CODIGOREG = "";
    objSelf.MAP_TIPOID = 0;
    objSelf.MAP_TIPOZONA = "";
    ui.refresh('FRM_EXISTEDAZONES,FRM_NEWZONE');
}

async function addNewUnitToSituationAndClose(objSelf, situationCode) {
    await addNewUnitToSituation(objSelf, situationCode);
    
    objSelf.MAP_CREATENEW = 0;
    ui.refresh('FRM_EXISTEDAZONES,FRM_NEWZONE');
}

async function loadUsersForSelectedComittee(objSelf) {
    let parent = objSelf.getParent();
    if (!isNothing(parent)) {
        parent.MAP_IDTITULAR = objSelf.TITULARID;
        parent.MAP_TITULAR = objSelf.MAP_TITULAR;
        parent.MAP_IDSUPLENTE = objSelf.SUPLENTEID;
        parent.MAP_SUPLENTE = objSelf.MAP_SUPLENTE;
        parent.MAP_NIVEL = objSelf.MAP_NOMBRE;
        parent.MAP_SHOWCOMITTEE = 0;
        parent.MAP_COMITTEEFILTER = '';
        parent.MAP_NIVELID = objSelf.COMITEID;
        parent.MAP_IDUSUARIO = user.ID;
        
        parent.MAP_AVAIBILITY = objSelf.DISPONIBILIDAD;
        let titularidad = objSelf.MAP_TITULARIDAD;
        let avaibility = (parent.MAP_AVAIBILITY == 'Disponible') ? 'Available' : (parent.MAP_AVAIBILITY == 'No Disponible') ? 'NotAvailable' : 'Desconocido';
                    
        if (avaibility != 'Desconocido') {
            changeAvaibilityStateBG(parent, avaibility);
        }
        
        parent.MAP_IDUSUARIO = user.ID;
        if (parent.MAP_IDUSUARIO ==  parent.MAP_IDTITULAR) {
            parent.MAP_TITULARBCOLOR = '#59CD00';
            parent.MAP_SUPLENTEBCOLOR = '#00000000';
            
        } else {
            parent.MAP_SUPLENTEBCOLOR = '#59CD00';
            parent.MAP_TITULARBCOLOR = '#00000000';
        }
        
        let comitteeContent = await parent.getContents("ComitteeContent");
        if (!isNothing(comitteeContent)) {
            comitteeContent.setMacro("##NIVELID##", parent.MAP_NIVELID);
            ui.refresh("ComitteeContent,MAP_COMITTEE");
        }
        
        /* Esto ya no se usa
        let holdersContent = parent.getContents("HoldersContent");
        if (!isNothing(holdersContent)) {
            holdersContent.setMacro("##USERCODE##", parent.MAP_IDTITULAR);
            ui.refresh("HoldersContent,MAP_TITULARS");
        }
        
        let substitutesContent = parent.getContents("SubstitutesContent");
        if (!isNothing(substitutesContent)) {
            substitutesContent.setMacro("##USERCODE##", parent.MAP_IDSUPLENTE);
            ui.refresh("SubstitutesContent,MAP_SUPLENTES");
        }
        */
    }    
}

async function loadSituationData(objSelf) {
    let parent = objSelf.getParent();
    if (!isNothing(parent)) {
        parent.MAP_SITUACIONCODIGO = objSelf.CODIGO;
        parent.MAP_SITUACION = objSelf.MAP_NOMBRE;
        parent.MAP_FECHAINICIO = objSelf.FECHAINICIO;
        parent.MAP_FECHAFIN = objSelf.FECHAFINESTIMADA;
        parent.MAP_REGION = objSelf.MAP_REGNOMBRE;
        parent.MAP_SHOWSITUATIONS = 0;
        parent.MAP_SITUATIONFILTER = '';
        
        let situationsContent = await parent.getContents("SituationsContent");
        if (!isNothing(situationsContent)) {
            situationsContent.setMacro("##SITUACIONCODIGO##", parent.MAP_SITUACIONCODIGO);
            
            let committeeContent = await parent.getContents("ComitteeContent");
            if (!isNothing(committeeContent)) {
                committeeContent.setMacro("##MACRO##", "gc.ID IS NOT NULL AND gs.CODIGO='" + parent.MAP_SITUACIONCODIGO + "'");
                committeeContent.setMacro("##IDUSUARIO##", user.ID);
                await committeeContent.loadAll();
                
                let comitteeContentCount = committeeContent.count();
                
                if (comitteeContentCount == 1) {
                    let committeeObj = await committeeContent.getItem(0);
                    parent.MAP_IDTITULAR = committeeObj.TITULARID;
                    parent.MAP_TITULAR = committeeObj.MAP_TITULAR;
                    parent.MAP_IDSUPLENTE = committeeObj.SUPLENTEID;
                    parent.MAP_SUPLENTE = committeeObj.MAP_SUPLENTE;
                    parent.MAP_NIVEL = committeeObj.MAP_NOMBRE;
                    parent.MAP_SHOWCOMITTEE = 0;
                    parent.MAP_COMITTEEFILTER = '';
                    parent.MAP_NIVELID = committeeObj.COMITEID;
                    parent.MAP_AVAIBILITY = committeeObj.DISPONIBILIDAD;
                    let titularidad = committeeObj.MAP_TITULARIDAD;
                    let avaibility = (parent.MAP_AVAIBILITY == 'Disponible') ? 'Available' : (parent.MAP_AVAIBILITY == 'No Disponible') ? 'NotAvailable' : 'Desconocido';
                    
                    if (avaibility != 'Desconocido') {
                        changeAvaibilityStateBG(parent, avaibility);
                    }
            
                    committeeContent.setMacro("##NIVELID##", parent.MAP_NIVELID);
                    ui.refresh("ComitteeContent,MAP_COMITTEE");
                    
                    parent.MAP_IDUSUARIO = user.ID;
                    if (parent.MAP_IDUSUARIO ==  parent.MAP_IDTITULAR) {
                        parent.MAP_TITULARBCOLOR = '#59CD00';
                        parent.MAP_SUPLENTEBCOLOR = '#00000000';
                        
                    } else {
                        parent.MAP_SUPLENTEBCOLOR = '#59CD00';
                        parent.MAP_TITULARBCOLOR = '#00000000';
                    }
                } else {
                    parent.MAP_IDTITULAR = 0;
                    parent.MAP_TITULAR = "";
                    parent.MAP_IDSUPLENTE = 0;
                    parent.MAP_SUPLENTE = "";
                    parent.MAP_NIVEL = "";
                    parent.MAP_SHOWCOMITTEE = 0;
                    parent.MAP_COMITTEEFILTER = '';
                    parent.MAP_NIVELID = 0;
                    parent.MAP_AVAIBILITY = "";
                    let titularidad = "";
                    
                    parent.MAP_DISPOBG = '#6f6f6f';
                    parent.MAP_NODISPOBG = '#6f6f6f';
                    
                    parent.MAP_TITULARBCOLOR = '#00000000';
                    parent.MAP_SUPLENTEBCOLOR = '#00000000';
                }
            }
            
            //ui.refresh("SituationsContent,MAP_SITUATIONS");
        }
    }    
}

async function getAssociatedComittee(objSelf) {
    let parent = objSelf.getParent();
    if (!isNothing(parent)) {
        parent.MAP_NIVEL = objSelf.MAP_NOMBRE;
        parent.MAP_SHOWCOMITTEE = 0;
        parent.MAP_COMITTEEFILTER = '';
        parent.MAP_NIVELID = objSelf.CODIGO;
        
        let comitteeContent = await parent.getContents("ComitteeContent");
        if (!isNothing(comitteeContent)) {
            comitteeContent.setMacro("##NIVELID##", parent.MAP_NIVELID);
            ui.refresh("ComitteeContent,MAP_COMITTEE");
        }
    }    
}

function getUserForComitteeOnContext(objSelf) {
    let context = '';
    let parent = objSelf.getParent();
    if (!isNothing(parent)) {
        let collName = parent.getName();
        if (!isNothing(parent.getName()) && parent.getName().indexOf('ComiteZonaAfectada') >= 0) {
            context = 'ComiteZonaAfectada';
        }
    }
}

async function getUserForComittee(objSelf) {
    let parent = objSelf.getParent();
    if (!isNothing(parent)) {
        if (parent.MAP_SHOWTITULAROPTIONS == 1) {
            parent.MAP_IDTITULAR = objSelf.ID;
            parent.MAP_TITULAR = objSelf.MAP_NOMBRE;
            let holdersContent = await parent.getContents("HoldersContent");
            if (!isNothing(holdersContent)) {
                holdersContent.setMacro("##USERCODE##", parent.MAP_IDTITULAR);
                ui.refresh("HoldersContent,MAP_TITULARS");
            }
            changeHoldersVisibility(objSelf, 0);
        } else if (parent.MAP_SHOWSUPLENTEOPTIONS == 1) {
            parent.MAP_IDSUPLENTE = objSelf.ID;
            parent.MAP_SUPLENTE = objSelf.MAP_NOMBRE;
            let substitutesContent = await parent.getContents("SubstitutesContent");
            if (!isNothing(substitutesContent)) {
                substitutesContent.setMacro("##USERCODE##", parent.MAP_IDSUPLENTE);
                ui.refresh("SubstitutesContent,MAP_SUPLENTES");
            }
            changeSubstitutesVisibility(objSelf, 0);
        }
         
    }    
}

async function getTypeForSituation(objSelf) {
    let parent = objSelf.getParent();
    if (!isNothing(parent)) {
        if (parent.MAP_SHOWTYPES == 1) {
            parent.MAP_TIPOCODE = objSelf.CODIGO;
            parent.MAP_CODIGOTIPO = objSelf.MAP_NOMBRE;
            let typesContent = await parent.getContents("TypesContent");
            if (!isNothing(typesContent)) {
                typesContent.setMacro("##TYPECODE##", parent.MAP_TIPOCODE);
                ui.refresh("TypesContent,MAP_TIPOS");
            }
            changeTypesVisibility(objSelf, 0);
        }
    }    
}

function getRegionForSituation(objSelf) {
    let parent = objSelf.getParent();
    if (!isNothing(parent)) {
        parent.MAP_REGIONCODE = objSelf.CODIGO;
    }    
}

async function getStateForSituation(objSelf) {
    let parent = objSelf.getParent();
    if (!isNothing(parent)) {
        if (parent.MAP_SHOWSTATES == 1) {
            parent.MAP_ESTADOCODE = objSelf.CODIGO;
            parent.MAP_ESTADO = objSelf.MAP_NOMBRE;
            let typesContent = await parent.getContents("StatesContent");
            if (!isNothing(typesContent)) {
                typesContent.setMacro("##STATECODE##", parent.MAP_ESTADOCODE);
                ui.refresh("StatesContent,MAP_ESTADOS,MAP_ESTADO");
            }
            changeStatesVisibility(objSelf, 0);
        }
    }    
}

function selectTitular(objSelf) {
    if (objSelf.MAP_IDUSUARIO == objSelf.MAP_IDSUPLENTE) {
        objSelf.MAP_SUPLENTEBCOLOR = "#00000000";
    }
    objSelf.MAP_IDUSUARIO = objSelf.MAP_IDTITULAR;
    objSelf.MAP_TITULARBCOLOR = "#59CD00";
}

function selectSuplente(objSelf) {
    if (objSelf.MAP_IDUSUARIO == objSelf.MAP_IDTITULAR) {
        objSelf.MAP_TITULARBCOLOR = "#00000000";
    }
    objSelf.MAP_IDUSUARIO = objSelf.MAP_IDSUPLENTE;
    objSelf.MAP_SUPLENTEBCOLOR = "#59CD00";
}

async function editAvaibilityInSituation (objSelf) {
    let disponibilityObj = await (await appData.getCollection('CrearDisponibilidad')).createObject();
    disponibilityObj.MAP_SITUACIONCODIGO = objSelf.MAP_CODIGO;
    disponibilityObj.MAP_SITUACION = objSelf.MAP_NOMBRE;
    disponibilityObj.MAP_FECHAINICIO = objSelf.MAP_FECHAINICIO;
    disponibilityObj.MAP_FECHAFIN = objSelf.MAP_FECHAFINESTIMADA;
    disponibilityObj.MAP_REGION = objSelf.MAP_CODIGOREGION;
    
    disponibilityObj.MAP_SHOWSITUATIONS = 0;
    disponibilityObj.MAP_SITUATIONFILTER = '';
    
    let situationsContent = await disponibilityObj.getContents("SituationsContent");
    if (!isNothing(situationsContent)) {
        situationsContent.setMacro("##IDUSUARIO##", user.ID);
        situationsContent.setMacro("##MACRO##", "gc.ID IS NOT NULL");
        situationsContent.setMacro("##SITUACIONCODIGO##", disponibilityObj.MAP_SITUACIONCODIGO);
            
        let committeeContent = await disponibilityObj.getContents("ComitteeContent");
        if (!isNothing(committeeContent)) {
            committeeContent.setMacro("##MACRO##", "gc.ID IS NOT NULL AND gs.CODIGO='" + disponibilityObj.MAP_SITUACIONCODIGO + "'");
            committeeContent.setMacro("##IDUSUARIO##", user.ID);
            await committeeContent.loadAll();
                
            let comitteeContentCount = committeeContent.count();
                
            if (comitteeContentCount == 1) {
                let committeeObj = await committeeContent.getItem(0);
                disponibilityObj.MAP_IDTITULAR = committeeObj.TITULARID;
                disponibilityObj.MAP_TITULAR = committeeObj.MAP_TITULAR;
                disponibilityObj.MAP_IDSUPLENTE = committeeObj.SUPLENTEID;
                disponibilityObj.MAP_SUPLENTE = committeeObj.MAP_SUPLENTE;
                disponibilityObj.MAP_NIVEL = committeeObj.MAP_NOMBRE;
                disponibilityObj.MAP_SHOWCOMITTEE = 0;
                disponibilityObj.MAP_COMITTEEFILTER = '';
                disponibilityObj.MAP_NIVELID = committeeObj.COMITEID;
                disponibilityObj.MAP_AVAIBILITY = committeeObj.DISPONIBILIDAD;
                let titularidad = committeeObj.MAP_TITULARIDAD;
                let avaibility = (disponibilityObj.MAP_AVAIBILITY == 'Disponible') ? 'Available' : (disponibilityObj.MAP_AVAIBILITY == 'No Disponible') ? 'NotAvailable' : 'Desconocido';
                    
                if (avaibility != 'Desconocido') {
                    changeAvaibilityStateBG(disponibilityObj, avaibility);
                }
            
                committeeContent.setMacro("##NIVELID##", disponibilityObj.MAP_NIVELID);
                //ui.refresh("ComitteeContent,MAP_COMITTEE");
                    
                disponibilityObj.MAP_IDUSUARIO = user.ID;
                if (disponibilityObj.MAP_IDUSUARIO ==  disponibilityObj.MAP_IDTITULAR) {
                    disponibilityObj.MAP_TITULARBCOLOR = '#59CD00';
                } else {
                    disponibilityObj.MAP_SUPLENTEBCOLOR = '#59CD00';
                }
            }
        }
    }
    
    appData.pushValue(disponibilityObj);
}

async function updateUnitsOrgAfterZoneSelection(objSelf) {
    
    try {
        ui.showWaitDialog("Cargando datos...");
        let parent = objSelf.getParent();
        if (!isNothing(parent)) {
            let sectorObj;
            let stCodigoZona=objSelf.CODIGOZONA;
            let iIsSelected=objSelf.ISSELECTED;
    
            let sectorContent = await parent.getContents('SDataContent');
            sectorContent.unlock();
            let sectorContentCount = sectorContent.count();
            for (let i = 0; i < sectorContentCount; i++) {
                sectorObj = await sectorContent.getItem(i);
                if (sectorObj.CODIGOZONA==stCodigoZona) {
                    if (sectorObj.ISSELECTED!=iIsSelected) {
                        sectorObj.ISSELECTED=iIsSelected;
                    }
                    if (sectorObj.ISSELECTED==1) {
                        sectorObj.MAP_BGCOLOR_SEL='#FFFFFF';
                        sectorObj.MAP_FORECOLOR_SEL='#2C2C2C';
                    } else {
                        sectorObj.MAP_BGCOLOR_SEL='#EEEEEE';
                        sectorObj.MAP_FORECOLOR_SEL='#888888';
                    }
                }
            }
            sectorContent.lock();
            parent.MAP_BANDERASECTOR=0;
        }
        ui.hideWaitDialog();
    } catch(e) {
        ui.hideWaitDialog();
    }
}

async function marcarZonasSeleccionadoSector(objSelf) {
    
    try {
        ui.showWaitDialog("Cargando datos...");
        //CODIGOZONA
        let parent = objSelf.getParent();
        if (!isNothing(parent)) {
            let zonaObj,sectorObj;
            let zonasel=[];
            let stCodigoZona=objSelf.CODIGOZONA;
            let iIsSelected=objSelf.ISSELECTED;
            
            //Primero ver en los sectores, quien esta marcado de las zonas
            let sectorContent = await parent.getContents('SDataContent');
            sectorContent.unlock();
            let sectorContentCount = sectorContent.count();
            for (let i = 0; i < sectorContentCount; i++) {
                sectorObj = await sectorContent.getItem(i);
                if (sectorObj.ISSELECTED==1) {
                    zonasel.push(sectorObj.CODIGOZONA);
                }
            }
            
            //En las zonas marcadas, primero se ponen a no seleccionada y luego se 
            //seleccionan las que sea 
            let zonas = await parent.getContents('ZDataContent');
            zonas.unlock();
            let zonaContentCount = zonas.getCount();
            for (let i = 0; i < zonaContentCount; i++) {
                zonaObj = await zonas.getItem(i);
                zonaObj.MAP_BANDERA=1;
                zonaObj.ISSELECTED=0;
                zonaObj.MAP_BGCOLOR_SEL='#EEEEEE';
                zonaObj.MAP_FORECOLOR_SEL='#888888';
                if (zonasel.indexOf(zonaObj.CODIGOZONA)!=-1) {
                    zonaObj.ISSELECTED=1;
                    zonaObj.MAP_BGCOLOR_SEL='#FFFFFF';
                    zonaObj.MAP_FORECOLOR_SEL='#2C2C2C';
                }
                zonaObj.MAP_BANDERA=0;
            }
            zonas.lock();
        }
        ui.hideWaitDialog();
    } catch(e) {
        ui.hideWaitDialog();
    }
}

async function updateUnitsOrgAfterZoneSelectionOLD(objSelf) {
    let parent = objSelf.getParent();
    if (!isNothing(parent) && parent.MAP_LOADINGDATA == 0) {
        let zonesFilter = "";
        let zonesContent = await parent.getContents('ZDataContent');
        zonesContent.unlock();
        let zonesContentCount = zonesContent.count();
        let zoneObj;
        for (let i = 1; i < zonesContentCount; i++) {
            zoneObj = await zonesContent.getItem(i);
            if (zoneObj.MAP_ISSELECTED == 1) {
                if (zonesFilter.length == 0) {
                    zonesFilter = "(" + zoneObj.ID;
                } else {
                    zonesFilter += "," + zoneObj.ID;
                }
            }
        }
        if (zonesFilter.length > 0) {
            zonesFilter += ")";      
        }
        zonesContent.lock();
        
        let sectorContent = await parent.getContents('SDataContent');
        sectorContent.unlock();
        let sectorsMacro = "(o.BAJA IS NULL OR o.BAJA = 0) AND o.TIPOUNIDADORG in ('SECTOR')";
        let cceRegionID = (isIBDServer() == false) ? getDevEnvSetts().cceRegionid : getProdEnvSetts().cceRegionid;
        if (parent.MAP_IDREGION != cceRegionID) {
            sectorsMacro = "z.CODIGOREGION = '" + parent.MAP_IDREGION + "' AND " + sectorsMacro;
        }
        if (zonesFilter.length > 0) {
            sectorsMacro += " AND o.IDZONA IN " + zonesFilter;
        }
        sectorContent.setMacro("##MACRO##", sectorsMacro);
        sectorContent.clear();
        await sectorContent.loadAll();
        sectorContent.lock();
        
        ui.refresh("SDataContent,MAP_SDATACONTENT");
    }
}

async function updateZonesOrgAfterRegionSelection(objSelf) {
    let parent = objSelf.getParent();
    if (!isNothing(parent) && parent.MAP_LOADINGDATA == 0) {
        let regionsFilter = "";
        let regionsContent = await parent.getContents('RDataContent');
        regionsContent.unlock();
        let regionsContentCount = regionsContent.count();
        let regionObj;
        for (let i = 1; i < regionsContentCount; i++) {
            regionObj = await regionsContent.getItem(i);
            if (regionObj.MAP_ISSELECTED == 1) {
                if (regionsFilter.length == 0) {
                    regionsFilter = "(" + regionObj.ID;
                } else {
                    regionsFilter += "," + regionObj.ID;
                }
            }
        }
        if (regionsFilter.length > 0) {
            regionsFilter += ")";
        }
        regionsContent.lock();
        
        let zonesContent = await parent.getContents('ZDataContent');
        zonesContent.unlock();
        let zonesMacro = "(z.BAJA IS NULL OR z.BAJA = 0) AND z.TIPOZONA in ('ZONA')";
        if (regionsFilter.length > 0) {
            zonesMacro += " AND z.CODIGOREGION IN " + regionsFilter;
        }
        zonesContent.setMacro("##MACRO##", zonesMacro);
        zonesContent.clear();
        await zonesContent.loadAll();
        zonesContent.lock();
        
        ui.refresh("ZDataContent,MAP_ZDATACONTENT");
    }
}

async function validateSituationData(objSelf, functionToColl) {
    // debugger;
    let response;
    if (!objSelf.MAP_NOMBRE.length>0){
        response=await userMsgBox("Por favor, incluye un nombre para la situacion.", "AVISO",0,"#e04c41");        
        return false;
    }
    if (!objSelf.MAP_CODIGOTIPO.length>0){
        response=await userMsgBox("Por favor, seleccióne un tipo de situación.", "AVISO",0,"#e04c41");        
        return false;
    }
    if (!objSelf.MAP_CODIGOREGION.length>0){
        response=await userMsgBox("Por favor, seleccione la región afectada.", "AVISO", 0,"#e04c41");
        return false;
    }
    if (isNothingDate(objSelf.MAP_FECHAINICIO)){
        response=await userMsgBox("Por favor, indique fecha y hora de inicio previsto", "AVISO",0,"#e04c41");        
        return false;
    }

    if (isNothingDate(objSelf.MAP_FECHAFINESTIMADA)){
        response=await userMsgBox("Por favor, indique fecha y hora de finalizacion prevista",  "AVISO",0,"#e04c41");        
        return false;
    }

    let menor=vbSupport.dateDiffSign("h",objSelf.MAP_FECHAFINESTIMADA,objSelf.MAP_FECHAINICIO);
    if (menor<0){
        response=await userMsgBox("Por favor, la fecha y hora de finalizacion estimada debe ser superior a la de inicio.","AVISO",0,"#e04c41");     
        return false;
    }
    
    
    let sectorContent = await objSelf.getContents('SDataContent');
    let sectorsSelected = 0;
    
    for (let i = 0; i < sectorContent.count(); i++) {
        if ((await sectorContent.getItem(i)).ISSELECTED == 1) {
            sectorsSelected +=1;
        }
    }
    
    if (sectorsSelected == 0) {
        response=await userMsgBox("Por favor, seleccione los sectores afectados","AVISO",0,"#e04c41");
        return false;
    }
    
    // debugger;
    
    switch(functionToColl) {
        case 'addNewRecord':
            await addNewRecord(objSelf, "s.CODIGO ='" + objSelf.MAP_CODIGO + "'", "SituacionExtraordinaria", true);
            break;
        case 'addNewRecordAndClose':
            await addNewRecordAndClose(objSelf, "s.CODIGO ='" + objSelf.MAP_CODIGO + "'", "SituacionExtraordinaria", true);
            break;
    }
}

async function askForDisponibility(objSelf, situationsCount, userID) {
    let situationsForDispoColl = await appData.getCollection('SituacionActiva');
    situationsForDispoColl.setMacro("##IDUSUARIO##", userID);
    situationsForDispoColl.setMacro("##MACRO##", "gc.ID IS NOT NULL AND (gs2.ID IS NULL OR gs2.DISPONIBILIDAD IS NULL OR gs2.DISPONIBILIDAD NOT IN ('Disponible', 'No Disponible'))");
    await situationsForDispoColl.loadAll();
    let disponibilityObj = await (await appData.getCollection('CrearDisponibilidad')).createObject();
    
    let situationsContent = await disponibilityObj.getContents("SituationsContent");
    if (!isNothing(situationsContent)) {
        situationsContent.setMacro("##IDUSUARIO##", userID);
        situationsContent.setMacro("##MACRO##", "gc.ID IS NOT NULL AND (gs2.ID IS NULL OR gs2.DISPONIBILIDAD IS NULL OR gs2.DISPONIBILIDAD NOT IN ('Disponible', 'No Disponible'))");
        //ui.refresh("SituationsContent,MAP_SITUATIONS");
    }
    if (situationsCount == 1) {
        let situationForDispoObj = await situationsForDispoColl.getItem(0);
        if (!isNothing(situationForDispoObj)) {
            disponibilityObj.MAP_SITUACIONCODIGO = situationForDispoObj.CODIGO;
            disponibilityObj.MAP_SITUACION = situationForDispoObj.MAP_NOMBRE;
            disponibilityObj.MAP_FECHAINICIO = situationForDispoObj.FECHAINICIO;
            disponibilityObj.MAP_FECHAFIN = situationForDispoObj.FECHAFINESTIMADA;
            disponibilityObj.MAP_REGION = situationForDispoObj.MAP_REGNOMBRE;
            disponibilityObj.MAP_SHOWSITUATIONS = 0;
            disponibilityObj.MAP_SITUATIONFILTER = '';
        
            situationsContent.setMacro("##SITUACIONCODIGO##", disponibilityObj.MAP_SITUACIONCODIGO);
            
            let committeeContent = await disponibilityObj.getContents("ComitteeContent");
            if (!isNothing(committeeContent)) {
                committeeContent.setMacro("##MACRO##", "gc.ID IS NOT NULL AND (gs2.ID IS NULL OR gs2.DISPONIBILIDAD IS NULL OR gs2.DISPONIBILIDAD NOT IN ('Disponible', 'No Disponible')) AND gs.CODIGO='" + disponibilityObj.MAP_SITUACIONCODIGO + "'");
                committeeContent.setMacro("##IDUSUARIO##", userID);
                await committeeContent.loadAll();
                
                let comitteeContentCount = committeeContent.count();
                
                if (comitteeContentCount == 1) {
                    let committeeObj = await committeeContent.getItem(0);
                    disponibilityObj.MAP_IDTITULAR = committeeObj.TITULARID;
                    disponibilityObj.MAP_TITULAR = committeeObj.MAP_TITULAR;
                    disponibilityObj.MAP_IDSUPLENTE = committeeObj.SUPLENTEID;
                    disponibilityObj.MAP_SUPLENTE = committeeObj.MAP_SUPLENTE;
                    disponibilityObj.MAP_NIVEL = committeeObj.MAP_NOMBRE;
                    disponibilityObj.MAP_SHOWCOMITTEE = 0;
                    disponibilityObj.MAP_COMITTEEFILTER = '';
                    disponibilityObj.MAP_NIVELID = committeeObj.COMITEID;
            
                    committeeContent.setMacro("##NIVELID##", disponibilityObj.MAP_NIVELID);
                    //ui.refresh("ComitteeContent,MAP_COMITTEE");
                    
                    disponibilityObj.MAP_IDUSUARIO = user.ID;
                    if (disponibilityObj.MAP_IDUSUARIO ==  disponibilityObj.MAP_IDTITULAR) {
                        disponibilityObj.MAP_TITULARBCOLOR = '#59CD00';
                    } else {
                        disponibilityObj.MAP_SUPLENTEBCOLOR = '#59CD00';
                    }
                }
            }
        }
    }
    
    appData.pushValue(disponibilityObj);
}

async function editDisponibility(objSelf, userID) {
    let situationsForDispoColl = await appData.getCollection('SituacionActiva');
    situationsForDispoColl.setMacro("##IDUSUARIO##", userID);
    situationsForDispoColl.setMacro("##MACRO##", "gc.ID IS NOT NULL");
    await situationsForDispoColl.loadAll();
    let situationsCount = situationsForDispoColl.count();
    
    let disponibilityObj = await (await appData.getCollection('CrearDisponibilidad')).createObject();
    
    let situationsContent = await disponibilityObj.getContents("SituationsContent");
    if (!isNothing(situationsContent)) {
        situationsContent.setMacro("##IDUSUARIO##", userID);
        situationsContent.setMacro("##MACRO##", "gc.ID IS NOT NULL");
        //ui.refresh("SituationsContent,MAP_SITUATIONS");
    }
    if (situationsCount == 1) {
        let situationForDispoObj = await situationsForDispoColl.getItem(0);
        if (!isNothing(situationForDispoObj)) {
            disponibilityObj.MAP_SITUACIONCODIGO = situationForDispoObj.CODIGO;
            disponibilityObj.MAP_SITUACION = situationForDispoObj.MAP_NOMBRE;
            disponibilityObj.MAP_FECHAINICIO = situationForDispoObj.FECHAINICIO;
            disponibilityObj.MAP_FECHAFIN = situationForDispoObj.FECHAFINESTIMADA;
            disponibilityObj.MAP_REGION = situationForDispoObj.MAP_REGNOMBRE;
            disponibilityObj.MAP_SHOWSITUATIONS = 0;
            disponibilityObj.MAP_SITUATIONFILTER = '';
        
            situationsContent.setMacro("##SITUACIONCODIGO##", disponibilityObj.MAP_SITUACIONCODIGO);
            
            let committeeContent = await disponibilityObj.getContents("ComitteeContent");
            if (!isNothing(committeeContent)) {
                committeeContent.setMacro("##MACRO##", "gc.ID IS NOT NULL AND gs.CODIGO='" + disponibilityObj.MAP_SITUACIONCODIGO + "'");
                committeeContent.setMacro("##IDUSUARIO##", userID);
                await committeeContent.loadAll();
                
                let comitteeContentCount = committeeContent.count();
                
                if (comitteeContentCount == 1) {
                    let committeeObj = await committeeContent.getItem(0);
                    disponibilityObj.MAP_IDTITULAR = committeeObj.TITULARID;
                    disponibilityObj.MAP_TITULAR = committeeObj.MAP_TITULAR;
                    disponibilityObj.MAP_IDSUPLENTE = committeeObj.SUPLENTEID;
                    disponibilityObj.MAP_SUPLENTE = committeeObj.MAP_SUPLENTE;
                    disponibilityObj.MAP_NIVEL = committeeObj.MAP_NOMBRE;
                    disponibilityObj.MAP_SHOWCOMITTEE = 0;
                    disponibilityObj.MAP_COMITTEEFILTER = '';
                    disponibilityObj.MAP_NIVELID = committeeObj.COMITEID;
                    disponibilityObj.MAP_AVAIBILITY = committeeObj.DISPONIBILIDAD;
                    let titularidad = committeeObj.MAP_TITULARIDAD;
                    let avaibility = (disponibilityObj.MAP_AVAIBILITY == 'Disponible') ? 'Available' : (disponibilityObj.MAP_AVAIBILITY == 'No Disponible') ? 'NotAvailable' : 'Desconocido';
                    
                    if (avaibility != 'Desconocido') {
                        changeAvaibilityStateBG(disponibilityObj, avaibility);
                    }
            
                    committeeContent.setMacro("##NIVELID##", disponibilityObj.MAP_NIVELID);
                    //ui.refresh("ComitteeContent,MAP_COMITTEE");
                    
                    disponibilityObj.MAP_IDUSUARIO = user.ID;
                    if (disponibilityObj.MAP_IDUSUARIO ==  disponibilityObj.MAP_IDTITULAR) {
                        disponibilityObj.MAP_TITULARBCOLOR = '#59CD00';
                    } else {
                        disponibilityObj.MAP_SUPLENTEBCOLOR = '#59CD00';
                    }
                }
            }
        }
    }
    
    appData.pushValue(disponibilityObj);
}

// - bAll: para ver si queremos que revise solo las que no ha contestado, false, o todas, true
// - stMove: para movernos anterior, Previous, o siguiente, Next
async function checkIfUserHasToIndicateDisponibility(objSelf,bAll) {
    try{
        ui.showWaitDialog("Verificando disponibilidad");
        // usamos ComiteRelacionadoEditScript, que es como ComiteRelacionadoEdit pero con los campos que necesitamos
        //let collDisponibilidad = appData.getCollection("ComiteRelacionadoEditScript");
        let response;
        let collDisponibilidad = await objSelf.getContents("ComiteRelacionadoEditScript");
        collDisponibilidad.unlock();
        let idUsuario=user.ID;
        // solo buscamos las disponibilidades a las que no ha contestado
        let stMacro="(st.BAJA=0 AND st.ESTADO!='0020' AND ((ca.DISP_SUPLENTE=0 AND ca.IDSUPLENTE="+idUsuario+") OR (ca.DISP_TITULAR=0 AND ca.IDTITULAR="+idUsuario+")))";
        collDisponibilidad.setMacro("##MACRO##", stMacro);
        await collDisponibilidad.loadAll();
        collDisponibilidad.lock();
        let countDisponibilidad = collDisponibilidad.getCount();
        if (bAll && countDisponibilidad===0){
        // mejora... la disponibilidad le saca las que no ha reportado, pero si es 0, que le pregunte si quiere 
        // ver todas las que ha informado
            response=await userMsgBox("No hay disponiblidad pendiente de notificar. \n\n ¿Desea revisar las ya informadas?", "INFORMACION", 3,"#5ea43f");
          	if(response != 1){
          	    return;
            }        
        }        
        if (bAll){
            // SI VIENE ALL, que el usuario pueda consultar todas sus disponibilidades
            stMacro="(st.BAJA=0 AND st.ESTADO!='0020' AND (ca.IDSUPLENTE="+idUsuario+" OR ca.IDTITULAR="+idUsuario+"))";
            collDisponibilidad.unlock();
            collDisponibilidad.clear();
            collDisponibilidad.setMacro("##MACRO##", stMacro);
            await collDisponibilidad.loadAll();
            collDisponibilidad.lock();
            countDisponibilidad = collDisponibilidad.getCount();            
        }

        if (countDisponibilidad>0){
            //notifyDisponibility(collDisponibilidad.getItem(0),false);
            await goToColl(objSelf, 'DisponibilidadListado',0);
        }else{
            // si no hay datos, y solo en el caso de true (ver todas) mostramos msg.
            // es decir, solo cuando pulsa en el boton Disponibilidad
            if (bAll){
                response=await userMsgBox("El usuario no tiene ninguna disponibilidad que notificar", "INFORMACION",0,"#5ea43f");
            }
        }

        ui.hideWaitDialog();
    }catch (e) {
        let sterror=e.message;
        writelogExceptionJSv2(" checkIfUserHasToIndicateDisponibility. ERROR: "+sterror,"organization_structure.js",false);   
        ui.hideWaitDialog();
    }   
}

async function notifyDisponibility(objDisponibilidad,bExit,bViewPrev,bViewNext) {
    try{
            let collCrearDisponibility = await appData.getCollection('CrearDisponibilidad');
            let objCrearDisponibility  = await collCrearDisponibility.createObject();
            // objCrearDisponibility.MAP_EDIT=countDisponibilidad>1?1:0;
            objCrearDisponibility.MAP_EDIT=0;
            // marcamos bandera de disponibilidad a 0, para controlar en el salvado...1 disponible, 2 no disponible
            objCrearDisponibility.MAP_IDCOMITEAFECTADO=objDisponibilidad.ID;
            objCrearDisponibility.MAP_SITUACION=objDisponibilidad.MAP_NOMBRESITUACION;
            objCrearDisponibility.MAP_NIVEL=objDisponibilidad.MAP_CARGO;
            objCrearDisponibility.MAP_NIVELSUP=objDisponibilidad.MAP_CARGOSUP;
            objCrearDisponibility.MAP_NIVELSUPSUP=objDisponibilidad.MAP_CARGOSUPSUP;
            objCrearDisponibility.MAP_FECHAS=objDisponibilidad.MAP_FECHAS;
            objCrearDisponibility.MAP_REGION=objDisponibilidad.MAP_REGION;
            objCrearDisponibility.MAP_TITULAR=objDisponibilidad.MAP_TITULAR;
            objCrearDisponibility.MAP_SUPLENTE=objDisponibilidad.MAP_SUPLENTE;
            objCrearDisponibility.MAP_OBJCOMITERELACIONADOEDIT=objDisponibilidad;
            if (objDisponibilidad.IDTITULAR==user.ID){
                objCrearDisponibility.MAP_IDTITULAR=objDisponibilidad.IDTITULAR;
                objCrearDisponibility.MAP_DISPONIBLEINICIAL=objDisponibilidad.DISP_TITULAR;
            }else if (objDisponibilidad.IDSUPLENTE==user.ID){
                objCrearDisponibility.MAP_IDSUPLENTE=objDisponibilidad.IDSUPLENTE;
                objCrearDisponibility.MAP_DISPONIBLEINICIAL=objDisponibilidad.DISP_SUPLENTE;
            }
            //if (objCrearDisponibility.MAP_DISPONIBLEINICIAL>0)
            changeAvaibilityStateBG(objCrearDisponibility,objCrearDisponibility.MAP_DISPONIBLEINICIAL);
            // dejamos indicado en esta variable si el usuario es titular o suplete.. nos va a sobrar despues...
            //objDisponibilityObj.MAP_TITULAROSUPLENTE=collDisponibilidad.getItem(0).IDTITULAR==user.ID?"T":"S";
            if (!bExit)
                ui.openEditView(objCrearDisponibility);
            else
                appData.pushValueAndExit(objCrearDisponibility);
        
    }catch (e) {
        let sterror=e.message;
        // writelogExceptionJSv2(" notifyDisponibility. ERROR: "+sterror,"organization_structure.js",false);   

    } 
          
}

async function saveContacto(objSelf, closeAfterSave) { 
    try {
        let response;
        if (objSelf.MAP_NOMBRE.length === 0) {
            response=await userMsgBox("Por favor, indique un nombre para el contacto.", "AVISO",0,"#e04c41");
            // response = ui.msgBox("Por favor, indique un nombre para el contacto.", "AVISO", 0);
            return;
        }
        if ((objSelf.MAP_TELEFONO.length === 0) && (objSelf.MAP_EMAIL.length === 0)) {
            response=await userMsgBox("Por favor, indique su teléfono o email para el contacto.", "AVISO",0,"#e04c41");
            // response = ui.msgBox("Por favor, indique su teléfono o email para el contacto.", "AVISO", 0);
            return;
        }
        if (objSelf.MAP_EMAIL.length > 0 && !isValidEmail(objSelf.MAP_EMAIL)) {
            response=await userMsgBox("Por favor, indique un email válido para el contacto.", "AVISO",0,"#e04c41");
            // response = ui.msgBox("Por favor, indique un email válido para el contacto.", "AVISO", 0);
            return;
        }
        if (objSelf.MAP_CONTACTOGLOBAL === 0 && objSelf.MAP_REGION.length === 0){
            response=await userMsgBox("Por favor, indique el ámbito al que se asocia el contacto.", "AVISO",0,"#e04c41");
            // response = ui.msgBox("Por favor, indique el ámbito al que se asocia el contacto.", "AVISO", 0);
            return;
        } 
        
        let existFilterCondition = (objSelf.MAP_RECORDSTATE == 'EDIT') ? "c.ID=" + objSelf.ID : "";
        
        if (closeAfterSave) {
            await addNewRecordAndClose(objSelf, existFilterCondition, "Contacto", true);
        } else {
            await addNewRecord(objSelf, existFilterCondition, "Contacto", true);
        }
    } catch (e) {
        let sterror = e.message;
        // writelogExceptionJSv2(" saveContacto. ERROR: "+sterror, "organization_structure.js", false);   
    } 
}let appData ,ui ,self ,selfDataColl ,user; const _logString = Array(1000).join(" "), _mF = new Map();

export const __SCRIPT_WRAPPERASYNC = async (AppData,Ui,Self,SelfDataColl,User,Func,Arguments) => {
  appData=AppData; ui=Ui; self=Self; selfDataColl=SelfDataColl; user=User;
	if (typeof Func === "function") return await Func.call(this,Arguments);
	let f = _mF.get(Func);
	if(!f) _mF.set(Func, (f = ((async () => {}).constructor)('appData, ui, self, selfDataColl, user,saveContacto,notifyDisponibility,checkIfUserHasToIndicateDisponibility,editDisponibility,askForDisponibility,validateSituationData,updateZonesOrgAfterRegionSelection,updateUnitsOrgAfterZoneSelectionOLD,marcarZonasSeleccionadoSector,updateUnitsOrgAfterZoneSelection,editAvaibilityInSituation,selectSuplente,selectTitular,getStateForSituation,getRegionForSituation,getTypeForSituation,getUserForComittee,getUserForComitteeOnContext,getAssociatedComittee,loadSituationData,loadUsersForSelectedComittee,addNewUnitToSituationAndClose,addNewZoneToSituationAndClose,addNewUnitToSituation,addNewZoneToSituation,deleteReasonFrom,addReasonTo,saveReasonsTo,addReasonsTo,applyFilterFor,getfilterSentenceFor,applyFilterForReasons,applyFilterForZoneContent,applyFilterForContent,getFilterConditions,removeSelectedUnitsTo,removeSelectedZonesTo,addSelectedUnitsTo,addSelectedZonesTo,updateSelectedRowsCount,deleteData,selectOrUnselectAll,sortData,getSortConditionFor,updateData,openEditViewFor,openEditViewOfExtraSituationFrom,changeAvaibilityStateBG,changeTypesVisibility,changeStatesVisibility,changeRegionsVisibility,changeSubstitutesVisibility,changeHoldersVisibility,changeComitteesVisibility,changeVisibilityForReasons,showFormToAddAffectedUnitTo,showFormToAddAffectedZoneTo,loadComitteeDataIfPossible,getRecord,askForDeleteUserFromComittee,selectUnitForExtraSituation,addUserToComittee,deleteFilters,applyFilters,saveContactRecord,saveComiteRelacionadoRecord,createNewComiteRelacionadoRecord,createNewContactRecord,saveAvaibilityForSituation,createNewAvaibilityForSituation,createNewFileForSituation,saveMessageForSituation,createNewMessageForSituation,saveAffectedUnit,createNewAffectedUnit,saveAffectedZone,createNewAffectedZone,saveAffectedRegion,createNewAffectedRegion,saveAffectedUnitRecord,createNewAffectedUnitRecord,saveStateRecord,createNewStateRecord,saveSituationRecord,createNewSituationRecord,getActiveStateCode,isStartDateOnThePast,addDefaultAffectedAreasTo,saveAffectedAreasTo,addAffectedAreasTo,createRelatedCommittee,createNewAffectedCommitteeRecord,saveOrgUnitRecord,createNewOrgUnitRecord,saveReasonRecord,createNewReasonRecord,saveUnitRecord,createNewUnitRecord,saveZoneRecord,createNewZoneRecord,saveRegionRecord,createNewRegionRecord,saveComitteeRecord,createNewComitteeRecord,saveUserRecord,createNewUserRecord,saveLevelRecord,createNewLevelRecord,deleteRecord,addNewRecordAndClose,addNewRecord,AbrirMenuMensajes,getAttendeesForSituationOLD,getAttendeesForSituationFromEmails,isBloqueado,onchangesituacionTeamMeet,CargarCorreos,CargarCargos,SeleccionarCargoTeamMeet,SeleccionarCorreoTeamMeet,selecteditemNivelessituacionTeamMeet,isValidEmail,getAttendeesForSituation,createTeamsMeetDeepLinkForSituation,createTeamsMeetDeepLinkForSituationFromEmails,eliminarDato,saveTrazaDisponibilidad,saveCrearDisponibilidad,changeAvaibilityStateBT,fBeforeEditDisponibilidadListado,CrearTeamsMeet,PrepararMenuCrearTeamMeet,AbrirMenuTeamsMeet,onEditorAction,updateZonasSectoresComiteCCE,asignarDatosCCE,activarCCE,createNewSituationCCE,gruposSituacion,cargarDatosSituaciones,refrescarPantallaPrincipal,salvarUbicacionSituacion,onchangeMAP_CODIGOREGION,loadSelectedSituaciones,selectSituacion,unSelectSituacion,doSetText,sendMailTo,copyMapFieldToField,copyObjectToVariables,copyVariablesToObject,copyJsonToVariables,copyJsonToXone,copyObject,addString,writelogExceptionJSv2,crearRegistroAcceso,onLoginWithLDAPFailed,afterSessionExpired,doLogin,isUserWithAccess,getTypeDevice,trazaSeguridadLogin,showMessage,getValueFromObjColl,seleccionarPrimerElemento,createComiteListado,controlBotonesNewSituacionExtraordinaria,editNewSituacionExtraordinaria,beforeEditSectorSituacionExtra,showTelefono,saveTelefonoUser,afterEditInicio,pickReasonIconToUpload,pickFileToUploadFromMain,pickFileToUploadRepositorio,pickFileToUpload,CreateGuid,addHours,addZero,getControl,changeOnField,getTodayDateInText,getMonthsName,expandOrCollapseMenu,noop,logout,loadMenuPadre,goToColl,selectedItemHijo,selectedItemPadre,loadMenuHijo,comprobarMenu,paginado,loadData,setMenusData,onBackOptionDisponibilidadListado,userMsgBox,safeCompareInt,safeToInt,replaceAll,escapeRegularExpression,safeToDate,safeToString,isDate,isEmptyString,isString,isNumber,isIntegerNumber,isFloatNumber,getClassName,isSomething,isNothingDate,isNothing,cambiarAtributoProp,VBScriptSupport,setDefaultMapProps,drawArea,addGeoJson,cargarDatosMapa,cargarDatosMapa_ANTERIOR,saveImportedData,importDataFromFile,validateImportedData,getSearchConditionFor,compareDataFrom,validateDataIn,getFilterConditionsFor,exportDataToFile,getProdEnvSetts,getDevEnvSetts,getLDAPControl,isIBDServer,isProd,onBackOption,oneditoractionnext,XArguments', Func)));
	if (_mF.size>1000) _mF.delete(_mF.entries().next().value[0]);
	console.log(f); console.log(`%c${_logString}`,"background:blue;display:block;font-size:1px");
	await f(appData, ui, self, selfDataColl, user,saveContacto,notifyDisponibility,checkIfUserHasToIndicateDisponibility,editDisponibility,askForDisponibility,validateSituationData,updateZonesOrgAfterRegionSelection,updateUnitsOrgAfterZoneSelectionOLD,marcarZonasSeleccionadoSector,updateUnitsOrgAfterZoneSelection,editAvaibilityInSituation,selectSuplente,selectTitular,getStateForSituation,getRegionForSituation,getTypeForSituation,getUserForComittee,getUserForComitteeOnContext,getAssociatedComittee,loadSituationData,loadUsersForSelectedComittee,addNewUnitToSituationAndClose,addNewZoneToSituationAndClose,addNewUnitToSituation,addNewZoneToSituation,deleteReasonFrom,addReasonTo,saveReasonsTo,addReasonsTo,applyFilterFor,getfilterSentenceFor,applyFilterForReasons,applyFilterForZoneContent,applyFilterForContent,getFilterConditions,removeSelectedUnitsTo,removeSelectedZonesTo,addSelectedUnitsTo,addSelectedZonesTo,updateSelectedRowsCount,deleteData,selectOrUnselectAll,sortData,getSortConditionFor,updateData,openEditViewFor,openEditViewOfExtraSituationFrom,changeAvaibilityStateBG,changeTypesVisibility,changeStatesVisibility,changeRegionsVisibility,changeSubstitutesVisibility,changeHoldersVisibility,changeComitteesVisibility,changeVisibilityForReasons,showFormToAddAffectedUnitTo,showFormToAddAffectedZoneTo,loadComitteeDataIfPossible,getRecord,askForDeleteUserFromComittee,selectUnitForExtraSituation,addUserToComittee,deleteFilters,applyFilters,saveContactRecord,saveComiteRelacionadoRecord,createNewComiteRelacionadoRecord,createNewContactRecord,saveAvaibilityForSituation,createNewAvaibilityForSituation,createNewFileForSituation,saveMessageForSituation,createNewMessageForSituation,saveAffectedUnit,createNewAffectedUnit,saveAffectedZone,createNewAffectedZone,saveAffectedRegion,createNewAffectedRegion,saveAffectedUnitRecord,createNewAffectedUnitRecord,saveStateRecord,createNewStateRecord,saveSituationRecord,createNewSituationRecord,getActiveStateCode,isStartDateOnThePast,addDefaultAffectedAreasTo,saveAffectedAreasTo,addAffectedAreasTo,createRelatedCommittee,createNewAffectedCommitteeRecord,saveOrgUnitRecord,createNewOrgUnitRecord,saveReasonRecord,createNewReasonRecord,saveUnitRecord,createNewUnitRecord,saveZoneRecord,createNewZoneRecord,saveRegionRecord,createNewRegionRecord,saveComitteeRecord,createNewComitteeRecord,saveUserRecord,createNewUserRecord,saveLevelRecord,createNewLevelRecord,deleteRecord,addNewRecordAndClose,addNewRecord,AbrirMenuMensajes,getAttendeesForSituationOLD,getAttendeesForSituationFromEmails,isBloqueado,onchangesituacionTeamMeet,CargarCorreos,CargarCargos,SeleccionarCargoTeamMeet,SeleccionarCorreoTeamMeet,selecteditemNivelessituacionTeamMeet,isValidEmail,getAttendeesForSituation,createTeamsMeetDeepLinkForSituation,createTeamsMeetDeepLinkForSituationFromEmails,eliminarDato,saveTrazaDisponibilidad,saveCrearDisponibilidad,changeAvaibilityStateBT,fBeforeEditDisponibilidadListado,CrearTeamsMeet,PrepararMenuCrearTeamMeet,AbrirMenuTeamsMeet,onEditorAction,updateZonasSectoresComiteCCE,asignarDatosCCE,activarCCE,createNewSituationCCE,gruposSituacion,cargarDatosSituaciones,refrescarPantallaPrincipal,salvarUbicacionSituacion,onchangeMAP_CODIGOREGION,loadSelectedSituaciones,selectSituacion,unSelectSituacion,doSetText,sendMailTo,copyMapFieldToField,copyObjectToVariables,copyVariablesToObject,copyJsonToVariables,copyJsonToXone,copyObject,addString,writelogExceptionJSv2,crearRegistroAcceso,onLoginWithLDAPFailed,afterSessionExpired,doLogin,isUserWithAccess,getTypeDevice,trazaSeguridadLogin,showMessage,getValueFromObjColl,seleccionarPrimerElemento,createComiteListado,controlBotonesNewSituacionExtraordinaria,editNewSituacionExtraordinaria,beforeEditSectorSituacionExtra,showTelefono,saveTelefonoUser,afterEditInicio,pickReasonIconToUpload,pickFileToUploadFromMain,pickFileToUploadRepositorio,pickFileToUpload,CreateGuid,addHours,addZero,getControl,changeOnField,getTodayDateInText,getMonthsName,expandOrCollapseMenu,noop,logout,loadMenuPadre,goToColl,selectedItemHijo,selectedItemPadre,loadMenuHijo,comprobarMenu,paginado,loadData,setMenusData,onBackOptionDisponibilidadListado,userMsgBox,safeCompareInt,safeToInt,replaceAll,escapeRegularExpression,safeToDate,safeToString,isDate,isEmptyString,isString,isNumber,isIntegerNumber,isFloatNumber,getClassName,isSomething,isNothingDate,isNothing,cambiarAtributoProp,VBScriptSupport,setDefaultMapProps,drawArea,addGeoJson,cargarDatosMapa,cargarDatosMapa_ANTERIOR,saveImportedData,importDataFromFile,validateImportedData,getSearchConditionFor,compareDataFrom,validateDataIn,getFilterConditionsFor,exportDataToFile,getProdEnvSetts,getDevEnvSetts,getLDAPControl,isIBDServer,isProd,onBackOption,oneditoractionnext,Arguments);
};